import axios from 'axios'
import { host } from '../../configuraciones'
import { v4 as uuidv4 } from 'uuid';
import {createAsyncThunk,createSlice} from '@reduxjs/toolkit'
import moment from 'moment'

var fechaHoy = moment().format('YYYY-MM-DD');
var fechaResta = moment().subtract(18, "y");
var fechaAño = moment().subtract("y");
var fechaParaMayorEdad = fechaResta.format('YYYY-MM-DD')
//constantes
const dataInicial = {
    data: {},
    fc_01: {
        actualizacioninformacion: false,
        asociado: false,
        calle: "",
        certificadonomcomercializador: false,
        certificadonomenvasador: false,
        certificadonomproductor: false,
        codigopostal: "",
        colonia: "",
        comercializadorbebidasconmezcal: false,
        comercializadormezcal: false,
        constanciacomercializador: false,
        correoelectronicorepresentante: "",
        dictameninstalaciones: false,
        dictameninstalacionesbodega: false,
        dictameninstalacionesenvasadora: false,
        dictameninstalacionesfabrica: false,
        discapacidadno: false,
        discapacidadsi: false,
        envasador: false,
        escolaridad: "",
        estado: "",
        estadocivil: "",
        fechadenacimiento: '',
        fechasolicitud: fechaHoy,
        inscrito: false,
        lenguaindijenano: false,
        lenguaindijenasi: false,
        localidad: "",
        municipioalcaldia: "",
        noasociado: false,
        nombrerazonsocial: "",
        numeroexterior: "",
        numerohijos: "",
        numerointerior: "",
        ocupacion: "",
        personafisica: false,
        personamoral: false,
        productormaguey: false,
        productormezcal: false,
        representantelegal: "",
        rfc: "",
        sexo: "",
        telefonorepresentante: "",
        tipodiscapacidad: "",
        tipolengua: "",
        viverista: false,
        personaautorizadasi: false, 
        personaautorizadano: false, 
        representantelegalsi: false, 
        representantelegalno: false,
        numerosocio: "",
        telefono: "",
        correoelectronico: "",
        terminosYCondiciones: false,
        certificacionsi: false, 
        certificacionno: false, 
        empresacertificadora: "",
        numerohombres: '', 
        numeromujeres: '', 
        numerodiscapacitados: '', 
        numerobase: '', 
        numeroeventuales: '',
        opcionTipoInscripcion: '',
        opcionTipoInscrito:'',
        opcionTipoEmpresa: '',
        otracalle: '',
        comprobantepago: undefined,
        comprobantepagotext: '',
        valores:{
        }
    },
    anexoUnidadAlmacen: [],
    anexoUnidadProduccion: [],
    anexoUnidadEnvasado: [],
    marcas: [],
    marcasProductosConMezcal: [],
    personasAutorizadas: [],
    mediosDeContacto: [],
    predios:[],
    productor:[],
    seccionesProduccion:[],
    dataSeccionesProduccion:[],
    loading: false,
    fc_01Map: {},
    marcasMap: [],
    representantesLegales: [],
    representantesLegalesMap: [],
    personasAutorizadasMap: [],
    predioMap: [],
    productorMap: [],
    anexoMarcaDeMezcalMap: [],
    anexoMarcaConProductoMap: [],
    validacionInstalacion: false,
    anexoUnidadMap: [],
    anexoResponsableMap: [],

    // anexoUnidadProduccionMap: [],
    // anexoUnidadEnvasadoMap: [],
    

    paginaActiva: 1,
    modoEdicionBorrador: false,
    modoCorreccion: false,
    seccionesAlmacen: [],
    dataSeccionesAlmacen: [],
    seccionesEnvasado: [], 
    actividadesEmpresa: {},
    borrador:[],
    archivos: [],
    files : [],
    domicilioFiscal: {},
    numeroDeUnidades: 0,
    instalaciones: [],
    contadorDeFechaFolio:0,
    filesApoderadosLeg: [],
    filesPersonasAut: [],
    filesMarcas: [],
    filesMarcasProduct: [],
    filesInstalaciones: [],
    opcionesFilesInstalaciones: [],
    filesPredios : [],
    opcionesFilesPredios : [],
    filesViveros : [],
    opcionesFilesViveros: [],
    filesResponsables: [],
    fc_01Map: {},
    personasAutorizadasMap: [],
    marcasMap: [],
    documentacionFC_01Map: [],
    documentacionRepresentanteLegalMap: [],
    documentacionPersonaAutorizadaMap: [],
    documentacionPredioMap: [],
    documentacionViveroMap: [],
    documentacionMarcaMap: [],
    documentacionMarcaProductoMap: [],
    documentacionInstalacionMap: [],
    documentacionResponsableMap: [],
    observacionesApartados: {},
    estadosDenominacionOrigen: [
        'Oaxaca',
        'Guerrero',
        'San Luis Potosí',
        'Zacatecas',
        'Durango'
    ],
    estadosDenominacion: [
        'Tamaulipas',
        'Guanajuato',
        'Michoacán de Ocampo',
        'Puebla',
    ],
    municipiosTamaulipas: [
        'San Carlos',
        'San Nicolás',
        'Burgos',
        'Miquihuana',
        'Bustamante',
        'Palmillas',
        'Jaumave',
        'Tula',
        'Cruillas',
        'Jiménez',
        'Méndez'
    ],
    municipiosGuanajuato: [
        'San Felipe',
        'San Luis de la Paz',
    ],
    municipiosMichoacan: [
        'Acuitzio',
        'Aguililla',
        'Ario',
        'Buenavista',
        'Charo',
        'Chinicuila',
        'Coalcomán de Vázquez Pallares',
        'Cotija',
        'Cojumatlán de Régules',
        'Erongarícuaro',
        'La Huacana',
        'Tacámbaro',
        'Turicato',
        'Tzitzio',
        'Hidalgo',
        'Salvador Escalante',
        'Morelia',
        'Madero',
        'Queréndaro',
        'Indaparapeo',
        'Tarímbaro',
        'Tancítaro',
        'Los Reyes',
        'Tepalcatepec',
        'Sahuayo',
        'Marcos Castellanos',
        'Jiquilpan',
        'Venustiano Carranza',
        'Vista Hermosa',
    ],
    municipiosPuebla: [
        'Acajete',
        'Acatlán de Osorio',
        'Acatzingo',
        'Acteopan',
        'Ahuatlán',
        'Ahuehuetitla',
        'Ajalpan',
        'Albino Zertuche',
        'Altepexi',
        'Amozoc',
        'Aquixtla',
        'Atexcal',
        'Atlixco',
        'Atoyatempan',
        'Atzala',
        'Axutla',
        'Caltepec',
        'Coatzingo',
        'Cohetzala',
        'Cohuecán',
        'Coxcatlán',
        'Coyomeapan',
        'Coyotepec',
        'Cuapiaxtla de Madero',
        'Cuautinchan',
        'Cuayuca de Andrade',
        'Cuyoaco',
        'Chapulco',
        'Chiautla',
        'Chietla',
        'Chigmecatitlan',
        'Chignahuapan',
        'Chila',
        'Chila de la Sal',
        'Chinantla',
        'Eloxochitlán',
        'Epatlán',
        'General Felipe Ángeles',
        'Guadalupe',
        'Huatlatlauca',
        'Huehuetlán el Chico',
        'Huehuetlán el Grande',
        'Huitziltepec',
        'Ixcamilpa de Guerrero',
        'Ixcaquixtla',
        'Ixtacamaxtitlán',
        'Izucar de Matamoros',
        'Jolalpan',
        'Juan N. Méndez',
        'La Magdalena Tlatlauquitepec',
        'Libres',
        'Los Reyes de Juárez',
        'Mixtla',
        'Molcaxac',
        'Nicolás Bravo',
        'Nopalucan',
        'Ocotepec',
        'Oriental',
        'Palmar de Bravo',
        'Petlalcingo',
        'Piaxtla',
        'Quecholac',
        'Rafael Lara Grajales',
        'San Antonio Cañada',
        'San Diego la Mesa Tochimiltzingo',
        'San Gabriel Chilac',
        'San Jerónimo Xayacatlán',
        'San José Chiapa',
        'San José Miahuatlán',
        'San Juan Atzompa',
        'San Martín Totoltepec',
        'San Miguel Ixitlán',
        'San Pablo Anicano',
        'San Pedro Yeloixtlahuaca',
        'San Salvador Huixcolotla',
        'San Sebastián Tlacotepec',
        'Santa Catarina Tlaltempan',
        'Santa Inés Ahuatempan',
        'Santiago Miahuatlán',
        'Santo Tomás Hueyotlipan',
        'Tecali de Herrera',
        'Tecamachalco',
        'Tecomatlán',
        'Tehuacán',
        'Tehuitzingo',
        'Teopantlán',
        'Teotlalco',
        'Tepanco de López',
        'Tepatlaxco de Hidalgo',
        'Tepeaca',
        'Tepemaxalco',
        'Tepeojuma',
        'Tepexco',
        'Tepexi de Rodríguez',
        'Tepeyahualco',
        'Tepeyahualco de Cuauhtémoc',
        'Tilapa',
        'Tlacotepec de Benito Juárez',
        'Tlanepantla',
        'Tlapanalá',
        'Tochimilco',
        'Tochtepec',
        'Totoltepec de Guerrero',
        'Tulcingo',
        'Tzicatlacoyan',
        'Vicente Guerrero',
        'Xayacatlán de Bravo',
        'Xicotlan',
        'Xochitlán Todos Santos',
        'Yehualtepec',
        'Zacapala',
        'Zapotitlán Salinas',
        'Zautla',
        'Zinacatepec',
        'Zoquitlán',
        'Xochiltepec',
    ],
}

//types
const AGREGAR_FC_01_EXITO = 'AGREGAR_FC_01_EXITO'
const AGREGAR_FC_01_BORRADOR_EXITO = 'AGREGAR_FC_01_BORRADOR_EXITO'
const GUARDAR_CAMBIOS_FC_01_BORRADOR_EXITO = 'GUARDAR_CAMBIOS_FC_01_BORRADOR_EXITO'
const ENVIAR_CORRECCIONES_FC_01_EXITO = 'ENVIAR_CORRECCIONES_FC_01_EXITO'
const ACTUALIZAR_FC_01_ESTATUS_EXITO = 'ACTUALIZAR_FC_01_ESTATUS_EXITO'
const OBTENER_FC_01_MAP_EXITO = 'OBTENER_FC_01_MAP_EXITO'
const OBTENER_FC_01_ANEXOUNIDADALMACEN_MAP_EXITO = 'OBTENER_FC_01_ANEXOUNIDADALMACEN_MAP_EXITO'
const OBTENER_FC_01_ANEXOUNIDADENVASADO_MAP_EXITO = 'OBTENER_FC_01_ANEXOUNIDADENVASADO_MAP_EXITO'
const OBTENER_FC_01_ANEXOUNIDADPRODUCCION_MAP_EXITO = 'OBTENER_FC_01_ANEXOUNIDADPRODUCCION_MAP_EXITO'
const OBTENER_FC_01_SECCIONESUNIDADALMACEN_EXITO = 'OBTENER_FC_01_SECCIONESUNIDADALMACEN_EXITO'
const OBTENER_FC_01_SECCIONESUNIDADENVASADO_EXITO = 'OBTENER_FC_01_SECCIONESUNIDADENVASADO_EXITO'
const OBTENER_FC_01_DETALLE_EXITO = 'OBTENER_FC_01_DETALLE_EXITO'
const OBTENER_FC_01_DETALLE_CON_FILES_EXITO = 'OBTENER_FC_01_DETALLE_CON_FILES_EXITO'
const ELIMINAR_FC_01_SOLICITUD_EXITO_BD = 'ELIMINAR_FC_01_SOLICITUD_EXITO_BD'
const ELIMINAR_FC_01_ANEXOUNIDADALMACEN_EXITO_BD = 'ELIMINAR_FC_01_ANEXOUNIDADALMACEN_EXITO_BD'
const ELIMINAR_FC_01_ANEXOUNIDADENVASADO_EXITO_BD = 'ELIMINAR_FC_01_ANEXOUNIDADENVASADO_EXITO_BD'
const ELIMINAR_FC_01_ANEXOUNIDADPRODUCCION_EXITO_BD = 'ELIMINAR_FC_01_ANEXOUNIDADPRODUCCION_EXITO_BD'
const ELIMINAR_FC_01_ANEXOMARCAS_EXITO_BD = 'ELIMINAR_FC_01_ANEXOMARCAS_EXITO_BD'
const ELIMINAR_DATAELEMENTO_EXITO_BD = 'ELIMINAR_DATAELEMENTO_EXITO_BD'
const ELIMINAR_RESPONSABLE_EXITO_BD = 'ELIMINAR_RESPONSABLE_EXITO_BD'
const ELIMINAR_FC_01_ANEXOPERSONASAUT_EXITO_BD = 'ELIMINAR_FC_01_ANEXOPERSONASAUT_EXITO_BD'
const ELIMINAR_FC_01_ANEXOREPRESENTANTELEGAL_EXITO_BD = 'ELIMINAR_FC_01_ANEXOREPRESENTANTELEGAL_EXITO_BD'
const ELIMINAR_FC_01_ANEXOS = 'ELIMINAR_FC_01_ANEXOS'
const ELIMINAR_FC_01_ANEXOMEDIODECONTACTO_EXITO_BD = 'ELIMINAR_FC_01_ANEXOMEDIODECONTACTO_EXITO_BD'
const ELIMINAR_FC_01_ANEXOPREDIO_EXITO_BD = 'ELIMINAR_FC_01_ANEXOPREDIO_EXITO_BD'
const OBTENER_FC_01_SECCIONES_EXITO_BD ='OBTENER_FC_01_SECCIONES_EXITO_BD'
const ELIMINAR_FC_01_ANEXOPRODUCTOR_EXITO_BD = 'ELIMINAR_FC_01_ANEXOPRODUCTOR_EXITO_BD'
const OBTENER_FC_01_BORRADORES_EXITO = 'OBTENER_FC_01_BORRADORES_EXITO'
const ELIMINAR_FC_01_INSTALACION_EXITO_BD = 'ELIMINAR_FC_01_INSTALACION_EXITO_BD'
const OBTENER_FC_01_CONTADOR_FECHA_FOLIO_EXITO = 'OBTENER_FC_01_CONTADOR_FECHA_FOLIO_EXITO'
const OBTENER_FILES_FC_01_EXITO = 'OBTENER_FILES_FC_01_EXITO'
const ENVIAR_BORRADOR_EXITO = 'ENVIAR_BORRADOR_EXITO'
const OBTENER_FC_01_ANEXOUNIDAD_MAP_EXITO = 'OBTENER_FC_01_ANEXOUNIDAD_MAP_EXITO'
const GENERAR_SOLICITUD_PDF_EXITO = 'GENERAR_SOLICITUD_PDF_EXITO'
const OBTENER_NUMERO_SOLICITUDES_FC_01_EXITO = 'OBTENER_NUMERO_SOLICITUDES_FC_01_EXITO'
const AGREGAR_ARCHIVO_FC_01_EXITO = 'AGREGAR_ARCHIVO_FC_01_EXITO'
const ACTUALIZAR_ARCHIVO_FC_01_EXITO = 'ACTUALIZAR_ARCHIVO_FC_01_EXITO'
const ELIMINAR_ARCHIVO_FC_01_EXITO = 'ELIMINAR_ARCHIVO_FC_01_EXITO'
const AGREGAR_FC_01_FECHA_EXITO = 'AGREGAR_FC_01_FECHA_EXITO'
const ACTUALIZAR_INSTALACIONES_EXITO = 'ACTUALIZAR_INSTALACIONES_EXITO'

export const enviarCorreccionesFC_01 = createAsyncThunk(
    ENVIAR_CORRECCIONES_FC_01_EXITO,
    async(data) => {
        try {
            const solicitud = { data: data.solicitud }
            const anexoAlmacen = { data: data.anexoUnidadAlmacen }
            const anexoProduccion = { data: data.anexoUnidadProduccion }
            const anexoEnvasado = { data: data.anexoUnidadEnvasado }
            const anexoMarcas = { data: data.marcas }
            const anexoPersonasAut = { data: data.personasAutorizadas }
            const anexoRepresentantesLegales = { data: data.representantesLegales }
    
            const anexoMediosDeContacto = { data: data.mediosDeContacto }
            const anexoPredios = { data: data.predios }
            const anexoProductor = {data: data.productor}
            const anexoMarcasProductoConMezcal = {data: data.marcasProductoConMezcal}

            const anexoInstalaciones = {data: data.anexoInstalaciones}
            const actualizarFC_01 = host + 'FC_01/actualizarSolicitudFC_01'
            const urlAnexosUnidadProduccion = host + 'FC_01/agregarNuevoFC_01AnexoUnidadDeProduccion'
            const urlActualizarAnexosUnidadProduccion = host + 'FC_01/actualizarAnexoUnidadDeProduccionFC_01'
    
            const urlAnexosUnidadAlmacen = host + 'FC_01/agregarNuevoFC_01AnexoUnidadAlmacen'
            const urlActualizarAnexosUnidadAlmacen = host + 'FC_01/actualizarAnexoUnidadDeAlmacenFC_01'
    
            const urlAnexosUnidadEnvasado = host + 'FC_01/agregarNuevoFC_01AnexoUnidadDeEnvasado'
            const urlActualizarAnexosUnidadEnvasado = host + 'FC_01/actualizarAnexoUnidadDeEnvasadoFC_01'
    
            const urlAnexosMarcas = host + 'FC_01/agregarNuevoFC_01AnexoMarcas'
            const urlActualizarAnexosMarcas = host + 'FC_01/actualizarAnexoMarcaDeSolicitudFC_01'
    
            const urlAnexoPersonasAutorizadas = host + 'FC_01/agregarNuevoFC_01AnexoPersonaAutorizadaTramites'
            const urlActualizarAnexoPersonasAutorizadas = host + 'FC_01/actualizarAnexoPersonaAutorizadaTramitesFC_01'

            const urlAnexoRepresentantesLegales = host + 'FC_01/agregarNuevoFC_01AnexoPersonaAutorizada'
            const urlActualizarAnexoRepresentanteLegal = host + 'FC_01/actualizarAnexoRepresentateLegalFC_01'
            const urlAnexoMediosDeContacto = host + 'FC_01/agregarNuevoFC_01AnexoMediosDeContacto'
            const urlActualizarAnexoMediosDeContacto = host + 'FC_01/actualizarAnexoMediosDeContactoFC_01'
    
            const urlAnexoPredios = host + 'FC_01/agregarNuevoFC_01AnexoVivero'
            const urlActualizarAnexoPredios = host + 'FC_01/actualizarAnexoViveroFC_01'

            const urlAnexoProductor = host + 'FC_01/agregarNuevoFC_01AnexoProductor'
            const urlActualizarAnexoProductor = host + 'FC_01/actualizarAnexoProductorFC_01'
            const urlAnexosMarcasProductosConMezcal = host + 'FC_01/agregarNuevoFC_01marcaProductorConMezcal'
            const urlActualizarAnexosMarcasProductosConMezcal = host + 'FC_01/actualizarAnexoMarcaProductorConMezcalFC_01'

            const urlAnexo = host + 'FC_01/agregarNuevoAnexo'
            const urlActualizarAnexo = host + 'FC_01/actualizarAnexo'
            const urlInformacionGeneral = host + 'FC_01/agregarNuevaInformacionGeneral'
            const urlActualizarInformacionGeneral = host + 'FC_01/actualizarInformacionGeneral'
            const urlInstalacion = host + 'FC_01/agregarNuevaInstalacion'
            const urlActualizarInstalacion = host + 'FC_01/actualizarInstalacion'
            const urlDataElemento = host + 'FC_01/agregarNuevaDataElemento'
            const urlActualizarDataElemento = host + 'FC_01/actualizarDataElelemento'
            
            const urlResponsable = host + 'FC_01/agregarNuevoResponsable'
            const urlActualizarResponsable = host + 'FC_01/actualizarResponsable'

            const filesGenerales = data.files
            const filesApoderadosLeg = data.filesApoderadosLeg
            const filesPersonasAut = data.filesPersonasAut
            const filesViveros = data.filesViveros
            const filesPredios = data.filesPredios
            const filesMarcas = data.filesMarcas
            const filesMarcasProduct = data.filesMarcasProduct
            const filesInstalaciones = data.filesInstalaciones

            // for (const i in filesGenerales) {
            //     if(filesGenerales[i].file.type){
            //         filesGenerales[i].idAnexoFK = solicitud.data.idfc01_solicitudregistro
            //         if(filesGenerales[i].idAnexo !== undefined) {
            //             await actualizarFile(filesGenerales[i], 'FC_01/actualizarFileFC_01')
            //         }else {
            //             await agregarFile(filesGenerales[i], 'FC_01/agregarAnexosArchivosFC_01')
            //         }
            //     }
            // }
            // for (const i in filesApoderadosLeg) {
            //     if(filesApoderadosLeg[i].file.type  && filesApoderadosLeg[i].idAnexoFK !== undefined){
            //         await actualizarFile(filesApoderadosLeg[i], 'FC_01/actualizarArchivoAnexosRepresentanteLegal')
            //     }
            // }

            // for (const i in filesPersonasAut) {
            //     if(filesPersonasAut[i].file.type  && filesPersonasAut[i].idAnexoFK !== undefined){
            //         await actualizarFile(filesPersonasAut[i], 'FC_01/actualizarAnexosPersonaAutorizada')
            //     }
            // }

            // for (const i in filesPredios) {
            //     if(filesPredios[i].file.type  && filesPredios[i].idAnexoFK !== undefined){
            //         await actualizarFile(filesPredios[i], 'FC_01/actualizarArchivosPredio')
            //     }
            // }
            // for (const i in filesViveros) {
            //     if(filesViveros[i].file.type  && filesViveros[i].idAnexoFK !== undefined){
            //         await actualizarFile(filesViveros[i], 'FC_01/actualizarArchivoAnexosViveros')
            //     }
            // }

            // for (const i in filesMarcas) {
            //     if(filesMarcas[i].file.type && filesMarcas[i].idAnexoFK !== undefined){
            //         await actualizarFile(filesMarcas[i], 'FC_01/actualizarAnexoDeMarca')
            //     }
            // }

            // for (const i in filesMarcasProduct) {
            //     if(filesMarcasProduct[i].file.type  && filesMarcasProduct[i].idAnexoFK !== undefined){
            //         await actualizarFile(filesMarcasProduct[i], 'FC_01/actualizarArchivoAnexoMarcaProducto')
            //     }
            // }

            // for (const i in filesInstalaciones) {
            //     if(filesInstalaciones[i].file.type  && filesInstalaciones[i].idAnexoFK !== undefined){
            //         if((filesInstalaciones[i].id).includes('INSTREP')){
            //             await actualizarFile(filesInstalaciones[i], 'FC_01/actualizarArchivoResponsable')
            //         }else{
            //             await actualizarFile(filesInstalaciones[i], 'FC_01/actualizarArchivoAnexoInstalacion')
            //         }
            //     }
            // }

            
            const res = await axios.put(actualizarFC_01, solicitud)

            for (let i in anexoRepresentantesLegales.data) {
                const {id, estado, fc_01_anexosrepresentantelegal, ...anexoRepLeg} = anexoRepresentantesLegales.data[i]
                let idfeik = id
                anexoRepLeg.idfc01_solicitudregistro = res.data.data.idfc01_solicitudregistro
                if(anexoRepLeg === "") {
                    anexoRepLeg = null
                }
                if(anexoRepLeg.idfc01_solicitudregistro) {
                    await axios.put(urlActualizarAnexoRepresentanteLegal, { data : anexoRepLeg})
                    anexoRepLeg.id = idfeik
                } else {
                    await axios.post(urlAnexoRepresentantesLegales, { data: anexoRepLeg })
                }
                // for (const j in filesApoderadosLeg) {
                //     if(filesApoderadosLeg[j].idAnexoFK === undefined){
                //         if(filesApoderadosLeg[j].idAnexo === id){
                //             filesApoderadosLeg[j].idAnexoFK = anexoRepLeg.idfc01_anexorepresentantelegal
                //             await agregarFile(filesApoderadosLeg[j], 'FC_01/agregarNuevoArchivoAnexosRepresentanteLegal')
                //         }
                //     }
                // }
            }
    
            for (let i in anexoPersonasAut.data) {
                const {id, estado, fc_01_anexospersonaautorizada, ...anexoPersonasSinID} = anexoPersonasAut.data[i]
                let idfeik = id;
                anexoPersonasSinID.idfc01_solicitudregistro = res.data.data.idfc01_solicitudregistro
                if (anexoPersonasSinID === "") {
                    anexoPersonasSinID = null
                }
                if (anexoPersonasSinID.idfc01_anexopersonaatorizadatramites) {
                    await axios.put(urlActualizarAnexoPersonasAutorizadas, { data: anexoPersonasSinID })
                    anexoPersonasSinID.id = idfeik
                } else {
                    await axios.post(urlAnexoPersonasAutorizadas, { data: anexoPersonasSinID })
                }
                // for (const j in filesPersonasAut) {
                //     if(filesPersonasAut[j].idAnexoFK === undefined){
                //         if(filesPersonasAut[j].idAnexo === id){
                //             filesPersonasAut[j].idAnexoFK = anexoPersonasSinID.idfc01_anexopersonaatorizadatramites
                //             await agregarFile(filesPersonasAut[j], 'FC_01/agregarNuevoArchivoAnexosPersonaAutorizada')
                //         }
                //     }
                // }
            }
    
            for (let i in anexoMarcas.data) {
                const {id, fc_01_anexosmarca, ...anexoMarcasSinID} = anexoMarcas.data[i]
                let idfeik = id;
                anexoMarcasSinID.idfc01_solicitudregistro = res.data.data.idfc01_solicitudregistro
                if (anexoMarcasSinID === "") {
                    anexoMarcasSinID = null
                }
                if (anexoMarcasSinID.idfc01_anexomarcas) {
                    await axios.put(urlActualizarAnexosMarcas, { data: anexoMarcasSinID })
                    anexoMarcasSinID.id = idfeik;
                } else {
                    await axios.post(urlAnexosMarcas, { data: anexoMarcasSinID })
                }
                // for (const j in filesMarcas) {
                //     if(filesMarcas[j].idAnexoFK === undefined){
                //         if(filesMarcas[j].idAnexo === id){
                //             filesMarcas[j].idAnexoFK = anexoMarcasSinID.idfc01_anexomarcas
                //             await agregarFile(filesMarcas[j], 'FC_01/agregarNuevoArchivoAnexoDeMarca')
                //         }
                //     }
                // }
            }
            for (let i in anexoMarcasProductoConMezcal.data) {
                const {id, fc_01_archivosmarcasproducto, ...anexoMarcasSinID} = anexoMarcasProductoConMezcal.data[i]
                let idfeik = id;
                anexoMarcasSinID.idfc01_solicitudregistro = res.data.data.idfc01_solicitudregistro
                if (anexoMarcasSinID === "") {
                    anexoMarcasSinID = null
                }
                if (anexoMarcasSinID.idfc01_anexomarcasproductoconmezcal) {
                    await axios.put(urlActualizarAnexosMarcasProductosConMezcal, { data: anexoMarcasSinID })
                    anexoMarcasSinID.id = idfeik;
                } else {
                    await axios.post(urlAnexosMarcasProductosConMezcal, { data: anexoMarcasSinID })
                }
                // for (const j in filesMarcasProduct) {
                //     if(filesMarcasProduct[j].idAnexoFK === undefined){
                //         if(filesMarcasProduct[j].idAnexo === id){
                //             filesMarcasProduct[j].idAnexoFK = anexoMarcasSinID.idfc01_anexomarcasproductoconmezcal
                //             await agregarFile(filesMarcasProduct[j], 'FC_01/agregarNuevoArchivoAnexoMarcaProducto')
                //         }
                //     }
                // }
            }

            for (let i in anexoMediosDeContacto.data) {
                const {id, estado, ...anexoMediosDeContactoSinID} = anexoMediosDeContacto.data[i]
                let idfeik = id;
                anexoMediosDeContactoSinID.idfc01_solicitudregistro = res.data.data.idfc01_solicitudregistro
                if (anexoMediosDeContactoSinID === "") {
                    anexoMediosDeContactoSinID = null
                }
                if (anexoMediosDeContactoSinID.idfc01_anexomediosdecontacto) {
                    await axios.put(urlActualizarAnexoMediosDeContacto, { data: anexoMediosDeContactoSinID })
                    anexoMediosDeContactoSinID.id = idfeik;
                } else {
                    await axios.post(urlAnexoMediosDeContacto, { data: anexoMediosDeContactoSinID })
                }
            }
            for (let i in anexoPredios.data) {
                const {id, fc_01_archivosviveros, ...anexoPrediosSinID} = anexoPredios.data[i]
                let idfeik = id;
                anexoPrediosSinID.idfc01_solicitudregistro = res.data.data.idfc01_solicitudregistro
                if (anexoPrediosSinID === "") {
                    anexoPrediosSinID = null
                }
                if (anexoPrediosSinID.idfc01_anexopredios) {
                    await axios.put(urlActualizarAnexoPredios, { data: anexoPrediosSinID })
                    anexoPrediosSinID.id = idfeik
                } else {
                    await axios.post(urlAnexoPredios, { data: anexoPrediosSinID })
                }
                // for (const j in filesViveros) {
                //     if(filesViveros[j].idAnexoFK === undefined){
                //         if(filesViveros[j].idAnexo === id){
                //             filesViveros[j].idAnexoFK = anexoPrediosSinID.idfc01_anexopredios
                //             await agregarFile(filesViveros[j], 'FC_01/agregarNuevoArchivoAnexosViveros')
                //         }
                //     }
                // }
            }
            for (let i in anexoProductor.data) {
                const {id, fc_01_archivospredios, ...anexoProductorSinID} = anexoProductor.data[i]
                let idfeik = id;
                anexoProductorSinID.idfc01_solicitudregistro = res.data.data.idfc01_solicitudregistro
                if (anexoProductorSinID === "") {
                    anexoProductorSinID = null
                }
                if (anexoProductorSinID.idfc01_anexoproductor) {
                    await axios.put(urlActualizarAnexoProductor, { data: anexoProductorSinID })
                    anexoProductorSinID.id = idfeik
                } else {
                    await axios.post(urlAnexoProductor, { data: anexoProductorSinID })
                }
                // for (const j in filesPredios) {
                //     if(filesPredios[j].idAnexoFK === undefined){
                //         if(filesPredios[j].idAnexo === id){
                //             filesPredios[j].idAnexoFK = anexoProductorSinID.idfc01_anexoproductor
                //             await agregarFile(filesPredios[j], 'FC_01/agregarNuevoFC_01ArchivosPredio')
                //         }
                //     }
                // }
            }
            //Instalaciones
            for(let i in anexoInstalaciones.data){
                const {id, responsables, domicilio, anexo, dataSeccion, opcionesSeleccionadas, tipoInstalacion, ...anexoInstalacionSinID} =  anexoInstalaciones.data[i].data
                for (let x in anexoInstalacionSinID) {
                    if (anexoInstalacionSinID[x] === "") {
                        anexoInstalacionSinID[x] = null
                    }
                }
                if(tipoInstalacion === 'Unidad Producción'){
                    if (anexoInstalacionSinID.idanexo) {
    
                        const {idfc01_solicitudregistro,idanexo, ...unidad} = anexoInstalacionSinID
                        const indormacionGeneralActualizada = await axios.put(urlActualizarInformacionGeneral, { data: unidad })
                        const idInfoGeneral = indormacionGeneralActualizada.data.data.idiformaciongeneral
    
                        for (const responsable of responsables) {
                            if(responsable.idresponsabledeinstalacion){
                                const {id, estado, fc_01_archivosresposansables, ...responsableSinID} = responsable
                                responsableSinID.idiformaciongeneral = idInfoGeneral
                                if(responsableSinID.nombreresponsable !== '') {
                                    const resResponsable = await axios.put(urlActualizarResponsable, { data : responsableSinID })

                                    const idRespon = resResponsable.data.data.idresponsabledeinstalacion
                                    // for (const j in filesInstalaciones) {
                                    //     if(filesInstalaciones[j].idAnexoFK === undefined){
                                    //         if(filesInstalaciones[j].idAnexo === id){
                                    //             filesInstalaciones[j].idAnexoFK = idRespon
                                    //             await agregarFile(filesInstalaciones[j], 'FC_01/agregarNuevoArchivoResponsable')
                                    //         }
                                    //     }
                                    // }
                                }
                            }else{
                                const {id, estado, idiformaciongeneral, idresponsabledeinstalacion, fc_01_archivosresposansables, ...responsableSinID} = responsable
                                responsableSinID.idiformaciongeneral = idInfoGeneral
                                if(responsableSinID.nombreresponsable !== '') await axios.post(urlResponsable, { data : responsableSinID })
                            }
                            
                            
                        }
                        if(dataSeccion?.coccionProduccion){
                            for (const elemento of dataSeccion.coccionProduccion) {
                                if(elemento.iddataelemento){
                                    const {id, opcion, ...dataElemento} = elemento
                                    dataElemento.idanexo = idanexo
                                    if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                    if(opcion !== '') await axios.put(urlActualizarDataElemento, { data: dataElemento })
                                }else{
                                    const {id, opcion, iddataelemento, ...dataElemento} = elemento
                                    dataElemento.idanexo = idanexo
                                    if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                    if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                                }
                                
                            }
                        }
                        if(dataSeccion?.moliendaProduccion){
                            for (const elemento of dataSeccion.moliendaProduccion) {
                                if(elemento.iddataelemento){
                                    const {id, opcion, ...dataElemento} = elemento
                                    dataElemento.idanexo = idanexo
                                    if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                    if(opcion !== '') await axios.put(urlActualizarDataElemento, { data: dataElemento })
                                }else{
                                    const {id, opcion, iddataelemento, ...dataElemento} = elemento
                                    dataElemento.idanexo = idanexo
                                    if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                    if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                                }
                                
                            }
                        }
                        if(dataSeccion?.fermentacionProduccion){
                            for (const elemento of dataSeccion.fermentacionProduccion) {
                                if(elemento.iddataelemento){
                                    const {id, opcion, ...dataElemento} = elemento
                                    dataElemento.idanexo = idanexo
                                    if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                    if(opcion !== '') await axios.put(urlActualizarDataElemento, { data: dataElemento })
                                }else{
                                    const {id, opcion, iddataelemento, ...dataElemento} = elemento
                                    dataElemento.idanexo = idanexo
                                    if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                    if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                                }
                                
                            }
                        }
                        if(dataSeccion?.destilacionProduccion){
                            for (const elemento of dataSeccion.destilacionProduccion) {
                                if(elemento.iddataelemento){
                                    const {id, opcion, ...dataElemento} = elemento
                                    dataElemento.idanexo = idanexo
                                    if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                    if(opcion !== '') await axios.put(urlActualizarDataElemento, { data: dataElemento })
                                }else{
                                    const {id, opcion, iddataelemento, ...dataElemento} = elemento
                                    dataElemento.idanexo = idanexo
                                    if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                    if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                                }
                                
                            }
                        }
    
                    } else {
                        const {idfc01_solicitudregistro, ...unidad} = anexoInstalacionSinID
                    
                        const indormacionGeneralAgregada = await axios.post(urlInformacionGeneral, { data: unidad })
                            const idiformaciongeneral = indormacionGeneralAgregada.data.data.idiformaciongeneral
                            let dataInstalacion = {
                                idiformaciongeneral: idiformaciongeneral,
                                idtipoinstalacion: 1,
                            }
                            await axios.post(urlInstalacion, { data: dataInstalacion})
                            
                            const data = {
                                idfc01_solicitudregistro: res.data.data.idfc01_solicitudregistro,
                                idtipoanexo: 1,
                                idiformaciongeneral: idiformaciongeneral
                            }
                            const anexoAgregado = await axios.post(urlAnexo, { data })
                            const idanexo = anexoAgregado.data.data.idanexo
    
                            for (const responsable of responsables) {
                                const {id, estado, ...responsableSinID} = responsable
                                responsableSinID.idiformaciongeneral = idiformaciongeneral
                                if(responsableSinID.nombreresponsable !== '') await axios.post(urlResponsable, { data : responsableSinID })
                            }
    
                            for (const elemento of dataSeccion.coccionProduccion) {
                                const {id, opcion, capacidad, ...dataElemento} = elemento
                                dataElemento.idanexo = idanexo
                                if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                            }
                            for (const elemento of dataSeccion.moliendaProduccion) {
                                const {id, opcion, capacidad, ...dataElemento} = elemento
                                dataElemento.idanexo = idanexo
                                if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                            }
                            for (const elemento of dataSeccion.fermentacionProduccion) {
                                const {id, opcion, capacidad, ...dataElemento} = elemento
                                dataElemento.idanexo = idanexo
                                if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                            }
                            for (const elemento of dataSeccion.destilacionProduccion) {
                                const {id, opcion, capacidad, ...dataElemento} = elemento
                                dataElemento.idanexo = idanexo
                                if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                            }
                    }
                }
                if(tipoInstalacion === 'Unidad Envasado'){
                    if (anexoInstalacionSinID.idanexo) {
                        
                        const {idfc01_solicitudregistro,idanexo, ...unidad} = anexoInstalacionSinID
                        const indormacionGeneralActualizada = await axios.put(urlActualizarInformacionGeneral, { data: unidad })
                        const idInfoGeneral = indormacionGeneralActualizada.data.data.idiformaciongeneral
    
                        for (const responsable of responsables) {
                            if(responsable.idresponsabledeinstalacion){
                                const {id, estado, fc_01_archivosresposansables, ...responsableSinID} = responsable
                                responsableSinID.idiformaciongeneral = idInfoGeneral
                                if(responsableSinID.nombreresponsable !== '') {
                                    const resResponsable = await axios.put(urlActualizarResponsable, { data : responsableSinID })
                                    const idRespon = resResponsable.data.data.idresponsabledeinstalacion
                                    // for (const j in filesInstalaciones) {
                                    //     if(filesInstalaciones[j].idAnexoFK === undefined){
                                    //         if(filesInstalaciones[j].idAnexo === id){
                                    //             filesInstalaciones[j].idAnexoFK = idRespon
                                    //             await agregarFile(filesInstalaciones[j], 'FC_01/agregarNuevoArchivoResponsable')
                                    //         }
                                    //     }
                                    // }
                                }
                            }else{
                                const {id, estado, idiformaciongeneral, idresponsabledeinstalacion, fc_01_archivosresposansables, ...responsableSinID} = responsable
                                responsableSinID.idiformaciongeneral = idInfoGeneral
                                if(responsableSinID.nombreresponsable !== '') await axios.post(urlResponsable, { data : responsableSinID })
                            }
                            
                        }
    
                        if(dataSeccion?.seccion1){
                            for (const elemento of dataSeccion.seccion1) {
                                if(elemento.iddataelemento){
                                    const {id, opcion, ...dataElemento} = elemento
                                    dataElemento.idanexo = idanexo
                                    if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                    if(opcion !== '') await axios.put(urlActualizarDataElemento, { data: dataElemento })
                                }else{
                                    const {id, opcion, iddataelemento, ...dataElemento} = elemento
                                    dataElemento.idanexo = idanexo
                                    if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                    if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                                }
                                
                            }
                        }
                        if(dataSeccion?.seccion2){
                            for (const elemento of dataSeccion.seccion2) {
                                if(elemento.iddataelemento){
                                    const {id, opcion, ...dataElemento} = elemento
                                    dataElemento.idanexo = idanexo
                                    if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                    if(opcion !== '') await axios.put(urlActualizarDataElemento, { data: dataElemento })
                                }else{
                                    const {id, opcion, iddataelemento, ...dataElemento} = elemento
                                    dataElemento.idanexo = idanexo
                                    if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                    if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                                }
                                
                            }
                        }
                        if(dataSeccion?.seccion3){
                            for (const elemento of dataSeccion.seccion3) {
                                if(elemento.iddataelemento){
                                    const {id, opcion, ...dataElemento} = elemento
                                    dataElemento.idanexo = idanexo
                                    if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                    if(opcion !== '') await axios.put(urlActualizarDataElemento, { data: dataElemento })
                                }else{
                                    const {id, opcion, iddataelemento, ...dataElemento} = elemento
                                    dataElemento.idanexo = idanexo
                                    if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                    if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                                }
                                
                            }
                        }
                        if(dataSeccion?.seccion4){
                            for (const elemento of dataSeccion.seccion4) {
                                if(elemento.iddataelemento){
                                    const {id, opcion, ...dataElemento} = elemento
                                    dataElemento.idanexo = idanexo
                                    if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                    if(opcion !== '') await axios.put(urlActualizarDataElemento, { data: dataElemento })
                                }else{
                                    const {id, opcion, iddataelemento, ...dataElemento} = elemento
                                    dataElemento.idanexo = idanexo
                                    if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                    if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                                }
                                
                            }
                        }
                        if(dataSeccion?.seccion5){
                            for (const elemento of dataSeccion.seccion5) {
                                if(elemento.iddataelemento){
                                    const {id, opcion, ...dataElemento} = elemento
                                    dataElemento.idanexo = idanexo
                                    if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                    if(opcion !== '') await axios.put(urlActualizarDataElemento, { data: dataElemento })
                                }else{
                                    const {id, opcion, iddataelemento, ...dataElemento} = elemento
                                    dataElemento.idanexo = idanexo
                                    if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                    if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                                }
                                
                            }
                        }
    
                    } else {
                        const {idfc01_solicitudregistro, ...unidad} = anexoInstalacionSinID
                    
                        const indormacionGeneralAgregada = await axios.post(urlInformacionGeneral, { data: unidad })
                        const idiformaciongeneral = indormacionGeneralAgregada.data.data.idiformaciongeneral
                        let dataInstalacion = {
                            idiformaciongeneral: idiformaciongeneral,
                            idtipoinstalacion: 2,
                        }
                        await axios.post(urlInstalacion, { data: dataInstalacion})
                        
                        const data = {
                            idfc01_solicitudregistro: res.data.data.idfc01_solicitudregistro,
                            idtipoanexo: 2,
                            idiformaciongeneral: idiformaciongeneral
                        }
                        const anexoAgregado = await axios.post(urlAnexo, { data })
                        const idanexo = anexoAgregado.data.data.idanexo
                        
                        for (const responsable of responsables) {
                            const {id, estado, ...responsableSinID} = responsable
                            responsableSinID.idiformaciongeneral = idiformaciongeneral
                            if(responsableSinID.nombreresponsable !== '') await axios.post(urlResponsable, { data : responsableSinID })
                        }
    
                        for (const elemento of dataSeccion.seccion1) {
                            const {id, opcion, capacidad, ...dataElemento} = elemento
                            dataElemento.idanexo = idanexo
                            if(dataElemento.cantidad === '') dataElemento.cantidad = null
                            if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                        }
                        for (const elemento of dataSeccion.seccion2) {
                            const {id, opcion, capacidad, ...dataElemento} = elemento
                            dataElemento.idanexo = idanexo
                            if(dataElemento.cantidad === '') dataElemento.cantidad = null
                            if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                        }
                        for (const elemento of dataSeccion.seccion3) {
                            const {id, opcion, capacidad, ...dataElemento} = elemento
                            dataElemento.idanexo = idanexo
                            if(dataElemento.cantidad === '') dataElemento.cantidad = null
                            if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                        }
                        for (const elemento of dataSeccion.seccion4) {
                            const {id, opcion, capacidad, ...dataElemento} = elemento
                            dataElemento.idanexo = idanexo
                            if(dataElemento.cantidad === '') dataElemento.cantidad = null
                            if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                        }
                        for (const elemento of dataSeccion.seccion5) {
                            const {id, opcion, capacidad, ...dataElemento} = elemento
                            dataElemento.idanexo = idanexo
                            if(dataElemento.cantidad === '') dataElemento.cantidad = null
                            if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                        }
                    }
                }
                if(tipoInstalacion === 'Unidad Almacén'){
                    if (anexoInstalacionSinID.idanexo) {
                        
                        const {tipoinstalacionanejamiento, tipoinstalacionbodega, tipoinstalaciongranel, tipoinstalacionmaduracion, tipoinstalacionreposado, idfc01_solicitudregistro, idanexo, ...unidad} = anexoInstalacionSinID
                    
                        const indormacionGeneralActualizada = await axios.put(urlActualizarInformacionGeneral, { data: unidad })
                        const idiformaciongeneral = indormacionGeneralActualizada.data.data.idiformaciongeneral
                        const idInfoGeneral = indormacionGeneralActualizada.data.data.idiformaciongeneral
                        const urlEliminarInstalaciones = host + `FC_01/eliminarInstalaciones/${idiformaciongeneral}`
                        await axios.delete(urlEliminarInstalaciones)
                        if(tipoinstalacionbodega) {
                            const data = {
                                idiformaciongeneral: idiformaciongeneral,
                                idtipoinstalacion: 3,
                            }
                            await axios.post(urlInstalacion, { data })
                        }
                        if(tipoinstalaciongranel) {
                            const data = {
                                idiformaciongeneral: idiformaciongeneral,
                                idtipoinstalacion: 4,
                            }
                            await axios.post(urlInstalacion, { data })
                        }
                        if(tipoinstalacionmaduracion) {
                            const data = {
                                idiformaciongeneral: idiformaciongeneral,
                                idtipoinstalacion: 5,
                            }
                            await axios.post(urlInstalacion, { data })
                        }
                        // if(tipoinstalacionanejamiento) {
                        //     const data = {
                        //         idiformaciongeneral: idiformaciongeneral,
                        //         idtipoinstalacion: 6,
                        //     }
                        //     await axios.post(urlInstalacion, { data })
                        // }
                        // if(tipoinstalacionreposado) {
                        //     const data = {
                        //         idiformaciongeneral: idiformaciongeneral,
                        //         idtipoinstalacion: 7,
                        //     }
                        //     await axios.post(urlInstalacion, { data })
                        // }
                        for (const responsable of responsables) {
                            if(responsable.idresponsabledeinstalacion){
                                const {id, estado, fc_01_archivosresposansables, ...responsableSinID} = responsable
                                responsableSinID.idiformaciongeneral = idiformaciongeneral
                                if(responsableSinID.nombreresponsable !== '') {
                                    const resResponsable = await axios.put(urlActualizarResponsable, { data : responsableSinID })
                                    const idRespon = resResponsable.data.data.idresponsabledeinstalacion
                                    // for (const j in filesInstalaciones) {
                                    //     if(filesInstalaciones[j].idAnexoFK === undefined){
                                    //         if(filesInstalaciones[j].idAnexo === id){
                                    //             filesInstalaciones[j].idAnexoFK = idRespon
                                    //             await agregarFile(filesInstalaciones[j], 'FC_01/agregarNuevoArchivoResponsable')
                                    //         }
                                    //     }
                                    // }
                                }
                            }else{
                                const {id, estado, idiformaciongeneral, fc_01_archivosresposansables, idresponsabledeinstalacion, ...responsableSinID} = responsable
                                responsableSinID.idiformaciongeneral = idInfoGeneral
                                if(responsableSinID.nombreresponsable !== '') await axios.post(urlResponsable, { data : responsableSinID })
                            }
                            
                        }
    
                        if(dataSeccion?.equipoAlmacen){
                            for (const elemento of dataSeccion.equipoAlmacen) {
                                if(elemento.iddataelemento){
                                    const {id, opcion, ...dataElemento} = elemento
                                    dataElemento.idanexo = idanexo
                                    if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                    if(opcion !== '') await axios.put(urlActualizarDataElemento, { data: dataElemento })
                                }else{
                                    const {id, opcion, iddataelemento, ...dataElemento} = elemento
                                    dataElemento.idanexo = idanexo
                                    if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                    if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                                }
                                
                            }
                        }
                        if(dataSeccion?.granelAlmacen){
                            for (const elemento of dataSeccion.granelAlmacen) {
                                if(elemento.iddataelemento){
                                    const {id, opcion, ...dataElemento} = elemento
                                    dataElemento.idanexo = idanexo
                                    if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                    if(opcion !== '') await axios.put(urlActualizarDataElemento, { data: dataElemento })
                                }else{
                                    const {id, opcion, iddataelemento, ...dataElemento} = elemento
                                    dataElemento.idanexo = idanexo
                                    if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                    if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                                }
                                
                            }
                        }
                        if(dataSeccion?.maduracionAlmacen){
                            for (const elemento of dataSeccion.maduracionAlmacen) {
                                if(elemento.iddataelemento){
                                    const {id, opcion, ...dataElemento} = elemento
                                    dataElemento.idanexo = idanexo
                                    if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                    if(opcion !== '') await axios.put(urlActualizarDataElemento, { data: dataElemento })
                                }else{
                                    const {id, opcion, iddataelemento, ...dataElemento} = elemento
                                    dataElemento.idanexo = idanexo
                                    if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                    if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                                }
                                
                            }
                        }
                        if(dataSeccion?.variablesAlmacen){
                            for (const elemento of dataSeccion.variablesAlmacen) {
                                if(elemento.iddataelemento){
                                    const {id, opcion, ...dataElemento} = elemento
                                    dataElemento.idanexo = idanexo
                                    if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                    if(opcion !== '') await axios.put(urlActualizarDataElemento, { data: dataElemento })
                                }else{
                                    const {id, opcion, iddataelemento, ...dataElemento} = elemento
                                    dataElemento.idanexo = idanexo
                                    if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                    if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                                }
                                
                            }
                        }
    
                    } else {
                        const {tipoinstalacionanejamiento, tipoinstalacionbodega, tipoinstalaciongranel, tipoinstalacionmaduracion, tipoinstalacionreposado,idfc01_solicitudregistro, ...unidad} = anexoInstalacionSinID
                    
                        const indormacionGeneralAgregada = await axios.post(urlInformacionGeneral, { data: unidad })
                        const idiformaciongeneral = indormacionGeneralAgregada.data.data.idiformaciongeneral
                        if(tipoinstalacionbodega) {
                            const data = {
                                idiformaciongeneral: idiformaciongeneral,
                                idtipoinstalacion: 3,
                            }
                            await axios.post(urlInstalacion, { data })
                        }
                        if(tipoinstalaciongranel) {
                            const data = {
                                idiformaciongeneral: idiformaciongeneral,
                                idtipoinstalacion: 4,
                            }
                            await axios.post(urlInstalacion, { data })
                        }
                        if(tipoinstalacionmaduracion) {
                            const data = {
                                idiformaciongeneral: idiformaciongeneral,
                                idtipoinstalacion: 5,
                            }
                            await axios.post(urlInstalacion, { data })
                        }
                        // if(tipoinstalacionanejamiento) {
                        //     const data = {
                        //         idiformaciongeneral: idiformaciongeneral,
                        //         idtipoinstalacion: 6,
                        //     }
                        //     await axios.post(urlInstalacion, { data })
                        // }
                        // if(tipoinstalacionreposado) {
                        //     const data = {
                        //         idiformaciongeneral: idiformaciongeneral,
                        //         idtipoinstalacion: 7,
                        //     }
                        //     await axios.post(urlInstalacion, { data })
                        // }
                        for (const responsable of responsables) {
                            const {id, estado, ...responsableSinID} = responsable
                            responsableSinID.idiformaciongeneral = idiformaciongeneral
                            if(responsableSinID.nombreresponsable !== '') await axios.post(urlResponsable, { data : responsableSinID })
                        }
                        const data = {
                            idfc01_solicitudregistro: res.data.data.idfc01_solicitudregistro,
                            idtipoanexo: 3,
                            idiformaciongeneral: idiformaciongeneral
                        }
                        const anexoAgregado = await axios.post(urlAnexo, { data })
                        const idanexo = anexoAgregado.data.data.idanexo
                        
                        if(tipoinstalacionbodega){
                            for (const elemento of dataSeccion.equipoAlmacen) {
                                const {id, opcion, capacidad, ...dataElemento} = elemento
                                dataElemento.idanexo = idanexo
                                if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                            }
                        }
                        if(tipoinstalaciongranel){
                            for (const elemento of dataSeccion.granelAlmacen) {
                                const {id, opcion, capacidad, ...dataElemento} = elemento
                                dataElemento.idanexo = idanexo
                                if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                            }
                        }
                        if(tipoinstalacionmaduracion){
                            for (const elemento of dataSeccion.maduracionAlmacen) {
                                const {id, opcion, capacidad, ...dataElemento} = elemento
                                dataElemento.idanexo = idanexo
                                if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                            }
                        }
                        // if(tipoinstalacionanejamiento){
                        //     for (const elemento of dataSeccion.anejamientoAlmacen) {
                        //         const {id, opcion, capacidad, ...dataElemento} = elemento
                        //         dataElemento.idanexo = idanexo
                        //         if(dataElemento.cantidad === '') dataElemento.cantidad = null
                        //         if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                        //     }
                        // }
                        // if(tipoinstalacionreposado){
                        //     for (const elemento of dataSeccion.reposadoAlmacen) {
                        //         const {id, opcion, capacidad, ...dataElemento} = elemento
                        //         dataElemento.idanexo = idanexo
                        //         if(dataElemento.cantidad === '') dataElemento.cantidad = null
                        //         if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                        //     }
                        // }
                        if(tipoinstalacionmaduracion){
                            for (const elemento of dataSeccion.variablesAlmacen) {
                                const {id, opcion, capacidad, ...dataElemento} = elemento
                                dataElemento.idanexo = idanexo
                                if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                            }
                        }
                    }
                }
                
                
                // for (const j in filesInstalaciones) {
                //     if(filesInstalaciones[j].idAnexoFK === undefined){
                //         if(filesInstalaciones[j].idAnexo === id){
                //             filesInstalaciones[j].idAnexoFK = anexoInstalacionSinID.idanexo
                //             await agregarFile(filesInstalaciones[j], 'FC_01/agregarNuevoArchivoAnexoInstalacion')
                //         }
                //     }
                // }
            }
            return {}
        } catch (error) {
            console.log(error);
        }    
    }
)
const actualizarFile = async (data, url) => {
    let formData = new FormData();
    formData.append(1, data.file)
    formData.append('nameId', data.id)
    formData.append('idSolicitud', data.idAnexo)
    formData.append('idSolicitudFK', data.idAnexoFK)
    const resFile = await axios.put(host + url, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
    return resFile
}

export const guardarCambiosFC_01Borrador = createAsyncThunk(
    GUARDAR_CAMBIOS_FC_01_BORRADOR_EXITO,
    async(data) => {
        try {
            const solicitud = { data: data.solicitud }
            const anexoAlmacen = { data: data.anexoUnidadAlmacen }
            const anexoProduccion = { data: data.anexoUnidadProduccion }
            const anexoEnvasado = { data: data.anexoUnidadEnvasado }
            const anexoMarcas = { data: data.marcas }
            const anexoPersonasAut = { data: data.personasAutorizadas }
            const anexoRepresentantesLegales = { data: data.representantesLegales }
            
            const archivosPredios = data.filesPredios
            const archivosViveros = data.filesViveros
            const archivosApoderadosLeg = data.filesApoderadosLeg
            const archivosPersonaAut = data.filesPersonasAut
            const archivosMarcas = data.filesMarcas
            const archivosMarcasProduct = data.filesMarcasProduct
            const archivosInstalaciones = data.filesInstalaciones
            const archivos = data.files
    
            const anexoMediosDeContacto = { data: data.mediosDeContacto }
            const anexoPredio = {data: data.predios}
            const anexoProductor = {data: data.productor}

            const anexoInstalaciones = {data: data.anexoInstalaciones}
            const anexoMarcasProductoConMezcal = { data: data.marcasProductoConMezcal }
            
            const actualizarFC_01 = host + 'FC_01/actualizarSolicitudFC_01'
            
            const urlAnexosUnidadAlmacen = host + 'FC_01/agregarNuevoFC_01AnexoUnidadAlmacen'
            const urlActualizarAnexosUnidadAlmacen = host + 'FC_01/actualizarAnexoUnidadDeAlmacenFC_01'
    
            const urlAnexosUnidadEnvasado = host + 'FC_01/agregarNuevoFC_01AnexoUnidadDeEnvasado'
            const urlActualizarAnexosUnidadEnvasado = host + 'FC_01/actualizarAnexoUnidadDeEnvasadoFC_01'
    
            const urlAnexosMarcas = host + 'FC_01/agregarNuevoFC_01AnexoMarcas'
            const urlActualizarAnexosMarcas = host + 'FC_01/actualizarAnexoMarcaDeSolicitudFC_01'
    
            const urlAnexoPersonasAutorizadas = host + 'FC_01/agregarNuevoFC_01AnexoPersonaAutorizadaTramites'
            const urlActualizarAnexoPersonasAutorizadas = host + 'FC_01/actualizarAnexoPersonaAutorizadaTramitesFC_01'

            const urlAnexoRepresentantesLegales = host + 'FC_01/agregarNuevoFC_01AnexoPersonaAutorizada'
            const urlActualizarAnexoRepresentanteLegal = host + 'FC_01/actualizarAnexoRepresentateLegalFC_01'
    
            const urlAnexoMediosDeContacto = host + 'FC_01/agregarNuevoFC_01AnexoMediosDeContacto'
            const urlActualizarAnexoMediosDeContacto = host + 'FC_01/actualizarAnexoMediosDeContactoFC_01'
            
            const urlAnexoPredios = host + 'FC_01/agregarNuevoFC_01AnexoVivero'
            const urlActualizarAnexoPredios = host + 'FC_01/actualizarAnexoViveroFC_01'

            const urlAnexoProductor = host + 'FC_01/agregarNuevoFC_01AnexoProductor'
            const urlActualizarAnexoProductor= host + 'FC_01/actualizarAnexoProductorFC_01'
            
            const urlAnexo = host + 'FC_01/agregarNuevoAnexo'
            const urlActualizarAnexo = host + 'FC_01/actualizarAnexo'
            const urlInformacionGeneral = host + 'FC_01/agregarNuevaInformacionGeneral'
            const urlActualizarInformacionGeneral = host + 'FC_01/actualizarInformacionGeneral'
            const urlInstalacion = host + 'FC_01/agregarNuevaInstalacion'
            const urlActualizarInstalacion = host + 'FC_01/actualizarInstalacion'
            const urlDataElemento = host + 'FC_01/agregarNuevaDataElemento'
            const urlActualizarDataElemento = host + 'FC_01/actualizarDataElelemento'
            
            const urlResponsable = host + 'FC_01/agregarNuevoResponsable'
            const urlActualizarResponsable = host + 'FC_01/actualizarResponsable'

            const urlAnexosMarcasProductosConMezcal = host + 'FC_01/agregarNuevoFC_01marcaProductorConMezcal'
            const urlActualizarAnexosMarcasProductosConMezcal = host + 'FC_01/actualizarAnexoMarcaProductorConMezcalFC_01'
            
            const res = await axios.put(actualizarFC_01, solicitud)
    
            if(archivos !== undefined){
                for (let i in archivos) {
                    archivos[i].idAnexoFK = res.data.data.idfc01_solicitudregistro
                    await agregarFile(archivos[i], 'FC_01/agregarAnexosArchivosFC_01')
                }
            }
            for (let i in anexoProductor.data) {
                const {id, fc_01_archivospredios, ...anexoProductorSinID} = anexoProductor.data[i]
                let idfeik = id;
                anexoProductorSinID.idfc01_solicitudregistro = res.data.data.idfc01_solicitudregistro
                if (anexoProductorSinID === "") {
                    anexoProductorSinID = null
                }
                if (anexoProductorSinID.idfc01_anexoproductor) {
                    await axios.put(urlActualizarAnexoProductor, { data: anexoProductorSinID })
                    anexoProductorSinID.id = idfeik;
                    if(archivosPredios !== undefined){
                        for (const j in archivosPredios) {
                            if(archivosPredios[j].idAnexo === id){
                                archivosPredios[j].idAnexoFK = anexoProductorSinID.idfc01_anexoproductor
                                await agregarFile(archivosPredios[j], 'FC_01/agregarNuevoFC_01ArchivosPredio')
                            }
                        }
                    }
                } else {
                    const resAnexo = await axios.post(urlAnexoProductor, { data: anexoProductorSinID })
                    if(archivosPredios !== undefined){
                        for (const j in archivosPredios) {
                            if(archivosPredios[j].idAnexo === id){
                                archivosPredios[j].idAnexoFK = resAnexo.data.data.idfc01_anexoproductor
                                await agregarFile(archivosPredios[j], 'FC_01/agregarNuevoFC_01ArchivosPredio')
                            }
                        }
                    }
                }
            }

            for (let i in anexoRepresentantesLegales.data) {
                const {id, estado, fc_01_anexosrepresentantelegal, ...anexoRepLeg} = anexoRepresentantesLegales.data[i]
                let idfeik = id
                anexoRepLeg.idfc01_solicitudregistro = res.data.data.idfc01_solicitudregistro
                if(anexoRepLeg === "") {
                    anexoRepLeg = null
                }
                if(anexoRepLeg.idfc01_anexorepresentantelegal) {
                    await axios.put(urlActualizarAnexoRepresentanteLegal, { data : anexoRepLeg})
                    anexoRepLeg.id = idfeik
                    if(archivosApoderadosLeg !== undefined){
                        for (const j in archivosApoderadosLeg) {
                            if(archivosApoderadosLeg[j].idAnexo === id){
                                archivosApoderadosLeg[j].idAnexoFK = anexoRepLeg.idfc01_anexorepresentantelegal
                                await agregarFile(archivosApoderadosLeg[j], 'FC_01/agregarNuevoArchivoAnexosRepresentanteLegal')
                            }
                        }
                    }
                } else {
                    const resAnexo =await axios.post(urlAnexoRepresentantesLegales, { data: anexoRepLeg })
                    if(archivosApoderadosLeg !== undefined){
                        for (const j in archivosApoderadosLeg) {
                            if(archivosApoderadosLeg[j].idAnexo === id){
                                archivosApoderadosLeg[j].idAnexoFK = resAnexo.data.data.idfc01_anexorepresentantelegal
                                await agregarFile(archivosApoderadosLeg[j], 'FC_01/agregarNuevoArchivoAnexosRepresentanteLegal')
                            }
                        }
                    }
                }

            }

            for (let i in anexoPersonasAut.data) {
                const {id, estado, fc_01_anexospersonaautorizada, ...anexoPersonasSinID} = anexoPersonasAut.data[i]
                let idfeik = id;
                anexoPersonasSinID.idfc01_solicitudregistro = res.data.data.idfc01_solicitudregistro
                if (anexoPersonasSinID === "") {
                    anexoPersonasSinID = null
                }
                if (anexoPersonasSinID.idfc01_anexopersonaatorizadatramites) {
                    await axios.put(urlActualizarAnexoPersonasAutorizadas, { data: anexoPersonasSinID })
                    anexoPersonasSinID.id = idfeik
                    if(archivosPersonaAut !== undefined){
                        for (const j in archivosPersonaAut) {
                            if(archivosPersonaAut[j].idAnexo === id){
                                archivosPersonaAut[j].idAnexoFK = anexoPersonasSinID.idfc01_anexopersonaatorizadatramites
                                await agregarFile(archivosPersonaAut[j], 'FC_01/agregarNuevoArchivoAnexosPersonaAutorizada')
                            }
                        }
                    }
                } else {
                    const resAnexo = await axios.post(urlAnexoPersonasAutorizadas, { data: anexoPersonasSinID })
                    if(archivosPersonaAut !== undefined){
                        for (const j in archivosPersonaAut) {
                            if(archivosPersonaAut[j].idAnexo === id){
                                archivosPersonaAut[j].idAnexoFK = resAnexo.data.data.idfc01_anexopersonaatorizadatramites
                                await agregarFile(archivosPersonaAut[j], 'FC_01/agregarNuevoArchivoAnexosPersonaAutorizada')
                            }
                        }
                    }
                }
            }
    
            for (let i in anexoMarcas.data) {
                const {id, fc_01_anexosmarca, ...anexoMarcasSinID} = anexoMarcas.data[i]
                let idfeik = id;
                anexoMarcasSinID.idfc01_solicitudregistro = res.data.data.idfc01_solicitudregistro
                if (anexoMarcasSinID === "") {
                    anexoMarcasSinID = null
                }
                if (anexoMarcasSinID.idfc01_anexomarcas) {
                    await axios.put(urlActualizarAnexosMarcas, { data: anexoMarcasSinID })
                    anexoMarcasSinID.id = idfeik;
                    if(archivosMarcas !== undefined){
                        for (const j in archivosMarcas) {
                            if(archivosMarcas[j].idAnexo === id){
                                archivosMarcas[j].idAnexoFK = anexoMarcasSinID.idfc01_anexomarcas
                                await agregarFile(archivosMarcas[j], 'FC_01/agregarNuevoArchivoAnexoDeMarca')
                            }
                        }
                    }
                } else {
                    const resAnexo = await axios.post(urlAnexosMarcas, { data: anexoMarcasSinID })
                    if(archivosMarcas !== undefined){
                        for (const j in archivosMarcas) {
                            if(archivosMarcas[j].idAnexo === id){
                                archivosMarcas[j].idAnexoFK = resAnexo.data.data.idfc01_anexomarcas
                                await agregarFile(archivosMarcas[j], 'FC_01/agregarNuevoArchivoAnexoDeMarca')
                            }
                        }
                    }
                }
            }
            for (let i in anexoMarcasProductoConMezcal.data) {
                const {id, fc_01_archivosmarcasproducto, ...anexoMarcasSinID} = anexoMarcasProductoConMezcal.data[i]
                let idfeik = id;
                anexoMarcasSinID.idfc01_solicitudregistro = res.data.data.idfc01_solicitudregistro
                if (anexoMarcasSinID === "") {
                    anexoMarcasSinID = null
                }
                if (anexoMarcasSinID.idfc01_anexomarcasproductoconmezcal) {
                    await axios.put(urlActualizarAnexosMarcasProductosConMezcal, { data: anexoMarcasSinID })
                    anexoMarcasSinID.id = idfeik;
                    if(archivosMarcasProduct !== undefined){
                        for (const j in archivosMarcasProduct) {
                            if(archivosMarcasProduct[j].idAnexo === id){
                                archivosMarcasProduct[j].idAnexoFK = anexoMarcasSinID.idfc01_anexomarcasproductoconmezcal
                                await agregarFile(archivosMarcasProduct[j], 'FC_01/agregarNuevoArchivoAnexoMarcaProducto')
                            }
                        }
                    }
                } else {
                    const resAnexo = await axios.post(urlAnexosMarcasProductosConMezcal, { data: anexoMarcasSinID })
                    if(archivosMarcasProduct !== undefined){
                        for (const j in archivosMarcasProduct) {
                            if(archivosMarcasProduct[j].idAnexo === id){
                                archivosMarcasProduct[j].idAnexoFK = resAnexo.data.data.idfc01_anexomarcasproductoconmezcal
                                await agregarFile(archivosMarcasProduct[j], 'FC_01/agregarNuevoArchivoAnexoMarcaProducto')
                            }
                        }
                    }
                }
            }
            
            //Instalaciones
            for(let i in anexoInstalaciones.data){
                
                const {id, responsables, domicilio, anexo, dataSeccion, opcionesSeleccionadas, tipoInstalacion, ...anexoInstalacionSinID} =  anexoInstalaciones.data[i].data
                for (let x in anexoInstalacionSinID) {
                    if (anexoInstalacionSinID[x] === "") {
                        anexoInstalacionSinID[x] = null
                    }
                }
                if(tipoInstalacion === 'Unidad Producción'){
                    if (anexoInstalacionSinID.idanexo) {
                        const {idfc01_solicitudregistro,idanexo, ...unidad} = anexoInstalacionSinID
                        const indormacionGeneralActualizada = await axios.put(urlActualizarInformacionGeneral, { data: unidad })
                        const idInfoGeneral = indormacionGeneralActualizada.data.data.idiformaciongeneral
    
                        for (const responsable of responsables) {
                            if(responsable.idresponsabledeinstalacion){
                                const {id, estado, fc_01_archivosresposansables, ...responsableSinID} = responsable
                                responsableSinID.idiformaciongeneral = idInfoGeneral
                                if(responsableSinID.nombreresponsable !== '') {
                                    await axios.put(urlActualizarResponsable, { data : responsableSinID })
                                    if(archivosInstalaciones !== undefined){
                                        for (const j in archivosInstalaciones) {
                                            if(archivosInstalaciones[j].idAnexo === id){
                                                archivosInstalaciones[j].idAnexoFK = responsableSinID.idresponsabledeinstalacion
                                                await agregarFile(archivosInstalaciones[j], 'FC_01/agregarNuevoArchivoResponsable')
                                            }
                                        }
                                    }
                                }
                            }else{
                                const {id, estado, idiformaciongeneral, idresponsabledeinstalacion, fc_01_archivosresposansables, ...responsableSinID} = responsable
                                responsableSinID.idiformaciongeneral = idInfoGeneral
                                if(responsableSinID.nombreresponsable !== '') {
                                    const resAnexo = await axios.post(urlResponsable, { data : responsableSinID })
                                    if(archivosInstalaciones !== undefined){
                                        for (const j in archivosInstalaciones) {
                                            if(archivosInstalaciones[j].idAnexo === id){
                                                archivosInstalaciones[j].idAnexoFK = resAnexo.data.data.idresponsabledeinstalacion
                                                await agregarFile(archivosInstalaciones[j], 'FC_01/agregarNuevoArchivoResponsable')
                                            }
                                        }
                                    }
                                }
                            }
                            
                        }
                        if(dataSeccion?.coccionProduccion){
                            for (const elemento of dataSeccion.coccionProduccion) {
                                if(elemento.iddataelemento){
                                    const {id, opcion, ...dataElemento} = elemento
                                    dataElemento.idanexo = idanexo
                                    if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                    if(opcion !== '') await axios.put(urlActualizarDataElemento, { data: dataElemento })
                                }else{
                                    const {id, opcion, iddataelemento, ...dataElemento} = elemento
                                    dataElemento.idanexo = idanexo
                                    if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                    if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                                }
                                
                            }
                        }
                        if(dataSeccion?.moliendaProduccion){
                            for (const elemento of dataSeccion.moliendaProduccion) {
                                if(elemento.iddataelemento){
                                    const {id, opcion, ...dataElemento} = elemento
                                    dataElemento.idanexo = idanexo
                                    if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                    if(opcion !== '') await axios.put(urlActualizarDataElemento, { data: dataElemento })
                                }else{
                                    const {id, opcion, iddataelemento, ...dataElemento} = elemento
                                    dataElemento.idanexo = idanexo
                                    if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                    if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                                }
                                
                            }
                        }
                        if(dataSeccion?.fermentacionProduccion){
                            for (const elemento of dataSeccion.fermentacionProduccion) {
                                if(elemento.iddataelemento){
                                    const {id, opcion, ...dataElemento} = elemento
                                    dataElemento.idanexo = idanexo
                                    if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                    if(opcion !== '') await axios.put(urlActualizarDataElemento, { data: dataElemento })
                                }else{
                                    const {id, opcion, iddataelemento, ...dataElemento} = elemento
                                    dataElemento.idanexo = idanexo
                                    if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                    if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                                }
                                
                            }
                        }
                        if(dataSeccion?.destilacionProduccion){
                            for (const elemento of dataSeccion.destilacionProduccion) {
                                if(elemento.iddataelemento){
                                    const {id, opcion, ...dataElemento} = elemento
                                    dataElemento.idanexo = idanexo
                                    if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                    if(opcion !== '') await axios.put(urlActualizarDataElemento, { data: dataElemento })
                                }else{
                                    const {id, opcion, iddataelemento, ...dataElemento} = elemento
                                    dataElemento.idanexo = idanexo
                                    if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                    if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                                }
                                
                            }
                        }
                        if(archivosInstalaciones !== undefined){
                            for (const j in archivosInstalaciones) {
                                if(archivosInstalaciones[j].idAnexo === id){
                                    archivosInstalaciones[j].idAnexoFK = anexoInstalacionSinID.idanexo
                                    await agregarFile(archivosInstalaciones[j], 'FC_01/agregarNuevoArchivoAnexoInstalacion')
                                }
                            }
                        }
    
                    } else {
                        const {idfc01_solicitudregistro, ...unidad} = anexoInstalacionSinID
                    
                        const indormacionGeneralAgregada = await axios.post(urlInformacionGeneral, { data: unidad })
                            const idiformaciongeneral = indormacionGeneralAgregada.data.data.idiformaciongeneral
                            let dataInstalacion = {
                                idiformaciongeneral: idiformaciongeneral,
                                idtipoinstalacion: 1,
                            }
                            await axios.post(urlInstalacion, { data: dataInstalacion})
                            
                            const data = {
                                idfc01_solicitudregistro: res.data.data.idfc01_solicitudregistro,
                                idtipoanexo: 1,
                                idiformaciongeneral: idiformaciongeneral
                            }
                            const anexoAgregado = await axios.post(urlAnexo, { data })
                            const idanexo = anexoAgregado.data.data.idanexo
    
                            for (const responsable of responsables) {
                                const {id, estado, fc_01_archivosresposansables, ...responsableSinID} = responsable
                                responsableSinID.idiformaciongeneral = idiformaciongeneral
                                if(responsableSinID.nombreresponsable !== '') {
                                    const resAnexo = await axios.post(urlResponsable, { data : responsableSinID })
                                    if(archivosInstalaciones !== undefined){
                                        for (const j in archivosInstalaciones) {
                                            if(archivosInstalaciones[j].idAnexo === id){
                                                archivosInstalaciones[j].idAnexoFK = resAnexo.data.data.idresponsabledeinstalacion
                                                await agregarFile(archivosInstalaciones[j], 'FC_01/agregarNuevoArchivoResponsable')
                                            }
                                        }
                                    }
                                }
                            }
    
                            for (const elemento of dataSeccion.coccionProduccion) {
                                const {id, opcion, capacidad, ...dataElemento} = elemento
                                dataElemento.idanexo = idanexo
                                if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                            }
                            for (const elemento of dataSeccion.moliendaProduccion) {
                                const {id, opcion, capacidad, ...dataElemento} = elemento
                                dataElemento.idanexo = idanexo
                                if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                            }
                            for (const elemento of dataSeccion.fermentacionProduccion) {
                                const {id, opcion, capacidad, ...dataElemento} = elemento
                                dataElemento.idanexo = idanexo
                                if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                            }
                            for (const elemento of dataSeccion.destilacionProduccion) {
                                const {id, opcion, capacidad, ...dataElemento} = elemento
                                dataElemento.idanexo = idanexo
                                if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                            }
                            if(archivosInstalaciones !== undefined){
                                for (const j in archivosInstalaciones) {
                                    if(archivosInstalaciones[j].idAnexo === id){
                                        archivosInstalaciones[j].idAnexoFK = idanexo
                                        await agregarFile(archivosInstalaciones[j], 'FC_01/agregarNuevoArchivoAnexoInstalacion')
                                    }
                                }
                            }
                    }
                }
                if(tipoInstalacion === 'Unidad Envasado'){
                    if (anexoInstalacionSinID.idanexo) {
                        
                        const {idfc01_solicitudregistro,idanexo, ...unidad} = anexoInstalacionSinID
                        const indormacionGeneralActualizada = await axios.put(urlActualizarInformacionGeneral, { data: unidad })
                        const idInfoGeneral = indormacionGeneralActualizada.data.data.idiformaciongeneral
    
                        for (const responsable of responsables) {
                            if(responsable.idresponsabledeinstalacion){
                                const {id, estado, fc_01_archivosresposansables, ...responsableSinID} = responsable
                                responsableSinID.idiformaciongeneral = idInfoGeneral
                                if(responsableSinID.nombreresponsable !== '') {
                                    await axios.put(urlActualizarResponsable, { data : responsableSinID })
                                    if(archivosInstalaciones !== undefined){
                                        for (const j in archivosInstalaciones) {
                                            if(archivosInstalaciones[j].idAnexo === id){
                                                archivosInstalaciones[j].idAnexoFK = responsableSinID.idresponsabledeinstalacion
                                                await agregarFile(archivosInstalaciones[j], 'FC_01/agregarNuevoArchivoResponsable')
                                            }
                                        }
                                    }
                                }
                            }else{
                                const {id, estado, idiformaciongeneral, idresponsabledeinstalacion, fc_01_archivosresposansables, ...responsableSinID} = responsable
                                responsableSinID.idiformaciongeneral = idInfoGeneral
                                if(responsableSinID.nombreresponsable !== '') {
                                    const resAnexo = await axios.post(urlResponsable, { data : responsableSinID })
                                    if(archivosInstalaciones !== undefined){
                                        for (const j in archivosInstalaciones) {
                                            if(archivosInstalaciones[j].idAnexo === id){
                                                archivosInstalaciones[j].idAnexoFK = resAnexo.data.data.idresponsabledeinstalacion
                                                await agregarFile(archivosInstalaciones[j], 'FC_01/agregarNuevoArchivoResponsable')
                                            }
                                        }
                                    }
                                }
                            }
                            
                        }
    
                        if(dataSeccion?.seccion1){
                            for (const elemento of dataSeccion.seccion1) {
                                if(elemento.iddataelemento){
                                    const {id, opcion, ...dataElemento} = elemento
                                    dataElemento.idanexo = idanexo
                                    if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                    if(opcion !== '') await axios.put(urlActualizarDataElemento, { data: dataElemento })
                                }else{
                                    const {id, opcion, iddataelemento, ...dataElemento} = elemento
                                    dataElemento.idanexo = idanexo
                                    if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                    if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                                }
                                
                            }
                        }
                        if(dataSeccion?.seccion2){
                            for (const elemento of dataSeccion.seccion2) {
                                if(elemento.iddataelemento){
                                    const {id, opcion, ...dataElemento} = elemento
                                    dataElemento.idanexo = idanexo
                                    if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                    if(opcion !== '') await axios.put(urlActualizarDataElemento, { data: dataElemento })
                                }else{
                                    const {id, opcion, iddataelemento, ...dataElemento} = elemento
                                    dataElemento.idanexo = idanexo
                                    if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                    if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                                }
                                
                            }
                        }
                        if(dataSeccion?.seccion3){
                            for (const elemento of dataSeccion.seccion3) {
                                if(elemento.iddataelemento){
                                    const {id, opcion, ...dataElemento} = elemento
                                    dataElemento.idanexo = idanexo
                                    if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                    if(opcion !== '') await axios.put(urlActualizarDataElemento, { data: dataElemento })
                                }else{
                                    const {id, opcion, iddataelemento, ...dataElemento} = elemento
                                    dataElemento.idanexo = idanexo
                                    if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                    if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                                }
                                
                            }
                        }
                        if(dataSeccion?.seccion4){
                            for (const elemento of dataSeccion.seccion4) {
                                if(elemento.iddataelemento){
                                    const {id, opcion, ...dataElemento} = elemento
                                    dataElemento.idanexo = idanexo
                                    if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                    if(opcion !== '') await axios.put(urlActualizarDataElemento, { data: dataElemento })
                                }else{
                                    const {id, opcion, iddataelemento, ...dataElemento} = elemento
                                    dataElemento.idanexo = idanexo
                                    if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                    if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                                }
                                
                            }
                        }
                        if(dataSeccion?.seccion5){
                            for (const elemento of dataSeccion.seccion5) {
                                if(elemento.iddataelemento){
                                    const {id, opcion, ...dataElemento} = elemento
                                    dataElemento.idanexo = idanexo
                                    if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                    if(opcion !== '') await axios.put(urlActualizarDataElemento, { data: dataElemento })
                                }else{
                                    const {id, opcion, iddataelemento, ...dataElemento} = elemento
                                    dataElemento.idanexo = idanexo
                                    if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                    if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                                }
                                
                            }
                        }
                        if(archivosInstalaciones !== undefined){
                            for (const j in archivosInstalaciones) {
                                if(archivosInstalaciones[j].idAnexo === id){
                                    archivosInstalaciones[j].idAnexoFK = anexoInstalacionSinID.idanexo
                                    await agregarFile(archivosInstalaciones[j], 'FC_01/agregarNuevoArchivoAnexoInstalacion')
                                }
                            }
                        }
                    } else {
                        const {idfc01_solicitudregistro, ...unidad} = anexoInstalacionSinID
                    
                        const indormacionGeneralAgregada = await axios.post(urlInformacionGeneral, { data: unidad })
                        const idiformaciongeneral = indormacionGeneralAgregada.data.data.idiformaciongeneral
                        let dataInstalacion = {
                            idiformaciongeneral: idiformaciongeneral,
                            idtipoinstalacion: 2,
                        }
                        await axios.post(urlInstalacion, { data: dataInstalacion})
                        
                        const data = {
                            idfc01_solicitudregistro: res.data.data.idfc01_solicitudregistro,
                            idtipoanexo: 2,
                            idiformaciongeneral: idiformaciongeneral
                        }
                        const anexoAgregado = await axios.post(urlAnexo, { data })
                        const idanexo = anexoAgregado.data.data.idanexo
                        
                        for (const responsable of responsables) {
                            const {id, estado, fc_01_archivosresposansables, ...responsableSinID} = responsable
                            responsableSinID.idiformaciongeneral = idiformaciongeneral
                            if(responsableSinID.nombreresponsable !== '') {
                                const resAnexo = await axios.post(urlResponsable, {
                                    data: responsableSinID
                                })
                                if (archivosInstalaciones !== undefined) {
                                    for (const j in archivosInstalaciones) {
                                        if (archivosInstalaciones[j].idAnexo === id) {
                                            archivosInstalaciones[j].idAnexoFK = resAnexo.data.data.idresponsabledeinstalacion
                                            await agregarFile(archivosInstalaciones[j], 'FC_01/agregarNuevoArchivoResponsable')
                                        }
                                    }
                                }
                            }
                        }
    
                        for (const elemento of dataSeccion.seccion1) {
                            const {id, opcion, capacidad, ...dataElemento} = elemento
                            dataElemento.idanexo = idanexo
                            if(dataElemento.cantidad === '') dataElemento.cantidad = null
                            if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                        }
                        for (const elemento of dataSeccion.seccion2) {
                            const {id, opcion, capacidad, ...dataElemento} = elemento
                            dataElemento.idanexo = idanexo
                            if(dataElemento.cantidad === '') dataElemento.cantidad = null
                            if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                        }
                        for (const elemento of dataSeccion.seccion3) {
                            const {id, opcion, capacidad, ...dataElemento} = elemento
                            dataElemento.idanexo = idanexo
                            if(dataElemento.cantidad === '') dataElemento.cantidad = null
                            if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                        }
                        for (const elemento of dataSeccion.seccion4) {
                            const {id, opcion, capacidad, ...dataElemento} = elemento
                            dataElemento.idanexo = idanexo
                            if(dataElemento.cantidad === '') dataElemento.cantidad = null
                            if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                        }
                        for (const elemento of dataSeccion.seccion5) {
                            const {id, opcion, capacidad, ...dataElemento} = elemento
                            dataElemento.idanexo = idanexo
                            if(dataElemento.cantidad === '') dataElemento.cantidad = null
                            if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                        }
                        if(archivosInstalaciones !== undefined){
                            for (const j in archivosInstalaciones) {
                                if(archivosInstalaciones[j].idAnexo === id){
                                    archivosInstalaciones[j].idAnexoFK = idanexo
                                    await agregarFile(archivosInstalaciones[j], 'FC_01/agregarNuevoArchivoAnexoInstalacion')
                                }
                            }
                        }
                    }
                }
                
                if(tipoInstalacion === 'Unidad Almacén'){
                    if (anexoInstalacionSinID.idanexo) {
                        
                        const {tipoinstalacionanejamiento, tipoinstalacionbodega, tipoinstalaciongranel, tipoinstalacionmaduracion, tipoinstalacionreposado, idfc01_solicitudregistro, idanexo, ...unidad} = anexoInstalacionSinID
                    
                        const indormacionGeneralActualizada = await axios.put(urlActualizarInformacionGeneral, { data: unidad })
                        const idiformaciongeneral = indormacionGeneralActualizada.data.data.idiformaciongeneral
                        const idInfoGeneral = indormacionGeneralActualizada.data.data.idiformaciongeneral
                        const urlEliminarInstalaciones = host + `FC_01/eliminarInstalaciones/${idiformaciongeneral}`
                        await axios.delete(urlEliminarInstalaciones)
                        if(tipoinstalacionbodega) {
                            const data = {
                                idiformaciongeneral: idiformaciongeneral,
                                idtipoinstalacion: 3,
                            }
                            await axios.post(urlInstalacion, { data })
                        }
                        if(tipoinstalaciongranel) {
                            const data = {
                                idiformaciongeneral: idiformaciongeneral,
                                idtipoinstalacion: 4,
                            }
                            await axios.post(urlInstalacion, { data })
                        }
                        if(tipoinstalacionmaduracion) {
                            const data = {
                                idiformaciongeneral: idiformaciongeneral,
                                idtipoinstalacion: 5,
                            }
                            await axios.post(urlInstalacion, { data })
                        }
                        // if(tipoinstalacionanejamiento) {
                        //     const data = {
                        //         idiformaciongeneral: idiformaciongeneral,
                        //         idtipoinstalacion: 6,
                        //     }
                        //     await axios.post(urlInstalacion, { data })
                        // }
                        // if(tipoinstalacionreposado) {
                        //     const data = {
                        //         idiformaciongeneral: idiformaciongeneral,
                        //         idtipoinstalacion: 7,
                        //     }
                        //     await axios.post(urlInstalacion, { data })
                        // }
                        for (const responsable of responsables) {
                            if(responsable.idresponsabledeinstalacion){
                                const {id, estado, fc_01_archivosresposansables, ...responsableSinID} = responsable
                                responsableSinID.idiformaciongeneral = idiformaciongeneral
                                if(responsableSinID.nombreresponsable !== '') {
                                    await axios.put(urlActualizarResponsable, { data : responsableSinID })
                                    if(archivosInstalaciones !== undefined){
                                        for (const j in archivosInstalaciones) {
                                            if(archivosInstalaciones[j].idAnexo === id){
                                                archivosInstalaciones[j].idAnexoFK = responsableSinID.idresponsabledeinstalacion
                                                await agregarFile(archivosInstalaciones[j], 'FC_01/agregarNuevoArchivoResponsable')
                                            }
                                        }
                                    }
                                }
                            }else{
                                const {id, estado, idiformaciongeneral, idresponsabledeinstalacion, fc_01_archivosresposansables, ...responsableSinID} = responsable
                                responsableSinID.idiformaciongeneral = idInfoGeneral
                                if(responsableSinID.nombreresponsable !== '') {
                                    const resAnexo = await axios.post(urlResponsable, { data : responsableSinID })
                                    if(archivosInstalaciones !== undefined){
                                        for (const j in archivosInstalaciones) {
                                            if(archivosInstalaciones[j].idAnexo === id){
                                                archivosInstalaciones[j].idAnexoFK = resAnexo.data.data.idresponsabledeinstalacion
                                                await agregarFile(archivosInstalaciones[j], 'FC_01/agregarNuevoArchivoResponsable')
                                            }
                                        }
                                    }
                                }
                            }
                            
                        }
    
                        if(dataSeccion?.equipoAlmacen){
                            for (const elemento of dataSeccion.equipoAlmacen) {
                                if(elemento.iddataelemento){
                                    const {id, opcion, ...dataElemento} = elemento
                                    dataElemento.idanexo = idanexo
                                    if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                    if(opcion !== '') await axios.put(urlActualizarDataElemento, { data: dataElemento })
                                }else{
                                    const {id, opcion, iddataelemento, ...dataElemento} = elemento
                                    dataElemento.idanexo = idanexo
                                    if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                    if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                                }
                                
                            }
                        }
                        if(dataSeccion?.granelAlmacen){
                            for (const elemento of dataSeccion.granelAlmacen) {
                                if(elemento.iddataelemento){
                                    const {id, opcion, ...dataElemento} = elemento
                                    dataElemento.idanexo = idanexo
                                    if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                    if(opcion !== '') await axios.put(urlActualizarDataElemento, { data: dataElemento })
                                }else{
                                    const {id, opcion, iddataelemento, ...dataElemento} = elemento
                                    dataElemento.idanexo = idanexo
                                    if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                    if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                                }
                                
                            }
                        }
                        if(dataSeccion?.maduracionAlmacen){
                            for (const elemento of dataSeccion.maduracionAlmacen) {
                                if(elemento.iddataelemento){
                                    const {id, opcion, ...dataElemento} = elemento
                                    dataElemento.idanexo = idanexo
                                    if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                    if(opcion !== '') await axios.put(urlActualizarDataElemento, { data: dataElemento })
                                }else{
                                    const {id, opcion, iddataelemento, ...dataElemento} = elemento
                                    dataElemento.idanexo = idanexo
                                    if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                    if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                                }
                                
                            }
                        }
                        
                        if(dataSeccion?.variablesAlmacen){
                            for (const elemento of dataSeccion.variablesAlmacen) {
                                if(elemento.iddataelemento){
                                    const {id, opcion, ...dataElemento} = elemento
                                    dataElemento.idanexo = idanexo
                                    if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                    if(opcion !== '') await axios.put(urlActualizarDataElemento, { data: dataElemento })
                                }else{
                                    const {id, opcion, iddataelemento, ...dataElemento} = elemento
                                    dataElemento.idanexo = idanexo
                                    if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                    if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                                }
                                
                            }
                        }
                        if(archivosInstalaciones !== undefined){
                            for (const j in archivosInstalaciones) {
                                if(archivosInstalaciones[j].idAnexo === id){
                                    archivosInstalaciones[j].idAnexoFK = anexoInstalacionSinID.idanexo
                                    await agregarFile(archivosInstalaciones[j], 'FC_01/agregarNuevoArchivoAnexoInstalacion')
                                }
                            }
                        }
                    } else {
                        const {tipoinstalacionanejamiento, tipoinstalacionbodega, tipoinstalaciongranel, tipoinstalacionmaduracion, tipoinstalacionreposado, idfc01_solicitudregistro, ...unidad} = anexoInstalacionSinID
                    
                        const indormacionGeneralAgregada = await axios.post(urlInformacionGeneral, { data: unidad })
                        const idiformaciongeneral = indormacionGeneralAgregada.data.data.idiformaciongeneral
                        if(tipoinstalacionbodega) {
                            const data = {
                                idiformaciongeneral: idiformaciongeneral,
                                idtipoinstalacion: 3,
                            }
                            await axios.post(urlInstalacion, { data })
                        }
                        if(tipoinstalaciongranel) {
                            const data = {
                                idiformaciongeneral: idiformaciongeneral,
                                idtipoinstalacion: 4,
                            }
                            await axios.post(urlInstalacion, { data })
                        }
                        if(tipoinstalacionmaduracion) {
                            const data = {
                                idiformaciongeneral: idiformaciongeneral,
                                idtipoinstalacion: 5,
                            }
                            await axios.post(urlInstalacion, { data })
                        }
                        // if(tipoinstalacionanejamiento) {
                        //     const data = {
                        //         idiformaciongeneral: idiformaciongeneral,
                        //         idtipoinstalacion: 6,
                        //     }
                        //     await axios.post(urlInstalacion, { data })
                        // }
                        // if(tipoinstalacionreposado) {
                        //     const data = {
                        //         idiformaciongeneral: idiformaciongeneral,
                        //         idtipoinstalacion: 6,
                        //     }
                        //     await axios.post(urlInstalacion, { data })
                        // }
                        for (const responsable of responsables) {
                            const {id, estado, fc_01_archivosresposansables, ...responsableSinID} = responsable
                            responsableSinID.idiformaciongeneral = idiformaciongeneral
                            if(responsableSinID.nombreresponsable !== '') {
                                const resAnexo = await axios.post(urlResponsable, {
                                    data: responsableSinID
                                })
                                if (archivosInstalaciones !== undefined) {
                                    for (const j in archivosInstalaciones) {
                                        if (archivosInstalaciones[j].idAnexo === id) {
                                            archivosInstalaciones[j].idAnexoFK = resAnexo.data.data.idresponsabledeinstalacion
                                            await agregarFile(archivosInstalaciones[j], 'FC_01/agregarNuevoArchivoResponsable')
                                        }
                                    }
                                }
                            }
                        }
                        const data = {
                            idfc01_solicitudregistro: res.data.data.idfc01_solicitudregistro,
                            idtipoanexo: 3,
                            idiformaciongeneral: idiformaciongeneral
                        }
                        const anexoAgregado = await axios.post(urlAnexo, { data })
                        const idanexo = anexoAgregado.data.data.idanexo
                        
                        if(tipoinstalacionbodega){
                            for (const elemento of dataSeccion.equipoAlmacen) {
                                const {id, opcion, capacidad, ...dataElemento} = elemento
                                dataElemento.idanexo = idanexo
                                if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                            }
                        }
                        if(tipoinstalaciongranel){
                            for (const elemento of dataSeccion.granelAlmacen) {
                                const {id, opcion, capacidad, ...dataElemento} = elemento
                                dataElemento.idanexo = idanexo
                                if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                            }
                        }
                        if(tipoinstalacionmaduracion){
                            for (const elemento of dataSeccion.maduracionAlmacen) {
                                const {id, opcion, capacidad, ...dataElemento} = elemento
                                dataElemento.idanexo = idanexo
                                if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                            }
                        }
                        // if(tipoinstalacionanejamiento){
                        //     for (const elemento of dataSeccion.anejamientoAlmacen) {
                        //         const {id, opcion, capacidad, ...dataElemento} = elemento
                        //         dataElemento.idanexo = idanexo
                        //         if(dataElemento.cantidad === '') dataElemento.cantidad = null
                        //         if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                        //     }
                        // }
                        // if(tipoinstalacionreposado){
                        //     for (const elemento of dataSeccion.reposadoAlmacen) {
                        //         const {id, opcion, capacidad, ...dataElemento} = elemento
                        //         dataElemento.idanexo = idanexo
                        //         if(dataElemento.cantidad === '') dataElemento.cantidad = null
                        //         if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                        //     }
                        // }
                        if(tipoinstalacionmaduracion){
                            for (const elemento of dataSeccion.variablesAlmacen) {
                                const {id, opcion, capacidad, ...dataElemento} = elemento
                                dataElemento.idanexo = idanexo
                                if(dataElemento.cantidad === '') dataElemento.cantidad = null
                                if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                            }
                        }
                        if(archivosInstalaciones !== undefined){
                            for (const j in archivosInstalaciones) {
                                if(archivosInstalaciones[j].idAnexo === id){
                                    archivosInstalaciones[j].idAnexoFK = idanexo
                                    await agregarFile(archivosInstalaciones[j], 'FC_01/agregarNuevoArchivoAnexoInstalacion')
                                }
                            }
                        }
                    }
                }
            }
            

            for (let i in anexoMediosDeContacto.data) {
                const {id, estado, ...anexoMediosDeContactoSinID} = anexoMediosDeContacto.data[i]
                let idfeik = id;
                anexoMediosDeContactoSinID.idfc01_solicitudregistro = res.data.data.idfc01_solicitudregistro
                if (anexoMediosDeContactoSinID === "") {
                    anexoMediosDeContactoSinID = null
                }
                if (anexoMediosDeContactoSinID.idfc01_anexomediosdecontacto) {
                    await axios.put(urlActualizarAnexoMediosDeContacto, { data: anexoMediosDeContactoSinID })
                    anexoMediosDeContactoSinID.id = idfeik;
                } else {
                    await axios.post(urlAnexoMediosDeContacto, { data: anexoMediosDeContactoSinID })
                }
            }
            for (let i in anexoPredio.data) {
                const {id, fc_01_archivosviveros, ...anexoPredioSinID} = anexoPredio.data[i]
                let idfeik = id;
                anexoPredioSinID.idfc01_solicitudregistro = res.data.data.idfc01_solicitudregistro
                if (anexoPredioSinID === "") {
                    anexoPredioSinID = null
                }
                if (anexoPredioSinID.idfc01_anexopredios) {
                    await axios.put(urlActualizarAnexoPredios, { data: anexoPredioSinID })
                    anexoPredioSinID.id = idfeik;
                    if(archivosViveros[0]){
                        for (const j in archivosViveros) {
                            if(archivosViveros[j].idAnexo === id){
                                archivosViveros[j].idAnexoFK = anexoPredioSinID.idfc01_anexopredios
                                await agregarFile(archivosViveros[j], 'FC_01/agregarNuevoArchivoAnexosViveros')
                            }
                        }
                    }
                } else {
                    const resAnexo = await axios.post(urlAnexoPredios, { data: anexoPredioSinID })
                    if(archivosViveros[0]){
                        for (const j in archivosViveros) {
                            if(archivosViveros[j].idAnexo === id){
                                archivosViveros[j].idAnexoFK = resAnexo.data.data.idfc01_anexopredios
                                await agregarFile(archivosViveros[j], 'FC_01/agregarNuevoArchivoAnexosViveros')
                            }
                        }
                    }
                }
            }
            return {}
        } catch (error) {
            console.log(error);
        }    
    }
)

export const agregarFileFC_01 = createAsyncThunk(
    AGREGAR_ARCHIVO_FC_01_EXITO,
    async(data) => {
        try {
            
            const {archivo, ruta} = data
            const result = await agregarFile(archivo, ruta)
            return result
        } catch (error) {
            console.log(error);
        }    
    }
)

export const actualizarFileFC_01 = createAsyncThunk(
    ACTUALIZAR_ARCHIVO_FC_01_EXITO,
    async(data) => {
        try {
            const {archivo, ruta} = data
            const result = await actualizarFile(archivo, ruta)
            return result
        } catch (error) {
            console.log(error);
        }    
    }
)

export const eliminarFileFC_01 = createAsyncThunk(
    ELIMINAR_ARCHIVO_FC_01_EXITO,
    async(data) => {
        try {
            const {archivo, ruta} = data
            const result = await axios.delete(host + ruta + "/"+ archivo.idAnexo)
            return result
        } catch (error) {
            console.log(error);
        }    
    }
)

const agregarFile = async (data, url) => {
    let formData = new FormData();
    formData.append(1, data.file)
    formData.append('nameId', data.id)
    formData.append('idSolicitud', data.idAnexoFK)
    const resFile = await axios.post(host + url, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
    return resFile
}
export const agregarFC_01SolicitudBorrador = createAsyncThunk(
    AGREGAR_FC_01_BORRADOR_EXITO,
    async (data) => {
        try {
            let solicitud = { data: data.solicitud }
            let anexoAlmacen = { data: data.anexoUnidadAlmacen }
            let anexoProduccion = { data: data.anexoUnidadProduccion }
            let anexoEnvasado = { data: data.anexoUnidadEnvasado }
            let anexoMarcas = { data: data.marcas }
            let anexoPersonasAut = { data: data.personasAutorizadas }
            let anexoRepresentantesLegales = { data: data.representantesLegales }

            let anexoMediosDeContacto = { data: data.mediosDeContacto }
            let anexoPredios = { data: data.predios }
            let anexoProductor = { data: data.productor }
            let anexoMarcasProductoConMezcal = { data: data.marcasProductoConMezcal }

            const anexoInstalaciones = {data: data.anexoInstalaciones}
            const agregarFC_01 = host + 'FC_01/agregarNuevoFC_01Solicitud'
            const urlAnexosUnidadProduccion = host + 'FC_01/agregarNuevoFC_01AnexoUnidadDeProduccion'
            const urlAnexosUnidadAlmacen = host + 'FC_01/agregarNuevoFC_01AnexoUnidadAlmacen'
            const urlAnexosUnidadEnvasado = host + 'FC_01/agregarNuevoFC_01AnexoUnidadDeEnvasado'
            const urlAnexosMarcas = host + 'FC_01/agregarNuevoFC_01AnexoMarcas'
            const urlAnexoPersonasAutorizadas = host + 'FC_01/agregarNuevoFC_01AnexoPersonaAutorizadaTramites'
            const urlAnexoRepresentantesLegales = host + 'FC_01/agregarNuevoFC_01AnexoPersonaAutorizada'
            const urlAnexoMediosDeContacto = host + 'FC_01/agregarNuevoFC_01AnexoMediosDeContacto'
            const urlAnexoPredios = host + 'FC_01/agregarNuevoFC_01AnexoVivero'
            const urlAnexo = host + 'FC_01/agregarNuevoAnexo'
            const urlInformacionGeneral = host + 'FC_01/agregarNuevaInformacionGeneral'
            const urlInstalacion = host + 'FC_01/agregarNuevaInstalacion'
            const urlDataElemento = host + 'FC_01/agregarNuevaDataElemento'
            const urlAnexoProductor = host + 'FC_01/agregarNuevoFC_01AnexoProductor'
            const urlResponsable = host + 'FC_01/agregarNuevoResponsable'
            const urlAnexosMarcasProductoConMezcal = host + 'FC_01/agregarNuevoFC_01marcaProductorConMezcal'
            const res = await axios.post(agregarFC_01, solicitud)

            
            for (let i in anexoProductor.data) {
                const {id, ...anexoProductorSinID} = anexoProductor.data[i]
                anexoProductorSinID.idfc01_solicitudregistro = res.data.data.idfc01_solicitudregistro
                if (anexoProductorSinID === "") {
                    anexoProductorSinID = null
                }
                await axios.post(urlAnexoProductor, { data: anexoProductorSinID })
            }

            //Instalaciones
            for(let i in anexoInstalaciones.data){
                const {id, responsables, domicilio, anexo, dataSeccion, opcionesSeleccionadas, tipoInstalacion, ...anexoInstalacionSinID} =  anexoInstalaciones.data[i].data
                for (let x in anexoInstalacionSinID) {
                    if (anexoInstalacionSinID[x] === "") {
                        anexoInstalacionSinID[x] = null
                    }
                }
                if(tipoInstalacion === 'Unidad Producción'){
                    const {idfc01_solicitudregistro, ...unidad} = anexoInstalacionSinID
                
                    const indormacionGeneralAgregada = await axios.post(urlInformacionGeneral, { data: unidad })
                    const idiformaciongeneral = indormacionGeneralAgregada.data.data.idiformaciongeneral
                    let dataInstalacion = {
                        idiformaciongeneral: idiformaciongeneral,
                        idtipoinstalacion: 1,
                    }
                    await axios.post(urlInstalacion, { data: dataInstalacion})
                    
                    const data = {
                        idfc01_solicitudregistro: res.data.data.idfc01_solicitudregistro,
                        idtipoanexo: 1,
                        idiformaciongeneral: idiformaciongeneral
                    }
                    const anexoAgregado = await axios.post(urlAnexo, { data })
                    const idanexo = anexoAgregado.data.data.idanexo

                    for (const responsable of responsables) {
                        const {id, estado, ...responsableSinID} = responsable
                        responsableSinID.idiformaciongeneral = idiformaciongeneral
                        if(responsableSinID.nombreresponsable !== '') await axios.post(urlResponsable, { data : responsableSinID })
                    }

                    for (const elemento of dataSeccion.coccionProduccion) {
                        const {id, opcion, capacidad, ...dataElemento} = elemento
                        dataElemento.idanexo = idanexo
                        if(dataElemento.cantidad === '') dataElemento.cantidad = null
                        if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                    }
                    for (const elemento of dataSeccion.moliendaProduccion) {
                        const {id, opcion, capacidad, ...dataElemento} = elemento
                        dataElemento.idanexo = idanexo
                        if(dataElemento.cantidad === '') dataElemento.cantidad = null
                        if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                    }
                    for (const elemento of dataSeccion.fermentacionProduccion) {
                        const {id, opcion, capacidad, ...dataElemento} = elemento
                        dataElemento.idanexo = idanexo
                        if(dataElemento.cantidad === '') dataElemento.cantidad = null
                        if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                    }
                    for (const elemento of dataSeccion.destilacionProduccion) {
                        const {id, opcion, capacidad, ...dataElemento} = elemento
                        dataElemento.idanexo = idanexo
                        if(dataElemento.cantidad === '') dataElemento.cantidad = null
                        if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                    }
                }
                if(tipoInstalacion === 'Unidad Envasado'){
                    const {idfc01_solicitudregistro, ...unidad} = anexoInstalacionSinID
                
                    const indormacionGeneralAgregada = await axios.post(urlInformacionGeneral, { data: unidad })
                    const idiformaciongeneral = indormacionGeneralAgregada.data.data.idiformaciongeneral
                    let dataInstalacion = {
                        idiformaciongeneral: idiformaciongeneral,
                        idtipoinstalacion: 2,
                    }
                    await axios.post(urlInstalacion, { data: dataInstalacion})
                    
                    const data = {
                        idfc01_solicitudregistro: res.data.data.idfc01_solicitudregistro,
                        idtipoanexo: 2,
                        idiformaciongeneral: idiformaciongeneral
                    }
                    const anexoAgregado = await axios.post(urlAnexo, { data })
                    const idanexo = anexoAgregado.data.data.idanexo
                    
                    for (const responsable of responsables) {
                        const {id, estado, ...responsableSinID} = responsable
                        responsableSinID.idiformaciongeneral = idiformaciongeneral
                        if(responsableSinID.nombreresponsable !== '') await axios.post(urlResponsable, { data : responsableSinID })
                    }

                    for (const elemento of dataSeccion.seccion1) {
                        const {id, opcion, capacidad, ...dataElemento} = elemento
                        dataElemento.idanexo = idanexo
                        if(dataElemento.cantidad === '') dataElemento.cantidad = null
                        if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                    }
                    for (const elemento of dataSeccion.seccion2) {
                        const {id, opcion, capacidad, ...dataElemento} = elemento
                        dataElemento.idanexo = idanexo
                        if(dataElemento.cantidad === '') dataElemento.cantidad = null
                        if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                    }
                    for (const elemento of dataSeccion.seccion3) {
                        const {id, opcion, capacidad, ...dataElemento} = elemento
                        dataElemento.idanexo = idanexo
                        if(dataElemento.cantidad === '') dataElemento.cantidad = null
                        if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                    }
                    for (const elemento of dataSeccion.seccion4) {
                        const {id, opcion, capacidad, ...dataElemento} = elemento
                        dataElemento.idanexo = idanexo
                        if(dataElemento.cantidad === '') dataElemento.cantidad = null
                        if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                    }
                    for (const elemento of dataSeccion.seccion5) {
                        const {id, opcion, capacidad, ...dataElemento} = elemento
                        dataElemento.idanexo = idanexo
                        if(dataElemento.cantidad === '') dataElemento.cantidad = null
                        if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                    }
                }
                if(tipoInstalacion === 'Unidad Almacén'){
                    const {tipoinstalacionanejamiento, tipoinstalacionbodega, tipoinstalaciongranel, tipoinstalacionmaduracion, tipoinstalacionreposado,idfc01_solicitudregistro, ...unidad} = anexoInstalacionSinID
                
                    const indormacionGeneralAgregada = await axios.post(urlInformacionGeneral, { data: unidad })
                    const idiformaciongeneral = indormacionGeneralAgregada.data.data.idiformaciongeneral
                    if(tipoinstalacionbodega) {
                        const data = {
                            idiformaciongeneral: idiformaciongeneral,
                            idtipoinstalacion: 3,
                        }
                        await axios.post(urlInstalacion, { data })
                    }
                    if(tipoinstalaciongranel) {
                        const data = {
                            idiformaciongeneral: idiformaciongeneral,
                            idtipoinstalacion: 4,
                        }
                        await axios.post(urlInstalacion, { data })
                    }
                    if(tipoinstalacionmaduracion) {
                        const data = {
                            idiformaciongeneral: idiformaciongeneral,
                            idtipoinstalacion: 5,
                        }
                        await axios.post(urlInstalacion, { data })
                    }
                    // if(tipoinstalacionanejamiento) {
                    //     const data = {
                    //         idiformaciongeneral: idiformaciongeneral,
                    //         idtipoinstalacion: 6,
                    //     }
                    //     await axios.post(urlInstalacion, { data })
                    // }
                    // if(tipoinstalacionreposado) {
                    //     const data = {
                    //         idiformaciongeneral: idiformaciongeneral,
                    //         idtipoinstalacion: 7,
                    //     }
                    //     await axios.post(urlInstalacion, { data })
                    // }
                    for (const responsable of responsables) {
                        const {id, estado, ...responsableSinID} = responsable
                        responsableSinID.idiformaciongeneral = idiformaciongeneral
                        if(responsableSinID.nombreresponsable !== '') await axios.post(urlResponsable, { data : responsableSinID })
                    }
                    const data = {
                        idfc01_solicitudregistro: res.data.data.idfc01_solicitudregistro,
                        idtipoanexo: 3,
                        idiformaciongeneral: idiformaciongeneral
                    }
                    const anexoAgregado = await axios.post(urlAnexo, { data })
                    const idanexo = anexoAgregado.data.data.idanexo
                    
                    if(tipoinstalacionbodega){
                        for (const elemento of dataSeccion.equipoAlmacen) {
                            const {id, opcion, capacidad, ...dataElemento} = elemento
                            dataElemento.idanexo = idanexo
                            if(dataElemento.cantidad === '') dataElemento.cantidad = null
                            if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                        }
                    }
                    if(tipoinstalaciongranel){
                        for (const elemento of dataSeccion.granelAlmacen) {
                            const {id, opcion, capacidad, ...dataElemento} = elemento
                            dataElemento.idanexo = idanexo
                            if(dataElemento.cantidad === '') dataElemento.cantidad = null
                            if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                        }
                    }
                    if(tipoinstalacionmaduracion){
                        for (const elemento of dataSeccion.maduracionAlmacen) {
                            const {id, opcion, capacidad, ...dataElemento} = elemento
                            dataElemento.idanexo = idanexo
                            if(dataElemento.cantidad === '') dataElemento.cantidad = null
                            if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                        }
                    }
                    // if(tipoinstalacionanejamiento){
                    //     for (const elemento of dataSeccion.anejamientoAlmacen) {
                    //         const {id, opcion, capacidad, ...dataElemento} = elemento
                    //         dataElemento.idanexo = idanexo
                    //         if(dataElemento.cantidad === '') dataElemento.cantidad = null
                    //         if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                    //     }
                    // }
                    // if(tipoinstalacionreposado){
                    //     for (const elemento of dataSeccion.reposadoAlmacen) {
                    //         const {id, opcion, capacidad, ...dataElemento} = elemento
                    //         dataElemento.idanexo = idanexo
                    //         if(dataElemento.cantidad === '') dataElemento.cantidad = null
                    //         if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                    //     }
                    // }
                    if(tipoinstalacionmaduracion){
                        for (const elemento of dataSeccion.variablesAlmacen) {
                            const {id, opcion, capacidad, ...dataElemento} = elemento
                            dataElemento.idanexo = idanexo
                            if(dataElemento.cantidad === '') dataElemento.cantidad = null
                            if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                        }
                    }
                }
            }

            for (let i in anexoRepresentantesLegales.data) {
                const {id, estado, ...anexoRepLeg} = anexoRepresentantesLegales.data[i]
                anexoRepLeg.idfc01_solicitudregistro = res.data.data.idfc01_solicitudregistro
                if(anexoRepLeg === "") {
                    anexoRepLeg = null
                }
                await axios.post(urlAnexoRepresentantesLegales, { data: anexoRepLeg })
            }

            for (let i in anexoPersonasAut.data) { 
                const {id, estado, ...anexoPersonasSinID} = anexoPersonasAut.data[i]
                anexoPersonasSinID.idfc01_solicitudregistro = res.data.data.idfc01_solicitudregistro
                if (anexoPersonasSinID === "") {
                    anexoPersonasSinID = null
                }
                await axios.post(urlAnexoPersonasAutorizadas, { data: anexoPersonasSinID })
            }

            for (let i in anexoMarcas.data) {
                const {id, ...anexoMarcasSinID} = anexoMarcas.data[i]
                anexoMarcasSinID.idfc01_solicitudregistro = res.data.data.idfc01_solicitudregistro
                if (anexoMarcasSinID === "") {
                    anexoMarcasSinID = null
                }
                await axios.post(urlAnexosMarcas, { data: anexoMarcasSinID })
            }
            
            for (let i in anexoMediosDeContacto.data) {
                const {id, estado, ...anexoMediosDeContactoSinID} = anexoMediosDeContacto.data[i]
                anexoMediosDeContactoSinID.idfc01_solicitudregistro = res.data.data.idfc01_solicitudregistro
                if (anexoMediosDeContactoSinID === "") {
                    anexoMediosDeContactoSinID = null
                }
                await axios.post(urlAnexoMediosDeContacto, { data: anexoMediosDeContactoSinID })
            }

            for (let i in anexoPredios.data) {
                const {id, ...anexoPrediosSinID} = anexoPredios.data[i]
                anexoPrediosSinID.idfc01_solicitudregistro = res.data.data.idfc01_solicitudregistro
                if (anexoPrediosSinID === "") {
                    anexoPrediosSinID = null
                }
                await axios.post(urlAnexoPredios, { data: anexoPrediosSinID })
            }
            for (let i in anexoMarcasProductoConMezcal.data) {
                const {id, ...anexoMarcasSinID} = anexoMarcasProductoConMezcal.data[i]
                anexoMarcasSinID.idfc01_solicitudregistro = res.data.data.idfc01_solicitudregistro
                if (anexoMarcasSinID === "") {
                    anexoMarcasSinID = null
                }
                await axios.post(urlAnexosMarcasProductoConMezcal, { data: anexoMarcasSinID })
            }

            return {
                solicitud,
                anexoAlmacen,
                anexoEnvasado,
                anexoMarcas,
                anexoPersonasAut,
                anexoProduccion,
                anexoRepresentantesLegales,
                anexoMediosDeContacto,
                anexoPredios
            }
        } catch (error) {
            console.log(error)
        }
    }
)

export const agregarFC_01Solicitud = createAsyncThunk(
    AGREGAR_FC_01_EXITO,
    async(data) => {
        try {
            const solicitud = { data: data.solicitud }
            const anexoAlmacen = { data: data.anexoUnidadAlmacen }
            const anexoProduccion = { data: data.anexoUnidadProduccion }
            const anexoEnvasado = { data: data.anexoUnidadEnvasado }
            const anexoMarcas = { data: data.marcas }
            const anexoPersonasAut = { data: data.personasAutorizadas }
            const anexoRepresentantesLegales = { data: data.representantesLegales }
            const anexoMediosDeContacto = { data: data.mediosDeContacto }
            const anexoPredios = { data: data.predios}
            const anexoProductor = { data: data.productor}
            // const archivos = data.files
            const anexoInstalaciones = {data: data.anexoInstalaciones}
            // const archivosPredios = data.filesPredios
            // const archivosViveros = data.filesViveros
            // const archivosApoderadosLeg = data.filesApoderadosLeg
            // const archivosPersonaAut = data.filesPersonasAut
            // const archivosMarcas = data.filesMarcas
            // const archivosMarcasProduct = data.filesMarcasProduct
            // const archivosInstalaciones = data.filesInstalaciones

            const urlAnexosMarcasProductoConMezcal = host + 'FC_01/agregarNuevoFC_01marcaProductorConMezcal'
            let anexoMarcasProductoConMezcal = { data: data.marcasProductoConMezcal }
            
            const agregarFC_01 = host + 'FC_01/agregarNuevoFC_01Solicitud'
            const urlAnexosMarcas = host + 'FC_01/agregarNuevoFC_01AnexoMarcas'
            const urlAnexoPersonasAutorizadas = host + 'FC_01/agregarNuevoFC_01AnexoPersonaAutorizadaTramites'
            const urlAnexoRepresentantesLegales = host + 'FC_01/agregarNuevoFC_01AnexoPersonaAutorizada'
            const urlAnexoMediosDeContacto = host + 'FC_01/agregarNuevoFC_01AnexoMediosDeContacto'
            const urlAnexoPredios = host + 'FC_01/agregarNuevoFC_01AnexoVivero'
            const urlAnexo = host + 'FC_01/agregarNuevoAnexo'
            const urlInformacionGeneral = host + 'FC_01/agregarNuevaInformacionGeneral'
            const urlInstalacion = host + 'FC_01/agregarNuevaInstalacion'
            const urlDataElemento = host + 'FC_01/agregarNuevaDataElemento'
            const urlAnexoProductor = host + 'FC_01/agregarNuevoFC_01AnexoProductor'
            const urlResponsable = host + 'FC_01/agregarNuevoResponsable'

            const urlArchivosMarca = host + 'FC_01/agregarNuevoArchivoAnexoDeMarca'
            const urlArchivosPersonaAut = host + 'FC_01/agregarNuevoArchivoAnexosPersonaAutorizada'
            const urlArchivosRepresentante = host + 'FC_01/agregarNuevoArchivoAnexosRepresentanteLegal'
            const urlArchivosInstalacion = host + 'FC_01/agregarNuevoArchivoAnexosDeInstalacion'

            const res = await axios.post(agregarFC_01, solicitud)

            for (let i in anexoMarcasProductoConMezcal.data) {
                const {id, ...anexoMarcasSinID} = anexoMarcasProductoConMezcal.data[i]
                anexoMarcasSinID.idfc01_solicitudregistro = res.data.data.idfc01_solicitudregistro
                if (anexoMarcasSinID === "") {
                    anexoMarcasSinID = null
                }
                const resultAnexo = await axios.post(urlAnexosMarcasProductoConMezcal, { data: anexoMarcasSinID })
                
                const idfc01_anexomarcasproductoconmezcal = resultAnexo.data.data.idfc01_anexomarcasproductoconmezcal
                // for (const j in archivosMarcasProduct) {
                //     if(archivosMarcasProduct[j].idAnexo === id){
                //         archivosMarcasProduct[j].idAnexoFK = idfc01_anexomarcasproductoconmezcal
                //         await agregarFile(archivosMarcasProduct[j], 'FC_01/agregarNuevoArchivoAnexoMarcaProducto')
                //     }
                // }
            }
            
            for (let i in anexoPersonasAut.data) {
                const {id, estado, ...anexoPersonasSinID} = anexoPersonasAut.data[i]
                anexoPersonasSinID.idfc01_solicitudregistro = res.data.data.idfc01_solicitudregistro
                if (anexoPersonasSinID === "") {
                    anexoPersonasSinID = null
                }
                const resultAnexo = await axios.post(urlAnexoPersonasAutorizadas, { data: anexoPersonasSinID })
                
                const idfc01_anexopersonaatorizadatramites = resultAnexo.data.data.idfc01_anexopersonaatorizadatramites
                // for (const j in archivosPersonaAut) {
                //     if(archivosPersonaAut[j].idAnexo === id){
                //         archivosPersonaAut[j].idAnexoFK = idfc01_anexopersonaatorizadatramites
                //         await agregarFile(archivosPersonaAut[j], 'FC_01/agregarNuevoArchivoAnexosPersonaAutorizada')
                //     }
                // }
            }

            // for (let i in archivos) {
            //     archivos[i].idAnexoFK = res.data.data.idfc01_solicitudregistro
            //     await agregarFile(archivos[i], 'FC_01/agregarAnexosArchivosFC_01')
            // }

            //predios
            for (let i in anexoProductor.data) {
                const {id, ...anexoProductorSinID} = anexoProductor.data[i]
                anexoProductorSinID.idfc01_solicitudregistro = res.data.data.idfc01_solicitudregistro
                if (anexoProductorSinID === "") {
                    anexoProductorSinID = null
                }
                const resultPredio = await axios.post(urlAnexoProductor, { data: anexoProductorSinID })
                const idfc01_anexoproductor = resultPredio.data.data.idfc01_anexoproductor
            }

            for (let i in anexoRepresentantesLegales.data) {
                const {id, estado, ...anexoRepLeg} = anexoRepresentantesLegales.data[i]
                anexoRepLeg.idfc01_solicitudregistro = res.data.data.idfc01_solicitudregistro
                if(anexoRepLeg === "") {
                    anexoRepLeg = null
                }
                const resultAnexo = await axios.post(urlAnexoRepresentantesLegales, { data: anexoRepLeg })
                const idfc01_anexorepresentantelegal = resultAnexo.data.data.idfc01_anexorepresentantelegal
                // for (const j in archivosApoderadosLeg) {
                //     if(archivosApoderadosLeg[j].idAnexo === id){
                //         archivosApoderadosLeg[j].idAnexoFK = idfc01_anexorepresentantelegal
                //         await agregarFile(archivosApoderadosLeg[j], 'FC_01/agregarNuevoArchivoAnexosRepresentanteLegal')
                //     }
                // }
            }
    
            for (let i in anexoMarcas.data) {
                const {id, ...anexoMarcasSinID} = anexoMarcas.data[i]
                anexoMarcasSinID.idfc01_solicitudregistro = res.data.data.idfc01_solicitudregistro
                if (anexoMarcasSinID === "") {
                    anexoMarcasSinID = null
                }
                const resultAnexo = await axios.post(urlAnexosMarcas, { data: anexoMarcasSinID })
                const idfc01_anexomarcas = resultAnexo.data.data.idfc01_anexomarcas
                // for (const j in archivosMarcas) {
                //     if(archivosMarcas[j].idAnexo === id){
                //         archivosMarcas[j].idAnexoFK = idfc01_anexomarcas
                //         await agregarFile(archivosMarcas[j], 'FC_01/agregarNuevoArchivoAnexoDeMarca')
                //     }
                // }
            }

            for (let i in anexoMediosDeContacto.data) {
                const {id, estado, ...anexoMediosDeContactoSinID} = anexoMediosDeContacto.data[i]
                anexoMediosDeContactoSinID.idfc01_solicitudregistro = res.data.data.idfc01_solicitudregistro
                if (anexoMediosDeContactoSinID === "") {
                    anexoMediosDeContactoSinID = null
                }
                await axios.post(urlAnexoMediosDeContacto, { data: anexoMediosDeContactoSinID })
            }
            //viveros
            for (let i in anexoPredios.data) {
                const {id, ...anexoPredioSinID} = anexoPredios.data[i]
                anexoPredioSinID.idfc01_solicitudregistro = res.data.data.idfc01_solicitudregistro
                if (anexoPredioSinID === "") {
                    anexoPredioSinID = null
                }
                const resultAnexo = await axios.post(urlAnexoPredios, { data: anexoPredioSinID })
                const idfc01_anexopredios = resultAnexo.data.data.idfc01_anexopredios
                // for (const j in archivosViveros) {
                //     if(archivosViveros[j].idAnexo === id){
                //         archivosViveros[j].idAnexoFK = idfc01_anexopredios
                //         await agregarFile(archivosViveros[j], 'FC_01/agregarNuevoArchivoAnexosViveros')
                //     }
                // }
            }

            //Instalaciones
            for(let i in anexoInstalaciones.data){
                const {id, responsables, domicilio, anexo, dataSeccion, opcionesSeleccionadas, tipoInstalacion, ...anexoInstalacionSinID} =  anexoInstalaciones.data[i].data
                
                for (let x in anexoInstalacionSinID) {
                    if (anexoInstalacionSinID[x] === "") {
                        anexoInstalacionSinID[x] = null
                    }
                }
                if(tipoInstalacion === 'Unidad Producción'){
                    const {idfc01_solicitudregistro, ...unidad} = anexoInstalacionSinID
                    
                    const indormacionGeneralAgregada = await axios.post(urlInformacionGeneral, { data: unidad })
                    const idiformaciongeneral = indormacionGeneralAgregada.data.data.idiformaciongeneral
                    let dataInstalacion = {
                        idiformaciongeneral: idiformaciongeneral,
                        idtipoinstalacion: 1,
                    }
                    await axios.post(urlInstalacion, { data: dataInstalacion})
                    
                    const data = {
                        idfc01_solicitudregistro: res.data.data.idfc01_solicitudregistro,
                        idtipoanexo: 1,
                        idiformaciongeneral: idiformaciongeneral
                    }
                    const anexoAgregado = await axios.post(urlAnexo, { data })
                    const idanexo = anexoAgregado.data.data.idanexo
                    
                    for (const responsable of responsables) {
                        const {id, estado, ...responsableSinID} = responsable
                        responsableSinID.idiformaciongeneral = idiformaciongeneral
                        if(responsableSinID.nombreresponsable !== '') {
                            const resResponsable = await axios.post(urlResponsable, { data : responsableSinID })
                            const idRespon = resResponsable.data.data.idresponsabledeinstalacion
                            // for (const j in archivosInstalaciones) {
                            //     if(archivosInstalaciones[j].idAnexo === id){
                            //         archivosInstalaciones[j].idAnexoFK = idRespon
                            //         await agregarFile(archivosInstalaciones[j], 'FC_01/agregarNuevoArchivoResponsable')
                            //     }
                            // }

                        }
                    }
                    for (const elemento of dataSeccion.coccionProduccion) {
                        const {id, opcion, capacidad, ...dataElemento} = elemento
                        dataElemento.idanexo = idanexo
                        if(dataElemento.cantidad === '') dataElemento.cantidad = null
                        if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                    }
                    for (const elemento of dataSeccion.moliendaProduccion) {
                        const {id, opcion, capacidad, ...dataElemento} = elemento
                        dataElemento.idanexo = idanexo
                        if(dataElemento.cantidad === '') dataElemento.cantidad = null
                        if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                    }
                    for (const elemento of dataSeccion.fermentacionProduccion) {
                        const {id, opcion, capacidad, ...dataElemento} = elemento
                        dataElemento.idanexo = idanexo
                        if(dataElemento.cantidad === '') dataElemento.cantidad = null
                        if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                    }
                    for (const elemento of dataSeccion.destilacionProduccion) {
                        const {id, opcion, capacidad, ...dataElemento} = elemento
                        dataElemento.idanexo = idanexo
                        if(dataElemento.cantidad === '') dataElemento.cantidad = null
                        if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                    }
                    
                    // for (const j in archivosInstalaciones) {
                    //     if(archivosInstalaciones[j].idAnexo === id){
                    //         archivosInstalaciones[j].idAnexoFK = idanexo
                    //         await agregarFile(archivosInstalaciones[j], 'FC_01/agregarNuevoArchivoAnexoInstalacion')
                    //     }
                    // }
                }
                if(tipoInstalacion === 'Unidad Envasado'){
                    const {idfc01_solicitudregistro, ...unidad} = anexoInstalacionSinID
                
                    const indormacionGeneralAgregada = await axios.post(urlInformacionGeneral, { data: unidad })
                    const idiformaciongeneral = indormacionGeneralAgregada.data.data.idiformaciongeneral
                    let dataInstalacion = {
                        idiformaciongeneral: idiformaciongeneral,
                        idtipoinstalacion: 2,
                    }
                    await axios.post(urlInstalacion, { data: dataInstalacion})
                    
                    const data = {
                        idfc01_solicitudregistro: res.data.data.idfc01_solicitudregistro,
                        idtipoanexo: 2,
                        idiformaciongeneral: idiformaciongeneral
                    }
                    const anexoAgregado = await axios.post(urlAnexo, { data })
                    const idanexo = anexoAgregado.data.data.idanexo
                    
                    for (const responsable of responsables) {
                        const {id, estado, ...responsableSinID} = responsable
                        responsableSinID.idiformaciongeneral = idiformaciongeneral
                        if(responsableSinID.nombreresponsable !== '') {
                            const resResponsable = await axios.post(urlResponsable, { data : responsableSinID })
                            const idRespon = resResponsable.data.data.idresponsabledeinstalacion
                            // for (const j in archivosInstalaciones) {
                            //     if(archivosInstalaciones[j].idAnexo === id){
                            //         archivosInstalaciones[j].idAnexoFK = idRespon
                            //         await agregarFile(archivosInstalaciones[j], 'FC_01/agregarNuevoArchivoResponsable')
                            //     }
                            // }
                        }
                    }

                    for (const elemento of dataSeccion.seccion1) {
                        const {id, opcion, capacidad, ...dataElemento} = elemento
                        dataElemento.idanexo = idanexo
                        if(dataElemento.cantidad === '') dataElemento.cantidad = null
                        if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                    }
                    for (const elemento of dataSeccion.seccion2) {
                        const {id, opcion, capacidad, ...dataElemento} = elemento
                        dataElemento.idanexo = idanexo
                        if(dataElemento.cantidad === '') dataElemento.cantidad = null
                        if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                    }
                    for (const elemento of dataSeccion.seccion3) {
                        const {id, opcion, capacidad, ...dataElemento} = elemento
                        dataElemento.idanexo = idanexo
                        if(dataElemento.cantidad === '') dataElemento.cantidad = null
                        if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                    }
                    for (const elemento of dataSeccion.seccion4) {
                        const {id, opcion, capacidad, ...dataElemento} = elemento
                        dataElemento.idanexo = idanexo
                        if(dataElemento.cantidad === '') dataElemento.cantidad = null
                        if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                    }
                    for (const elemento of dataSeccion.seccion5) {
                        const {id, opcion, capacidad, ...dataElemento} = elemento
                        dataElemento.idanexo = idanexo
                        if(dataElemento.cantidad === '') dataElemento.cantidad = null
                        if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                    }
                    
                    // for (const j in archivosInstalaciones) {
                    //     if(archivosInstalaciones[j].idAnexo === id){
                    //         archivosInstalaciones[j].idAnexoFK = idanexo
                    //         await agregarFile(archivosInstalaciones[j], 'FC_01/agregarNuevoArchivoAnexoInstalacion')
                    //     }
                    // }
                }
                if(tipoInstalacion === 'Unidad Almacén'){
                    const {tipoinstalacionanejamiento, tipoinstalacionbodega, tipoinstalaciongranel, tipoinstalacionmaduracion, tipoinstalacionreposado, idfc01_solicitudregistro, ...unidad} = anexoInstalacionSinID
                
                    const indormacionGeneralAgregada = await axios.post(urlInformacionGeneral, { data: unidad })
                    const idiformaciongeneral = indormacionGeneralAgregada.data.data.idiformaciongeneral
                    if(tipoinstalacionbodega) {
                        const data = {
                            idiformaciongeneral: idiformaciongeneral,
                            idtipoinstalacion: 3,
                        }
                        await axios.post(urlInstalacion, { data })
                    }
                    if(tipoinstalaciongranel) {
                        const data = {
                            idiformaciongeneral: idiformaciongeneral,
                            idtipoinstalacion: 4,
                        }
                        await axios.post(urlInstalacion, { data })
                    }
                    if(tipoinstalacionmaduracion) {
                        const data = {
                            idiformaciongeneral: idiformaciongeneral,
                            idtipoinstalacion: 5,
                        }
                        await axios.post(urlInstalacion, { data })
                    }
                    // if(tipoinstalacionanejamiento) {
                    //     const data = {
                    //         idiformaciongeneral: idiformaciongeneral,
                    //         idtipoinstalacion: 6,
                    //     }
                    //     await axios.post(urlInstalacion, { data })
                    // }
                    // if(tipoinstalacionreposado) {
                    //     const data = {
                    //         idiformaciongeneral: idiformaciongeneral,
                    //         idtipoinstalacion: 7,
                    //     }
                    //     await axios.post(urlInstalacion, { data })
                    // }
                    for (const responsable of responsables) {
                        const {id, estado, ...responsableSinID} = responsable
                        responsableSinID.idiformaciongeneral = idiformaciongeneral
                        if(responsableSinID.nombreresponsable !== '') {
                            const resResponsable = await axios.post(urlResponsable, { data : responsableSinID })
                            const idRespon = resResponsable.data.data.idresponsabledeinstalacion
                            // for (const j in archivosInstalaciones) {
                            //     if(archivosInstalaciones[j].idAnexo === id){
                            //         archivosInstalaciones[j].idAnexoFK = idRespon
                            //         await agregarFile(archivosInstalaciones[j], 'FC_01/agregarNuevoArchivoResponsable')
                            //     }
                            // }
                        }
                    }
                    const data = {
                        idfc01_solicitudregistro: res.data.data.idfc01_solicitudregistro,
                        idtipoanexo: 3,
                        idiformaciongeneral: idiformaciongeneral
                    }
                    const anexoAgregado = await axios.post(urlAnexo, { data })
                    const idanexo = anexoAgregado.data.data.idanexo
                    
                    if(tipoinstalacionbodega){
                        for (const elemento of dataSeccion.equipoAlmacen) {
                            const {id, opcion, capacidad, ...dataElemento} = elemento
                            dataElemento.idanexo = idanexo
                            if(dataElemento.cantidad === '') dataElemento.cantidad = null
                            if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                        }
                    }
                    if(tipoinstalaciongranel){
                        for (const elemento of dataSeccion.granelAlmacen) {
                            const {id, opcion, capacidad, ...dataElemento} = elemento
                            dataElemento.idanexo = idanexo
                            if(dataElemento.cantidad === '') dataElemento.cantidad = null
                            if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                        }
                    }
                    if(tipoinstalacionmaduracion){
                        for (const elemento of dataSeccion.maduracionAlmacen) {
                            const {id, opcion, capacidad, ...dataElemento} = elemento
                            dataElemento.idanexo = idanexo
                            if(dataElemento.cantidad === '') dataElemento.cantidad = null
                            if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                        }
                    }
                    // if(tipoinstalacionanejamiento){
                    //     for (const elemento of dataSeccion.anejamientoAlmacen) {
                    //         const {id, opcion, capacidad, ...dataElemento} = elemento
                    //         dataElemento.idanexo = idanexo
                    //         if(dataElemento.cantidad === '') dataElemento.cantidad = null
                    //         if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                    //     }
                    // }
                    // if(tipoinstalacionreposado){
                    //     for (const elemento of dataSeccion.reposadoAlmacen) {
                    //         const {id, opcion, capacidad, ...dataElemento} = elemento
                    //         dataElemento.idanexo = idanexo
                    //         if(dataElemento.cantidad === '') dataElemento.cantidad = null
                    //         if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                    //     }
                    // }
                    if(tipoinstalacionmaduracion){
                        for (const elemento of dataSeccion.variablesAlmacen) {
                            const {id, opcion, capacidad, ...dataElemento} = elemento
                            dataElemento.idanexo = idanexo
                            if(dataElemento.cantidad === '') dataElemento.cantidad = null
                            if(opcion !== '') await axios.post(urlDataElemento, { data: dataElemento })
                        }
                    }
                    // for (const j in archivosInstalaciones) {
                    //     if(archivosInstalaciones[j].idAnexo === id){
                    //         archivosInstalaciones[j].idAnexoFK = idanexo
                    //         await agregarFile(archivosInstalaciones[j], 'FC_01/agregarNuevoArchivoAnexoInstalacion')
                    //     }
                    // }
                }
            }
    
            return res
        } catch (error) {
            console.log(error)
        }
    }
)

export const obtenerFC_01SolicitudDetalle = createAsyncThunk(
    OBTENER_FC_01_DETALLE_EXITO,
    async(idSolicitud) => {
        try {
            const fullUrl = host + `FC_01/obtenerUnaSolicitudFC_01Detalle/${idSolicitud}`
            const res = await axios.get(fullUrl)
            let anexoUnidadAlmacen = []
            let anexoUnidadEnvasado = []
            let anexoUnidadProduccion = []
            let anexoPersonasAut = []
            let anexoRepresentantesLegales = []
            let anexoMarcas = []
            let anexoMediosDeContacto = []
            let anexoPredio = []
            let anexoProductor = []
            let anexoInstalaciones = []
            let anexomarcasProductoConMezcal = []
            // for (let i in res.data.data.fc_01_anexounidaddeproduccion) {
            //     res.data.data.fc_01_anexounidaddeproduccion[i]['id'] = uuidv4()
            //     anexoUnidadProduccion.push( { data: res.data.data.fc_01_anexounidaddeproduccion[i] })
            // }
            

            // for (let i in res.data.data.fc_01_anexounidaddealmacen) {
            //     res.data.data.fc_01_anexounidaddealmacen[i]['id'] = uuidv4()
            //     anexoUnidadAlmacen.push({ data: res.data.data.fc_01_anexounidaddealmacen[i] })
            // }
    
            // for (let i in res.data.data.fc_01_anexounidaddeenvasado) {
            //     res.data.data.fc_01_anexounidaddeenvasado[i]['id'] = uuidv4()
            //     anexoUnidadEnvasado.push({ data: res.data.data.fc_01_anexounidaddeenvasado[i] })
            // }
            let maxNumeroDeInstlacion = 0
            for (const anexo of res.data.data.anexo) {
                anexo.informaciongeneral.id = uuidv4()
                anexo.informaciongeneral.idfc01_solicitudregistro = anexo.idfc01_solicitudregistro
                anexo.informaciongeneral.idanexo = anexo.idanexo
                let domicilio = ''
                if(anexo.informaciongeneral.calle !== null){
                    if(anexo.informaciongeneral.calle === 'Otro'){
                        domicilio += anexo.informaciongeneral.otracalle + ', '
                    }
                }
                if(anexo.informaciongeneral.colonia !== null){
                    domicilio += anexo.informaciongeneral.colonia + ', '
                }
                if(anexo.informaciongeneral.localidad !== null){
                    domicilio += anexo.informaciongeneral.localidad + ', '
                }
                if(anexo.informaciongeneral.municipio !== null){
                    domicilio += anexo.informaciongeneral.municipio + ', '
                }
                if(anexo.informaciongeneral.estado !== null){
                    domicilio += anexo.informaciongeneral.estado + ', '
                }
                if(anexo.informaciongeneral.codigopostal !== null){
                    domicilio += anexo.informaciongeneral.codigopostal + ', '
                }
                if(domicilio === '') domicilio = 'No se asignó un domicilio'
                anexo.informaciongeneral.domicilio = domicilio

                for(let i in anexo.informaciongeneral.responsablesdeinstalacion) {
                    let estado = await comprobarEmail(anexo.informaciongeneral.responsablesdeinstalacion[i].correoelectronico)
                    anexo.informaciongeneral.responsablesdeinstalacion[i]['estado'] = estado
                }

                const responsables = anexo.informaciongeneral.responsablesdeinstalacion
                delete anexo.informaciongeneral.responsablesdeinstalacion
                anexo.informaciongeneral.responsables = responsables
                
                if(anexo.informaciongeneral.instalacionnumero > maxNumeroDeInstlacion) maxNumeroDeInstlacion = anexo.informaciongeneral.instalacionnumero

                if(anexo.idtipoanexo === 1){
                    let coccionProduccion = []
                    let moliendaProduccion = []
                    let fermentacionProduccion = []
                    let destilacionProduccion = []
                    let granelProduccion = []

                    let opcionesSeleccionadosSeccion1 = []
                    let opcionesSeleccionadosSeccion2 = []
                    let opcionesSeleccionadosSeccion3 = []
                    let opcionesSeleccionadosSeccion4 = []
                    let opcionesSeleccionadosSeccion5 = []

                    for (const elemento of anexo.dataelemento) {
                        elemento.opcion = elemento.elemento.nombreelemento
                        switch(elemento.idseccion){
                            case 1: 
                                opcionesSeleccionadosSeccion1.push({nombre: elemento.elemento.nombreelemento})
                                delete elemento.elemento
                                coccionProduccion.push(elemento)
                                break
                            case 2: 
                                opcionesSeleccionadosSeccion2.push({nombre: elemento.elemento.nombreelemento})
                                delete elemento.elemento
                                moliendaProduccion.push(elemento)
                                break
                            case 3: 
                                opcionesSeleccionadosSeccion3.push({nombre: elemento.elemento.nombreelemento})
                                delete elemento.elemento
                                fermentacionProduccion.push(elemento)
                                break
                            case 4: 
                                opcionesSeleccionadosSeccion4.push({nombre: elemento.elemento.nombreelemento})
                                delete elemento.elemento
                                destilacionProduccion.push(elemento)
                                break
                            // case 5: 
                            //     opcionesSeleccionadosSeccion5.push({nombre: elemento.elemento.nombreelemento})
                            //     granelProduccion.push(elemento)
                            //     break
                            default:
                                break
                        }
                        let dataSeccion = {
                            coccionProduccion,
                            moliendaProduccion,
                            fermentacionProduccion,
                            destilacionProduccion,
                            granelProduccion
                        }
                        const opcionesSeleccionadas = {
                            opcionesSeleccionadosSeccion1,
                            opcionesSeleccionadosSeccion2,
                            opcionesSeleccionadosSeccion3,
                            opcionesSeleccionadosSeccion4,
                            opcionesSeleccionadosSeccion5
                        }
                        anexo.informaciongeneral.dataSeccion = dataSeccion
                        anexo.informaciongeneral.opcionesSeleccionadas = opcionesSeleccionadas
                    }
                    delete anexo.informaciongeneral.instalaciones
                    anexo.informaciongeneral.tipoInstalacion = 'Unidad Producción'
                    anexoInstalaciones.push({ data: anexo.informaciongeneral })
                }
                if(anexo.idtipoanexo === 2){
                    let seccion1 = []
                    let seccion2 = []
                    let seccion3 = []
                    let seccion4 = []
                    let seccion5 = []

                    let opcionesSeleccionadosSeccion1 = []
                    let opcionesSeleccionadosSeccion2 = []
                    let opcionesSeleccionadosSeccion3 = []
                    let opcionesSeleccionadosSeccion4 = []
                    let opcionesSeleccionadosSeccion5 = []

                    for (const elemento of anexo.dataelemento) {
                        elemento.opcion = elemento.elemento.nombreelemento
                        switch(elemento.idseccion){
                            case 6: 
                                opcionesSeleccionadosSeccion1.push({nombre: elemento.elemento.nombreelemento})
                                delete elemento.elemento
                                seccion1.push(elemento)
                                break
                            case 7: 
                                opcionesSeleccionadosSeccion2.push({nombre: elemento.elemento.nombreelemento})
                                delete elemento.elemento
                                seccion2.push(elemento)
                                break
                            case 8: 
                                opcionesSeleccionadosSeccion3.push({nombre: elemento.elemento.nombreelemento})
                                delete elemento.elemento
                                seccion3.push(elemento)
                                break
                            case 9: 
                                opcionesSeleccionadosSeccion4.push({nombre: elemento.elemento.nombreelemento})
                                delete elemento.elemento
                                seccion4.push(elemento)
                                break
                            case 10: 
                                opcionesSeleccionadosSeccion5.push({nombre: elemento.elemento.nombreelemento})
                                delete elemento.elemento
                                seccion5.push(elemento)
                                break
                            default:
                                break
                        }
                        let dataSeccion = {
                            seccion1,
                            seccion2,
                            seccion3,
                            seccion4,
                            seccion5
                        }
                        const opcionesSeleccionadas = {
                            opcionesSeleccionadosSeccion1,
                            opcionesSeleccionadosSeccion2,
                            opcionesSeleccionadosSeccion3,
                            opcionesSeleccionadosSeccion4,
                            opcionesSeleccionadosSeccion5
                        }
                        anexo.informaciongeneral.dataSeccion = dataSeccion
                        anexo.informaciongeneral.opcionesSeleccionadas = opcionesSeleccionadas
                    }
                    delete anexo.informaciongeneral.instalaciones
                    anexo.informaciongeneral.tipoInstalacion = 'Unidad Envasado'
                    anexoInstalaciones.push({ data: anexo.informaciongeneral })
                }
                if(anexo.idtipoanexo === 3){
                    let equipoAlmacen = []
                    let maduracionAlmacen = []
                    let variablesAlmacen = []
                    let granelAlmacen = []
                    let anejamientoAlmacen = []
                    let reposadoAlmacen = []
                    
                    let opcionesSeleccionadosSeccion1 = []
                    let opcionesSeleccionadosSeccion2 = []
                    let opcionesSeleccionadosSeccion3 = []
                    let opcionesSeleccionadosSeccion4 = []
                    let opcionesSeleccionadosSeccion5 = []
                    let opcionesSeleccionadosSeccion6 = []
                    
                    for (const elemento of anexo.dataelemento) {
                        elemento.opcion = elemento.elemento.nombreelemento
                        switch(elemento.idseccion){
                            case 11: 
                                opcionesSeleccionadosSeccion1.push({nombre: elemento.elemento.nombreelemento})
                                delete elemento.elemento
                                equipoAlmacen.push(elemento)
                                break
                            case 5: 
                                opcionesSeleccionadosSeccion4.push({nombre: elemento.elemento.nombreelemento})
                                delete elemento.elemento
                                granelAlmacen.push(elemento)
                                break
                            case 12: 
                                opcionesSeleccionadosSeccion2.push({nombre: elemento.elemento.nombreelemento})
                                delete elemento.elemento
                                maduracionAlmacen.push(elemento)
                                break
                            // case 13: 
                            //     opcionesSeleccionadosSeccion5.push({nombre: elemento.elemento.nombreelemento})
                            //     delete elemento.elemento
                            //     anejamientoAlmacen.push(elemento)
                            //     break
                            // case 14: 
                            //     opcionesSeleccionadosSeccion6.push({nombre: elemento.elemento.nombreelemento})
                            //     delete elemento.elemento
                            //     reposadoAlmacen.push(elemento)
                            //     break
                            case 13: 
                                opcionesSeleccionadosSeccion3.push({nombre: elemento.elemento.nombreelemento})
                                delete elemento.elemento
                                variablesAlmacen.push(elemento)
                                break
                            default:
                                break
                        }
                        let dataSeccion = {
                            equipoAlmacen,
                            granelAlmacen,
                            maduracionAlmacen,
                            variablesAlmacen,
                            anejamientoAlmacen,
                            reposadoAlmacen
                        }
                        const opcionesSeleccionadas = {
                            opcionesSeleccionadosSeccion1,
                            opcionesSeleccionadosSeccion2,
                            opcionesSeleccionadosSeccion3,
                            opcionesSeleccionadosSeccion4,
                            opcionesSeleccionadosSeccion5,
                            opcionesSeleccionadosSeccion6
                        }
                        anexo.informaciongeneral.dataSeccion = dataSeccion
                        anexo.informaciongeneral.opcionesSeleccionadas = opcionesSeleccionadas
                    }
                    anexo.informaciongeneral.tipoinstalacionanejamiento = false
                    anexo.informaciongeneral.tipoinstalacionbodega = false
                    anexo.informaciongeneral.tipoinstalaciongranel = false
                    anexo.informaciongeneral.tipoinstalacionmaduracion = false

                    for (const instalacion of anexo.informaciongeneral.instalaciones) {
                        switch(instalacion.tipoinstalacion.instalacion){
                            case 'Producto terminado': 
                                anexo.informaciongeneral.tipoinstalacionbodega = true
                                break
                            case 'Graneles': 
                                anexo.informaciongeneral.tipoinstalaciongranel = true
                                break
                            case 'Maduracion en vidrio': 
                                anexo.informaciongeneral.tipoinstalacionmaduracion = true
                                break
                            // case 'Añejamiento': 
                            //     anexo.informaciongeneral.tipoinstalacionanejamiento = true
                            //     break
                            // case 'Reposado': 
                            //     anexo.informaciongeneral.tipoinstalacionreposado = true
                            //     break
                            default:
                                break
                        }
                    }
                    delete anexo.informaciongeneral.instalaciones
                    anexo.informaciongeneral.tipoInstalacion = 'Unidad Almacén'
                    anexoInstalaciones.push({ data: anexo.informaciongeneral })
                }
            }
    
            

            for(let i in res.data.data.fc_01_anexorepresentantelegal) {
                res.data.data.fc_01_anexorepresentantelegal[i]['id'] = uuidv4()
                let estado = await comprobarEmail(res.data.data.fc_01_anexorepresentantelegal[i].correoelectronicorepresentante)
                res.data.data.fc_01_anexorepresentantelegal[i]['estado'] = estado
            }
            anexoRepresentantesLegales.push({ data:res.data.data.fc_01_anexorepresentantelegal })
    
            for (let i in res.data.data.fc_01_anexopersonaautorizadatramites) {
                res.data.data.fc_01_anexopersonaautorizadatramites[i]['id'] = uuidv4()
                let estado = await comprobarEmail(res.data.data.fc_01_anexopersonaautorizadatramites[i].correoelectronicopersona)
                res.data.data.fc_01_anexopersonaautorizadatramites[i]['estado'] = estado
            }
            anexoPersonasAut.push({ data: res.data.data.fc_01_anexopersonaautorizadatramites })
    
            for (let i in res.data.data.fc_01_anexomarcas) {
                res.data.data.fc_01_anexomarcas[i]['id'] = uuidv4()
            }
            anexoMarcas.push({ data: res.data.data.fc_01_anexomarcas })

            for (let i in res.data.data.fc_01_anexomediosdecontacto) {
                res.data.data.fc_01_anexomediosdecontacto[i]['id'] = uuidv4()
                let estado = await comprobarEmail(res.data.data.fc_01_anexomediosdecontacto[i].correoelectronico)
                res.data.data.fc_01_anexomediosdecontacto[i]['estado'] = estado
            }
            anexoMediosDeContacto.push({ data: res.data.data.fc_01_anexomediosdecontacto })

            for (let i in res.data.data.fc_01_anexovivero) {
                res.data.data.fc_01_anexovivero[i]['id'] = uuidv4()
            }
            anexoPredio.push({ data: res.data.data.fc_01_anexovivero })

            for (let i in res.data.data.fc_01_anexoproductor) {
                res.data.data.fc_01_anexoproductor[i]['id'] = uuidv4()
            }
            anexoProductor.push({ data: res.data.data.fc_01_anexoproductor })

            for (let i in res.data.data.fc_01_anexomarcasproductoconmezcal) {
                res.data.data.fc_01_anexomarcasproductoconmezcal[i]['id'] = uuidv4()
            }
            anexomarcasProductoConMezcal.push({ data: res.data.data.fc_01_anexomarcasproductoconmezcal })
            
            
            let opcionTipoInscripcion = ''
            let opcionTipoInscrito =''
            if(res.data.data.asociado) opcionTipoInscripcion = 'asociado'
            if(res.data.data.inscrito) opcionTipoInscripcion = 'inscrito'
            if(res.data.data.noasociado) opcionTipoInscripcion = 'noasociado'
            if(res.data.data.inscrito && res.data.data.asociado) opcionTipoInscrito = 'asociado'
            if(res.data.data.inscrito && res.data.data.noasociado) opcionTipoInscrito = 'noasociado'
            let opcionTipoEmpresa = ''
            if(res.data.data.personafisica) opcionTipoEmpresa = 'fisica'
            if(res.data.data.personamoral) opcionTipoEmpresa = 'moral'
            res.data.data.opcionTipoInscripcion = opcionTipoInscripcion
            res.data.data.opcionTipoInscrito = opcionTipoInscrito
            res.data.data.opcionTipoEmpresa = opcionTipoEmpresa
            for (const x in  res.data.data) {
                if(res.data.data[x] === null)  res.data.data[x] = ''
            }
            if(res.data.data.fechadenacimiento){
                let fecha = res.data.data.fechadenacimiento
                res.data.data.fechadenacimiento = moment(fecha).add(1, 'd').format('YYYY-MM-DD')
            }
            let solicitud = {
                data: res.data.data,
                anexoUnidadAlmacen,
                anexoUnidadEnvasado,
                anexoUnidadProduccion,
                anexoPersonasAut,
                anexoRepresentantesLegales,
                anexoMarcas,
                anexoMediosDeContacto,
                anexoPredio,
                anexoProductor,
                maxNumeroDeInstlacion,
                anexoInstalaciones,
                anexomarcasProductoConMezcal
            }

            return solicitud
        } catch (error) {
            console.log(error);
        }
    }
)

export const obtenerFC_01SolicitudDetalleConFiles = createAsyncThunk(
    OBTENER_FC_01_DETALLE_CON_FILES_EXITO,
    async(idSolicitud) => {
        try {
            const fullUrl = host + `FC_01/obtenerUnaSolicitudFC_01Detalle/${idSolicitud}`
            const res = await axios.get(fullUrl)
            let anexoUnidadAlmacen = []
            let anexoUnidadEnvasado = []
            let anexoUnidadProduccion = []
            let anexoPersonasAut = []
            let anexoRepresentantesLegales = []
            let anexoMarcas = []
            let anexoMediosDeContacto = []
            let anexoPredio = []
            let anexoProductor = []
            let anexoInstalaciones = []
            let anexomarcasProductoConMezcal = []
            let documentacionFC_01 = []
            let documentacionRepresentantesLeg = []
            let documentacionPersonasAut = []
            let documentacionPredios = []
            let documentacionViveros = []
            let documentacionMarca = []
            let documentacionMarcaProducto = []
            let documentacionInstalaciones = []
            let documentacionResponsables = []
            
            // for (let i in res.data.data.fc_01_anexounidaddeproduccion) {
            //     res.data.data.fc_01_anexounidaddeproduccion[i]['id'] = uuidv4()
            //     anexoUnidadProduccion.push( { data: res.data.data.fc_01_anexounidaddeproduccion[i] })
            // }

            // for (let i in res.data.data.fc_01_anexounidaddealmacen) {
            //     res.data.data.fc_01_anexounidaddealmacen[i]['id'] = uuidv4()
            //     anexoUnidadAlmacen.push({ data: res.data.data.fc_01_anexounidaddealmacen[i] })
            // }
    
            // for (let i in res.data.data.fc_01_anexounidaddeenvasado) {
            //     res.data.data.fc_01_anexounidaddeenvasado[i]['id'] = uuidv4()
            //     anexoUnidadEnvasado.push({ data: res.data.data.fc_01_anexounidaddeenvasado[i] })
            // }
            let maxNumeroDeInstlacion = 0
            let countInst = 0
            const opcionesFileInstalacion = []
            for (const anexo of res.data.data.anexo) {
                anexo.informaciongeneral.id = uuidv4()
                anexo.informaciongeneral.idfc01_solicitudregistro = anexo.idfc01_solicitudregistro
                anexo.informaciongeneral.idanexo = anexo.idanexo
                let domicilio = ''
                if(anexo.informaciongeneral.calle !== null){
                    if(anexo.informaciongeneral.calle === 'Otro'){
                        domicilio += anexo.informaciongeneral.otracalle + ', '
                    }
                }
                if(anexo.informaciongeneral.colonia !== null){
                    domicilio += anexo.informaciongeneral.colonia + ', '
                }
                if(anexo.informaciongeneral.localidad !== null){
                    domicilio += anexo.informaciongeneral.localidad + ', '
                }
                if(anexo.informaciongeneral.municipio !== null){
                    domicilio += anexo.informaciongeneral.municipio + ', '
                }
                if(anexo.informaciongeneral.estado !== null){
                    domicilio += anexo.informaciongeneral.estado + ', '
                }
                if(anexo.informaciongeneral.codigopostal !== null){
                    domicilio += anexo.informaciongeneral.codigopostal + ', '
                }
                if(domicilio === '') domicilio = 'No se asignó un domicilio'
                anexo.informaciongeneral.domicilio = domicilio

                for (const anexoInstalacion of anexo.fc_01_archivosinstalaciones) {
                    const data = {
                        id: anexoInstalacion.nameid,
                        file: {name: await getNameFile(anexoInstalacion.ruta)},
                        idAnexo: anexoInstalacion.idarchivosinstalacion,
                        idAnexoFK: anexo.idanexo,
                        estatus: true,
                    }
                    documentacionInstalaciones.push(data)
                    if((data.id).includes('TITULOINS')){
                        opcionesFileInstalacion.push({id: 'INST' + data.idAnexoFK, opcionFile: 'copiatitulopropiedad'})
                    } else if((data.id).includes('CAINSP')){
                        opcionesFileInstalacion.push({id: 'INST' + data.idAnexoFK, opcionFile: 'contratoarrendamientopublico'})
                    } else if((data.id).includes('CAINS')){
                        opcionesFileInstalacion.push({id: 'INST' + data.idAnexoFK, opcionFile: 'contratoarrendamientoprivado'})
                    } else if((data.id).includes('CCINSP')){
                        opcionesFileInstalacion.push({id: 'INST' + data.idAnexoFK, opcionFile: 'contratocomodatopublico'})
                    } else if((data.id).includes('CCINS')){
                        opcionesFileInstalacion.push({id: 'INST' + data.idAnexoFK, opcionFile: 'contratocomodatoprivado'})
                    }
                }
                

                for(let i in anexo.informaciongeneral.responsablesdeinstalacion) {
                    anexo.informaciongeneral.responsablesdeinstalacion[i]['id'] = uuidv4()
                    let estado = await comprobarEmail(anexo.informaciongeneral.responsablesdeinstalacion[i].correoelectronico)
                    anexo.informaciongeneral.responsablesdeinstalacion[i]['estado'] = estado
                    for (const anexoRes of anexo.informaciongeneral.responsablesdeinstalacion[i]['fc_01_archivosresposansables']) {
                        const data = {
                            id: anexoRes.nameid,
                            file: {name: await getNameFile(anexoRes.ruta)},
                            idAnexo: anexoRes.idarchivosresponsables,
                            idAnexoFK: anexo.informaciongeneral.responsablesdeinstalacion[i].idresponsabledeinstalacion,
                            estatus: true,
                        }
                        // documentacionInstalaciones.push(data)
                        documentacionResponsables.push(data)
                    }
                }

                const responsables = anexo.informaciongeneral.responsablesdeinstalacion
                delete anexo.informaciongeneral.responsablesdeinstalacion
                anexo.informaciongeneral.responsables = responsables
                
                if(anexo.informaciongeneral.instalacionnumero > maxNumeroDeInstlacion) maxNumeroDeInstlacion = anexo.informaciongeneral.instalacionnumero

                if(anexo.idtipoanexo === 1){
                    let coccionProduccion = []
                    let moliendaProduccion = []
                    let fermentacionProduccion = []
                    let destilacionProduccion = []
                    let granelProduccion = []

                    let opcionesSeleccionadosSeccion1 = []
                    let opcionesSeleccionadosSeccion2 = []
                    let opcionesSeleccionadosSeccion3 = []
                    let opcionesSeleccionadosSeccion4 = []
                    let opcionesSeleccionadosSeccion5 = []

                    for (const elemento of anexo.dataelemento) {
                        elemento.opcion = elemento.elemento.nombreelemento
                        switch(elemento.idseccion){
                            case 1: 
                                opcionesSeleccionadosSeccion1.push({nombre: elemento.elemento.nombreelemento})
                                delete elemento.elemento
                                coccionProduccion.push(elemento)
                                break
                            case 2: 
                                opcionesSeleccionadosSeccion2.push({nombre: elemento.elemento.nombreelemento})
                                delete elemento.elemento
                                moliendaProduccion.push(elemento)
                                break
                            case 3: 
                                opcionesSeleccionadosSeccion3.push({nombre: elemento.elemento.nombreelemento})
                                delete elemento.elemento
                                fermentacionProduccion.push(elemento)
                                break
                            case 4: 
                                opcionesSeleccionadosSeccion4.push({nombre: elemento.elemento.nombreelemento})
                                delete elemento.elemento
                                destilacionProduccion.push(elemento)
                                break
                            // case 5: 
                            //     opcionesSeleccionadosSeccion5.push({nombre: elemento.elemento.nombreelemento})
                            //     granelProduccion.push(elemento)
                            //     break
                            default:
                                break
                        }
                        let dataSeccion = {
                            coccionProduccion,
                            moliendaProduccion,
                            fermentacionProduccion,
                            destilacionProduccion,
                            granelProduccion
                        }
                        const opcionesSeleccionadas = {
                            opcionesSeleccionadosSeccion1,
                            opcionesSeleccionadosSeccion2,
                            opcionesSeleccionadosSeccion3,
                            opcionesSeleccionadosSeccion4,
                            opcionesSeleccionadosSeccion5
                        }
                        anexo.informaciongeneral.dataSeccion = dataSeccion
                        anexo.informaciongeneral.opcionesSeleccionadas = opcionesSeleccionadas
                    }
                    delete anexo.informaciongeneral.instalaciones
                    anexo.informaciongeneral.tipoInstalacion = 'Unidad Producción'
                    anexoInstalaciones.push({ data: anexo.informaciongeneral })
                }
                if(anexo.idtipoanexo === 2){
                    let seccion1 = []
                    let seccion2 = []
                    let seccion3 = []
                    let seccion4 = []
                    let seccion5 = []

                    let opcionesSeleccionadosSeccion1 = []
                    let opcionesSeleccionadosSeccion2 = []
                    let opcionesSeleccionadosSeccion3 = []
                    let opcionesSeleccionadosSeccion4 = []
                    let opcionesSeleccionadosSeccion5 = []

                    for (const elemento of anexo.dataelemento) {
                        elemento.opcion = elemento.elemento.nombreelemento
                        switch(elemento.idseccion){
                            case 6: 
                                opcionesSeleccionadosSeccion1.push({nombre: elemento.elemento.nombreelemento})
                                delete elemento.elemento
                                seccion1.push(elemento)
                                break
                            case 7: 
                                opcionesSeleccionadosSeccion2.push({nombre: elemento.elemento.nombreelemento})
                                delete elemento.elemento
                                seccion2.push(elemento)
                                break
                            case 8: 
                                opcionesSeleccionadosSeccion3.push({nombre: elemento.elemento.nombreelemento})
                                delete elemento.elemento
                                seccion3.push(elemento)
                                break
                            case 9: 
                                opcionesSeleccionadosSeccion4.push({nombre: elemento.elemento.nombreelemento})
                                delete elemento.elemento
                                seccion4.push(elemento)
                                break
                            case 10: 
                                opcionesSeleccionadosSeccion5.push({nombre: elemento.elemento.nombreelemento})
                                delete elemento.elemento
                                seccion5.push(elemento)
                                break
                            default:
                                break
                        }
                        let dataSeccion = {
                            seccion1,
                            seccion2,
                            seccion3,
                            seccion4,
                            seccion5
                        }
                        const opcionesSeleccionadas = {
                            opcionesSeleccionadosSeccion1,
                            opcionesSeleccionadosSeccion2,
                            opcionesSeleccionadosSeccion3,
                            opcionesSeleccionadosSeccion4,
                            opcionesSeleccionadosSeccion5
                        }
                        anexo.informaciongeneral.dataSeccion = dataSeccion
                        anexo.informaciongeneral.opcionesSeleccionadas = opcionesSeleccionadas
                    }
                    delete anexo.informaciongeneral.instalaciones
                    anexo.informaciongeneral.tipoInstalacion = 'Unidad Envasado'
                    anexoInstalaciones.push({ data: anexo.informaciongeneral })
                }
                if(anexo.idtipoanexo === 3){
                    let equipoAlmacen = []
                    let maduracionAlmacen = []
                    let variablesAlmacen = []
                    let granelAlmacen = []
                    let anejamientoAlmacen = []
                    let reposadoAlmacen = []
                    
                    let opcionesSeleccionadosSeccion1 = []
                    let opcionesSeleccionadosSeccion2 = []
                    let opcionesSeleccionadosSeccion3 = []
                    let opcionesSeleccionadosSeccion4 = []
                    let opcionesSeleccionadosSeccion5 = []
                    let opcionesSeleccionadosSeccion6 = []
                    
                    for (const elemento of anexo.dataelemento) {
                        elemento.opcion = elemento.elemento.nombreelemento
                        switch(elemento.idseccion){
                            case 11: 
                                opcionesSeleccionadosSeccion1.push({nombre: elemento.elemento.nombreelemento})
                                delete elemento.elemento
                                equipoAlmacen.push(elemento)
                                break
                            case 5: 
                                opcionesSeleccionadosSeccion4.push({nombre: elemento.elemento.nombreelemento})
                                delete elemento.elemento
                                granelAlmacen.push(elemento)
                                break
                            case 12: 
                                opcionesSeleccionadosSeccion2.push({nombre: elemento.elemento.nombreelemento})
                                delete elemento.elemento
                                maduracionAlmacen.push(elemento)
                                break
                            // case 13: 
                            //     opcionesSeleccionadosSeccion5.push({nombre: elemento.elemento.nombreelemento})
                            //     delete elemento.elemento
                            //     anejamientoAlmacen.push(elemento)
                            //     break
                            // case 14: 
                            //     opcionesSeleccionadosSeccion6.push({nombre: elemento.elemento.nombreelemento})
                            //     delete elemento.elemento
                            //     reposadoAlmacen.push(elemento)
                            //     break
                            case 13: 
                                opcionesSeleccionadosSeccion3.push({nombre: elemento.elemento.nombreelemento})
                                delete elemento.elemento
                                variablesAlmacen.push(elemento)
                                break
                            default:
                                break
                        }
                        let dataSeccion = {
                            equipoAlmacen,
                            granelAlmacen,
                            maduracionAlmacen,
                            variablesAlmacen,
                            anejamientoAlmacen,
                            reposadoAlmacen
                        }
                        const opcionesSeleccionadas = {
                            opcionesSeleccionadosSeccion1,
                            opcionesSeleccionadosSeccion2,
                            opcionesSeleccionadosSeccion3,
                            opcionesSeleccionadosSeccion4,
                            opcionesSeleccionadosSeccion5,
                            opcionesSeleccionadosSeccion6
                        }
                        anexo.informaciongeneral.dataSeccion = dataSeccion
                        anexo.informaciongeneral.opcionesSeleccionadas = opcionesSeleccionadas
                    }
                    anexo.informaciongeneral.tipoinstalacionanejamiento = false
                    anexo.informaciongeneral.tipoinstalacionbodega = false
                    anexo.informaciongeneral.tipoinstalaciongranel = false
                    anexo.informaciongeneral.tipoinstalacionmaduracion = false

                    for (const instalacion of anexo.informaciongeneral.instalaciones) {
                        switch(instalacion.tipoinstalacion.instalacion){
                            case 'Producto terminado': 
                                anexo.informaciongeneral.tipoinstalacionbodega = true
                                break
                            case 'Graneles': 
                                anexo.informaciongeneral.tipoinstalaciongranel = true
                                break
                            case 'Maduracion en vidrio': 
                                anexo.informaciongeneral.tipoinstalacionmaduracion = true
                                break
                            // case 'Añejamiento': 
                            //     anexo.informaciongeneral.tipoinstalacionanejamiento = true
                            //     break
                            // case 'Reposado': 
                            //     anexo.informaciongeneral.tipoinstalacionreposado = true
                            //     break
                            default:
                                break
                        }
                    }
                    delete anexo.informaciongeneral.instalaciones
                    anexo.informaciongeneral.tipoInstalacion = 'Unidad Almacén'
                    anexoInstalaciones.push({ data: anexo.informaciongeneral })
                }
                countInst++
            }
            var oJSONI = sortJSON(documentacionInstalaciones, 'idAnexoBD', 'asc');
                documentacionInstalaciones = oJSONI
    
            for(let i in res.data.data.fc_01_anexorepresentantelegal) {
                res.data.data.fc_01_anexorepresentantelegal[i]['id'] = uuidv4()
                let estado = await comprobarEmail(res.data.data.fc_01_anexorepresentantelegal[i].correoelectronicorepresentante)
                res.data.data.fc_01_anexorepresentantelegal[i]['estado'] = estado

                for (const anexo of res.data.data.fc_01_anexorepresentantelegal[i]['fc_01_anexosrepresentantelegal']) {
                    const data = {
                        id: anexo.nameid,
                        file: {name: await getNameFile(anexo.ruta)},
                        idAnexo: anexo.idanexorepresentantelegal,
                        idAnexoFK: res.data.data.fc_01_anexorepresentantelegal[i].idfc01_anexorepresentantelegal,
                        estatus: true,
                    }
                    documentacionRepresentantesLeg.push(data)
                }
            }
            anexoRepresentantesLegales.push({ data:res.data.data.fc_01_anexorepresentantelegal })
            var oJSONRL = sortJSON(documentacionRepresentantesLeg, 'idAnexoBD', 'asc');
            documentacionRepresentantesLeg = oJSONRL

            for (let i in res.data.data.fc_01_anexopersonaautorizadatramites) {
                res.data.data.fc_01_anexopersonaautorizadatramites[i]['id'] = uuidv4()
                let estado = await comprobarEmail(res.data.data.fc_01_anexopersonaautorizadatramites[i].correoelectronicopersona)
                res.data.data.fc_01_anexopersonaautorizadatramites[i]['estado'] = estado

                for (const anexo of res.data.data.fc_01_anexopersonaautorizadatramites[i]['fc_01_anexospersonaautorizada']) {
                    const data = {
                        id: anexo.nameid,
                        file: {name: await getNameFile(anexo.ruta)},
                        idAnexo: anexo.idanexopersonaautorizada,
                        idAnexoFK: res.data.data.fc_01_anexopersonaautorizadatramites[i].idfc01_anexopersonaatorizadatramites,
                        estatus: true,
                    }
                    documentacionPersonasAut.push(data)
                }
            }
            anexoPersonasAut.push({ data: res.data.data.fc_01_anexopersonaautorizadatramites })
            var oJSONPA = sortJSON(documentacionPersonasAut, 'idAnexoBD', 'asc');
            documentacionPersonasAut = oJSONPA

            for (let i in res.data.data.fc_01_anexomarcas) {
                res.data.data.fc_01_anexomarcas[i]['id'] = uuidv4()
                
                for (const anexo of res.data.data.fc_01_anexomarcas[i]['fc_01_anexosmarca']) {
                    const data = {
                        id: anexo.nameid,
                        file: {name: await getNameFile(anexo.ruta)},
                        idAnexo: anexo.idanexomarca,
                        idAnexoFK: res.data.data.fc_01_anexomarcas[i].idfc01_anexomarcas,
                        estatus: true,
                    }
                    documentacionMarca.push(data)
                }
            }
            anexoMarcas.push({ data: res.data.data.fc_01_anexomarcas })
            var oJSONMD = sortJSON(documentacionMarca, 'idAnexoBD', 'asc');
            documentacionMarca = oJSONMD

            for (let i in res.data.data.fc_01_anexomediosdecontacto) {
                res.data.data.fc_01_anexomediosdecontacto[i]['id'] = uuidv4()
                let estado = await comprobarEmail(res.data.data.fc_01_anexomediosdecontacto[i].correoelectronico)
                res.data.data.fc_01_anexomediosdecontacto[i]['estado'] = estado
            }
            anexoMediosDeContacto.push({ data: res.data.data.fc_01_anexomediosdecontacto })
            

            const opcionesFileVivero = []
            for (let i in res.data.data.fc_01_anexovivero) {
                res.data.data.fc_01_anexovivero[i]['id'] = uuidv4()
                for (const anexo of res.data.data.fc_01_anexovivero[i]['fc_01_archivosviveros']) {                    
                    const data = {
                        id: anexo.nameid,
                        file: {name: await getNameFile(anexo.ruta)},
                        idAnexo: anexo.idarchivosvivero,
                        idAnexoFK: res.data.data.fc_01_anexovivero[i].idfc01_anexopredios,
                        estatus: true,
                    }
                    documentacionViveros.push(data)
                    if((anexo.nameid).includes('COPIAESC')){
                        opcionesFileVivero.push({id: 'VIV' + data.idAnexoFK, opcionFile: 'copiaescritura'})
                    } else if((anexo.nameid).includes('CONSPOS')){
                        opcionesFileVivero.push({id: 'VIV' + data.idAnexoFK, opcionFile: 'constanciaposesion'})
                    } else if((anexo.nameid).includes('CONARREN')){
                        opcionesFileVivero.push({id: 'VIV' + data.idAnexoFK, opcionFile: 'contratoarrendamiento'})
                    } else if((anexo.nameid).includes('CONCOMPR')){
                        opcionesFileVivero.push({id: 'VIV' + data.idAnexoFK, opcionFile: 'contratocompraventa'})
                    } else if((anexo.nameid).includes('CONCOMODA')){
                        opcionesFileVivero.push({id: 'VIV' + data.idAnexoFK, opcionFile: 'contratocomodato'})
                    }
                }
            }
            anexoPredio.push({ data: res.data.data.fc_01_anexovivero })
            var oJSONV = sortJSON(documentacionViveros, 'idAnexoBD', 'asc');
            documentacionViveros = oJSONV

            const opcionesFilePredio = []
            for (let i in res.data.data.fc_01_anexoproductor) {
                res.data.data.fc_01_anexoproductor[i]['id'] = uuidv4()

                for (const anexo of res.data.data.fc_01_anexoproductor[i]['fc_01_archivospredios']) {
                    const data = {
                        id: anexo.nameid,
                        file: {name: await getNameFile(anexo.ruta)},
                        idAnexo: anexo.idarchivospredio,
                        idAnexoFK: res.data.data.fc_01_anexoproductor[i].idfc01_anexoproductor,
                        estatus: true,
                    }
                    documentacionPredios.push(data)
                    if((anexo.nameid).includes('COPIAESC')){
                        opcionesFilePredio.push({id: 'PRED' + data.idAnexoFK, opcionFile: 'copiaescritura'})
                    } else if((anexo.nameid).includes('CONSPOS')){
                        opcionesFilePredio.push({id: 'PRED' + data.idAnexoFK, opcionFile: 'constanciaposesion'})
                    } else if((anexo.nameid).includes('CONARREN')){
                        opcionesFilePredio.push({id: 'PRED' + data.idAnexoFK, opcionFile: 'contratoarrendamiento'})
                    } else if((anexo.nameid).includes('CONCOMPR')){
                        opcionesFilePredio.push({id: 'PRED' + data.idAnexoFK, opcionFile: 'contratocompraventa'})
                    } else if((anexo.nameid).includes('CONCOMODA')){
                        opcionesFilePredio.push({id: 'PRED' + data.idAnexoFK, opcionFile: 'contratocomodato'})
                    }
                }
            }
            anexoProductor.push({ data: res.data.data.fc_01_anexoproductor })
            var oJSONP = sortJSON(documentacionPredios, 'idAnexoBD', 'asc');
            documentacionPredios = oJSONP

            for (let i in res.data.data.fc_01_anexomarcasproductoconmezcal) {
                res.data.data.fc_01_anexomarcasproductoconmezcal[i]['id'] = uuidv4()
                for (const anexo of res.data.data.fc_01_anexomarcasproductoconmezcal[i]['fc_01_archivosmarcasproducto']) {
                    const data = {
                        id: anexo.nameid,
                        file: {name: await getNameFile(anexo.ruta)},
                        idAnexo: anexo.idarchivosmarcaproducto,
                        idAnexoFK: res.data.data.fc_01_anexomarcasproductoconmezcal[i].idfc01_anexomarcasproductoconmezcal,
                        estatus: true,
                    }
                    documentacionMarcaProducto.push(data)
                }
            }
            anexomarcasProductoConMezcal.push({ data: res.data.data.fc_01_anexomarcasproductoconmezcal })
            var oJSONMP = sortJSON(documentacionMarcaProducto, 'idAnexoBD', 'asc');
            documentacionMarcaProducto = oJSONMP

            let opcionTipoInscripcion = ''
            let opcionTipoInscrito =''
            if(res.data.data.asociado) opcionTipoInscripcion = 'asociado'
            if(res.data.data.inscrito) opcionTipoInscripcion = 'inscrito'
            if(res.data.data.noasociado) opcionTipoInscripcion = 'noasociado'
            if(res.data.data.inscrito && res.data.data.asociado) opcionTipoInscrito = 'asociado'
            if(res.data.data.inscrito && res.data.data.noasociado) opcionTipoInscrito = 'noasociado'
            let opcionTipoEmpresa = ''
            if(res.data.data.personafisica) opcionTipoEmpresa = 'fisica'
            if(res.data.data.personamoral) opcionTipoEmpresa = 'moral'
            res.data.data.opcionTipoInscripcion = opcionTipoInscripcion
            res.data.data.opcionTipoInscrito = opcionTipoInscrito
            res.data.data.opcionTipoEmpresa = opcionTipoEmpresa
            for (const x in  res.data.data) {
                if(res.data.data[x] === null)  res.data.data[x] = ''
            }
            if(res.data.data.fechadenacimiento){
                let fecha = res.data.data.fechadenacimiento
                res.data.data.fechadenacimiento = moment(fecha).add(1, 'd').format('YYYY-MM-DD')
            }

            //FILES
            for (const anexo of res.data.data.fc_01_anexos) {
                const data = {
                    id: anexo.nameid,
                    file: {name: await getNameFile(anexo.ruta)},
                    idAnexo: anexo.idfc01_anexos,
                    idAnexoFK: anexo.idfc01_solicitudregistro,
                    estatus: true,
                }
                
                documentacionFC_01.push(data)
            }
            
            let solicitud = {
                data: res.data.data,
                anexoUnidadAlmacen,
                anexoUnidadEnvasado,
                anexoUnidadProduccion,
                anexoPersonasAut,
                anexoRepresentantesLegales,
                anexoMarcas,
                anexoMediosDeContacto,
                anexoPredio,
                anexoProductor,
                maxNumeroDeInstlacion,
                anexoInstalaciones,
                anexomarcasProductoConMezcal,
                documentacionFC_01,
                documentacionRepresentantesLeg,
                documentacionPersonasAut,
                documentacionPredios,
                documentacionViveros,
                documentacionMarca,
                documentacionMarcaProducto,
                documentacionInstalaciones,
                documentacionResponsables,
                opcionesFileVivero,
                opcionesFilePredio,
                opcionesFileInstalacion,
            }
            return solicitud
        } catch (error) {
            console.log(error);
        }
    }
)
function sortJSON(data, key, orden) {
    return data.sort(function (a, b) {
        var x = a[key],
        y = b[key];

        if (orden === 'asc') {
            return ((x < y) ? -1 : ((x > y) ? 1 : 0));
        }

        if (orden === 'desc') {
            return ((x > y) ? -1 : ((x < y) ? 1 : 0));
        }
    });
}
const comprobarEmail = async (correo) => {
    const patron = /^[^ ]+@[^ ]+\.[a-z]{2,3}$/;
    const emailsAceptados = ['@gmail', '@yahoo','@outlook','@hotmail'];
    const extensionesAceptadas = ['.mx', '.com','.es'];
    let emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    
    let isEmailAceptadoFlag = false;
    let isExtensionAceptadaFlag =false;

    if (correo.match(emailRegex)) {
        isEmailAceptadoFlag = true;
        isExtensionAceptadaFlag = true;

        if(isEmailAceptadoFlag === true && isExtensionAceptadaFlag === true){
            return true
        } else {
            return false
        }
    } 
    else {
        return false
    }
    
}
const getNameFile = async (ruta) => {
    let nameFile = null
    // const array = ruta.split("\\")
    const array = ruta.split("/")
    nameFile = array[array.length - 1]
    return nameFile
}
export const obtenerFC_01AnexoUnidadMap = createAsyncThunk(
    OBTENER_FC_01_ANEXOUNIDADALMACEN_MAP_EXITO,
    async(idAnexo) => {
        try {
            const fullUrl = host + `MapSolicitud/obtenerMapFC_01_AnexoInformacionGeneralMap/${idAnexo}`
            const res = await axios.get(fullUrl)
            const dato = []
            dato.push(res.data.data)
            if(res.data.data != null){
                return dato
            }else{
                return []
            }
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerFC_01AnexoResponsableUnidadMap = createAsyncThunk(
    OBTENER_FC_01_ANEXOUNIDAD_MAP_EXITO,
    async(data) => {
        try {
            const responsables = data.responsables
            // const fullUrl = host + `MapSolicitud/obtenerMapFC_01_AnexoInformacionGeneralMap/${idAnexo}`
            // const res = await axios.get(fullUrl)
            const obtenerAnexoResponsableMap = host + `MapSolicitud/obtenerMapFC_01_AnexoResponsableMap/`
            let anexoResponsableMap = []
            for (const anexo of responsables) {
                const resMap = await axios.get(obtenerAnexoResponsableMap + anexo.idresponsabledeinstalacion)
                anexoResponsableMap.push(resMap.data.data)
            }
            return anexoResponsableMap
        } catch (error) {
            console.log(error)
        }
    }
)




export const obtenerFC_01Map = createAsyncThunk(
    OBTENER_FC_01_MAP_EXITO,
    async (solicitudId) => {
        try {
            const fullUrl = host + `MapSolicitud/obtenerMapFC_01_Solicitud/${solicitudId}`
            const res = await axios.get(fullUrl)

            const anexosMap = await obtenerAnexosMap(solicitudId)
            let countObsDatosGenerales = 0
            let countObsDomicilioFiscal = 0
            for (const i in res.data.data) {
                if(res.data.data[i] === true) countObsDatosGenerales++
            }
            if(res.data.data.domiciliofiscalcheck === true) {
                countObsDomicilioFiscal++
                countObsDatosGenerales--
            }
            anexosMap.countObsDatosGenerales += countObsDatosGenerales
            anexosMap.countObsDomicilioFiscal = countObsDomicilioFiscal
            if(res != null) {
                return {fc_01Map : res.data.data,
                        anexosMap : anexosMap}
            }else {
                return {}
            }
        }catch(error){
            console.log(error)
        }
    }
)

const obtenerAnexosMap = async (idSolicitud) => {

    try {
        const fullUrl = host + `FC_01/obtenerUnaSolicitudFC_01Detalle/${idSolicitud}`
        const obtenerPersonasAutorizadas = host + `MapSolicitud/obtenerMapFC_01_AnexoPersonaAut/`
        const obtenerDocumentacionFC_01Map = host + `MapSolicitud/obtenerMapFC_01_AnexosFiles/`

        const res = await axios.get(fullUrl)
        let countObservacionesDocumentacion = 0
        let documentacionFC_01Map = []
        for (const anexo of res.data.data.fc_01_anexos) {
            if(anexo.fc_01_anexosmap[0] !== undefined){
                anexo.fc_01_anexosmap[0].idAnexoBD = anexo.fc_01_anexosmap?.[0]?.idfc01_anexos
                documentacionFC_01Map.push(anexo.fc_01_anexosmap?.[0])
                for (const i in anexo.fc_01_anexosmap?.[0]) {
                    if(anexo.fc_01_anexosmap?.[0][i] === true) countObservacionesDocumentacion++
                }    
            }
            
        }

        let documentacionRepresentanteLegalMap = []
        for (const data of res.data.data.fc_01_anexorepresentantelegal) {
            for (const anexo of data.fc_01_anexosrepresentantelegal) {
                if(anexo.fc_01_anexosrepresentantelegalmap){
                    anexo.fc_01_anexosrepresentantelegalmap.idAnexoBD = anexo.fc_01_anexosrepresentantelegalmap?.idanexorepresentantelegal
                    documentacionRepresentanteLegalMap.push(anexo.fc_01_anexosrepresentantelegalmap)
                    for (const i in anexo.fc_01_anexosrepresentantelegalmap?.[0]) {
                        if(anexo.fc_01_anexosrepresentantelegalmap?.[0][i] === true) countObservacionesDocumentacion++
                    }
                }
                
            }
        }
        
        let documentacionPersonaAutorizadaMap = []
        for (const data of res.data.data.fc_01_anexopersonaautorizadatramites) {
            for (const anexo of data.fc_01_anexospersonaautorizada) {
                if(anexo.fc_01_anexospersonaautorizadamap[0]){
                    anexo.fc_01_anexospersonaautorizadamap[0].idAnexoBD = anexo.fc_01_anexospersonaautorizadamap?.[0]?.idanexopersonaautorizada
                    documentacionPersonaAutorizadaMap.push(anexo.fc_01_anexospersonaautorizadamap?.[0])
                }
                for (const i in anexo.fc_01_anexospersonaautorizadamap?.[0]) {
                    if(anexo.fc_01_anexospersonaautorizadamap?.[0][i] === true) countObservacionesDocumentacion++
                }
            }
        }
        
        let documentacionPredioMap = []
        for (const data of res.data.data.fc_01_anexoproductor) {
            for (const anexo of data.fc_01_archivospredios) {
                if(anexo.fc_01_archivosprediosmap[0]){
                    anexo.fc_01_archivosprediosmap[0].idAnexoBD = anexo.fc_01_archivosprediosmap?.[0]?.idarchivospredio
                documentacionPredioMap.push(anexo.fc_01_archivosprediosmap?.[0])
                }
                for (const i in anexo.fc_01_archivosprediosmap?.[0]) {
                    if(anexo.fc_01_archivosprediosmap?.[0][i] === true) countObservacionesDocumentacion++
                }
            }
        }
        
        let documentacionViveroMap = []
        for (const data of res.data.data.fc_01_anexovivero) {
            for (const anexo of data.fc_01_archivosviveros) {
                if(anexo.fc_01_archivosviverosmap[0]){
                    anexo.fc_01_archivosviverosmap[0].idAnexoBD = anexo.fc_01_archivosviverosmap?.[0]?.idarchivosvivero
                documentacionViveroMap.push(anexo.fc_01_archivosviverosmap?.[0])
                }
                for (const i in anexo.fc_01_archivosviverosmap?.[0]) {
                    if(anexo.fc_01_archivosviverosmap?.[0][i] === true) countObservacionesDocumentacion++
                }
            }
        }
        
        let documentacionMarcaMap = []
        for (const data of res.data.data.fc_01_anexomarcas) {
            for (const anexo of data.fc_01_anexosmarca) {
                if(anexo.fc_01_anexosmarcamap[0]){
                    anexo.fc_01_anexosmarcamap[0].idAnexoBD = anexo.fc_01_anexosmarcamap?.[0]?.idanexomarca
                    documentacionMarcaMap.push(anexo.fc_01_anexosmarcamap?.[0])
                }
                for (const i in anexo.fc_01_anexosmarcamap?.[0]) {
                    if(anexo.fc_01_anexosmarcamap?.[0][i] === true) countObservacionesDocumentacion++
                }
            }
        }
        
        let documentacionMarcaProductoMap = []
        for (const data of res.data.data.fc_01_anexomarcasproductoconmezcal) {
            for (const anexo of data.fc_01_archivosmarcasproducto) {
                if(anexo.fc_01_archivosmarcasproductomap[0]){
                    anexo.fc_01_archivosmarcasproductomap[0].idAnexoBD = anexo.fc_01_archivosmarcasproductomap?.[0]?.idarchivosmarcaproducto
                    documentacionMarcaProductoMap.push(anexo.fc_01_archivosmarcasproductomap?.[0])
                }
                for (const i in anexo.fc_01_archivosmarcasproductomap?.[0]) {
                    if(anexo.fc_01_archivosmarcasproductomap?.[0][i] === true) countObservacionesDocumentacion++
                }
            }
        }

        let documentacionInstalacionMap = []
        let documentacionResponsableMap = []
        for (const data of res.data.data.anexo) {
            for (const anexo of data.fc_01_archivosinstalaciones) {
                if(anexo.fc_01_archivosinstalacionesmap[0]){
                    anexo.fc_01_archivosinstalacionesmap[0].idAnexoBD = anexo.fc_01_archivosinstalacionesmap?.[0]?.idarchivosinstalacion
                    documentacionInstalacionMap.push(anexo.fc_01_archivosinstalacionesmap?.[0])
                }
                for (const i in anexo.fc_01_archivosinstalacionesmap?.[0]) {
                    if(anexo.fc_01_archivosinstalacionesmap?.[0][i] === true) countObservacionesDocumentacion++
                }
            }
            for (const anexo of data.informaciongeneral.responsablesdeinstalacion) {
                for (const dataMap of anexo.fc_01_archivosresposansables) {
                    if(dataMap.fc_01_archivosresposansablesmap[0]){
                        dataMap.fc_01_archivosresposansablesmap[0].idAnexoBD = dataMap.fc_01_archivosresposansablesmap?.[0]?.idarchivosresponsables
                        documentacionResponsableMap.push(dataMap.fc_01_archivosresposansablesmap?.[0])
                    }
                    for (const i in dataMap.fc_01_archivosresposansablesmap?.[0]) {
                        if(dataMap.fc_01_archivosresposansablesmap?.[0][i] === true) countObservacionesDocumentacion++
                    } 
                }
            }
        }
        const obtenerInstalacionMap = host + `MapSolicitud/obtenerMapFC_01_AnexoInformacionGeneralMap/`
        const obtenerResponsableInstalacionMap = host + `MapSolicitud/obtenerMapFC_01_AnexoResponsableMap/`
        let countObsInstalaciones = 0
        let validacionInstalacion = false
        for (const anexo of res.data.data.anexo) {
            const resMap = await axios.get(obtenerInstalacionMap + anexo.informaciongeneral.idiformaciongeneral)
            for (const i in resMap.data.data) {
                if(resMap.data.data[i] === true) countObsInstalaciones++
            }
            for (const respon of anexo.informaciongeneral.responsablesdeinstalacion) {
                const resResponsableMap = await axios.get(obtenerResponsableInstalacionMap + respon.idresponsabledeinstalacion)
                for (const i in resResponsableMap.data.data) {
                    if(resResponsableMap.data.data[i] === true) countObsInstalaciones++
                }
            }
        }
        if(countObsInstalaciones > 0)validacionInstalacion = true

        const obtenerRepresentantesLegales = host + `MapSolicitud/obtenerMapFC_01_ApoderadoLegalMap/`
        const obtenerMapFC_01_PredioMap = host + `MapSolicitud/obtenerMapFC_01_PredioMap/`
        const obtenerMapFC_01_ProductorMap = host + `MapSolicitud/obtenerMapFC_01_ProductorMap/`
        const obtenerAnexoMarcasMap = host + `MapSolicitud/obtenerMapFC_01_AnexoMarcasMap/`
        const obtenerAnexoMarcasConProductoMap = host + `MapSolicitud/obtenerMapFC_01_AnexoProductosConMarcasMap/`

        
        let anexoMarcasMap = []
        let anexoPersonasAutMap = []
        let anexoRepresentanteLegal = []
        let anexoPredioMap = []
        let anexoProductorMap = []
        let anexoMarcaDeMezcalMap = []
        let anexoMarcaConProductoMap = []

        let countObsDatosGenerales = 0
        let countObsPrediosViveros = 0
        let countObsMarcas = 0

        for (const anexo of res.data.data.fc_01_anexopersonaautorizadatramites) {
            const resMap = await axios.get(obtenerPersonasAutorizadas + anexo.idfc01_anexopersonaatorizadatramites)
            anexoPersonasAutMap.push(resMap.data.data)
            for (const i in resMap.data.data) {
                if(resMap.data.data[i] === true) countObsDatosGenerales++
            }
        }
        for (const anexo of res.data.data.fc_01_anexorepresentantelegal) {
            const resMap = await axios.get(obtenerRepresentantesLegales + anexo.idfc01_anexorepresentantelegal)
            anexoRepresentanteLegal.push(resMap.data.data)
            for (const i in resMap.data.data) {
                if(resMap.data.data[i] === true) countObsDatosGenerales++
            }
        }
        
        for (const anexo of res.data.data.fc_01_anexovivero) {
            const resMap = await axios.get(obtenerMapFC_01_PredioMap + anexo.idfc01_anexopredios)
            if(resMap.data.data !== null)anexoPredioMap.push(resMap.data.data)
            if(resMap.data.data !== null){
                for (const i in resMap.data.data) {
                    if(resMap.data.data[i] === true) countObsPrediosViveros++
                }
            }
        }
       
        for (const anexo of res.data.data.fc_01_anexoproductor) {
            const resMap = await axios.get(obtenerMapFC_01_ProductorMap + anexo.idfc01_anexoproductor)
            if(resMap.data.data !== null) anexoProductorMap.push(resMap.data.data)
            if(resMap.data.data !== null){
                for (const i in resMap.data.data) {
                    if(resMap.data.data[i] === true) countObsPrediosViveros++
                }
            }
        }
        for (const anexo of res.data.data.fc_01_anexomarcas) {
            const resMap = await axios.get(obtenerAnexoMarcasMap + anexo.idfc01_anexomarcas)
            anexoMarcaDeMezcalMap.push(resMap.data.data)
            for (const i in resMap.data.data) {
                if(resMap.data.data[i] === true) countObsMarcas++
            }
        }
        for (const anexo of res.data.data.fc_01_anexomarcasproductoconmezcal) {
            const resMap = await axios.get(obtenerAnexoMarcasConProductoMap + anexo.idfc01_anexomarcasproductoconmezcal)
            
            anexoMarcaConProductoMap.push(resMap.data.data)
            for (const i in resMap.data.data) {
                if(resMap.data.data[i] === true) countObsMarcas++
            }
        }

        
        let anexosMap = {
            anexoMarcasMap,
            anexoPersonasAutMap,
            documentacionFC_01Map,
            documentacionRepresentanteLegalMap,
            documentacionPersonaAutorizadaMap,
            documentacionPredioMap,
            documentacionViveroMap,
            documentacionMarcaMap,
            documentacionMarcaProductoMap,
            documentacionInstalacionMap,
            documentacionResponsableMap,
            anexoRepresentanteLegal,
            anexoPredioMap,
            anexoProductorMap,
            anexoMarcaDeMezcalMap,
            anexoMarcaConProductoMap,
            countObsDatosGenerales,
            countObsPrediosViveros,
            countObsMarcas,
            countObsInstalaciones,
            countObservacionesDocumentacion,
            validacionInstalacion
        }
        return anexosMap

    } catch (error) {
        console.log(error);
    }
}

export const obtenerSeccionesDeProduccion = createAsyncThunk(
    OBTENER_FC_01_SECCIONES_EXITO_BD,
    async(idTipoAnexo) => {
        try {
            const fullUrl = host + `FC_01/obtenerSeccionesDeAnexo/${idTipoAnexo}`
            const res = await axios.get(fullUrl)
            for (const seccion of  res.data.data) {
                for (let i in seccion.seccion.elementosdeseccion) {
                    seccion.seccion.elementosdeseccion[i]['seleccionado'] = false
                }
            }
            
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)

export const eliminarFC_01Anexos = createAsyncThunk(
    ELIMINAR_FC_01_ANEXOS,
    async(id) => {
        try {
            const fullUrlAnexos = host + `FC_01/eliminarFC_01Anexos/${id}`
            await axios.delete(fullUrlAnexos)
            return []
        } catch (error) {
            console.log(error)
        }
    }
)

export const actualizarFC_01Estatus = createAsyncThunk(
    ACTUALIZAR_FC_01_ESTATUS_EXITO,
    async(data) => {
        try {
            const fullUrl = host + 'Estatus/actualizarEstatusFC_01'
            const res = await axios.post(fullUrl, data)
            
            return {}
        } catch (error) {
            console.log(error);
        }
    }
)

export const eliminarFC_01AnexoPersonasAutBD = createAsyncThunk(
    ELIMINAR_FC_01_ANEXOPERSONASAUT_EXITO_BD,
    async(id) => {
        try {
            const fullUrl = host + `FC_01/eliminarAnexoPersonaAutorizadaTramitesFC_01/${id}`
            await axios.delete(fullUrl)
            return id
        } catch (error) {
            console.log(error);
        }
    }
)

export const eliminarFC_01AnexoRepresentanteLegal = createAsyncThunk(
    ELIMINAR_FC_01_ANEXOREPRESENTANTELEGAL_EXITO_BD,
    async(id) => {
        try {
            const fullUrl = host + `FC_01/eliminarAnexoRepresentanteLegalFC_01/${id}`
            await axios.delete(fullUrl)
        } catch (error) {
            console.log(error)
        }
    }
)

export const eliminarFC_01AnexoMarcasBD = createAsyncThunk(
    ELIMINAR_FC_01_ANEXOMARCAS_EXITO_BD,
    async(id) => {
        try {
            const fullUrl = host + `FC_01/eliminarAnexoMarcaDeSolicitudFC_01/${id}`
            await axios.delete(fullUrl)
            return id
        } catch (error) {
            console.log(error)
        }
    }
)
export const eliminarDataElementoBD = createAsyncThunk(
    ELIMINAR_DATAELEMENTO_EXITO_BD,
    async(id) => {
        try {
            const fullUrl = host + `FC_01/eliminarDataElemento/${id}`
            await axios.delete(fullUrl)
            return id
        } catch (error) {
            console.log(error)
        }
    }
)
export const eliminarResponsableBD = createAsyncThunk(
    ELIMINAR_RESPONSABLE_EXITO_BD,
    async(id) => {
        try {
            const fullUrl = host + `FC_01/eliminarResponsable/${id}`
            await axios.delete(fullUrl)
            return id
        } catch (error) {
            console.log(error)
        }
    }
)

export const eliminarFC_01AnexoMedioDeContactoBD = createAsyncThunk(
    ELIMINAR_FC_01_ANEXOMEDIODECONTACTO_EXITO_BD,
    async(id) => {
        try {
            const fullUrl = host + `FC_01/eliminarAnexoMediosDeContactoFC_01/${id}`
            await axios.delete(fullUrl)
            return id
        } catch (error) {
            console.log(error)
        }
    }
)

export const eliminarFC_01SolicitudBD = createAsyncThunk(
    ELIMINAR_FC_01_SOLICITUD_EXITO_BD,
    async(id) => {
        try {
            const fullUrlAnexos = host + `FC_01/eliminarFC_01Anexos/${id}`
            const resulDleteAnexos = await axios.delete(fullUrlAnexos)
            if (resulDleteAnexos) {
                const fullUrlSolicitud = host + `FC_01/eliminarUnaSolicitudFC_01/${id}`
                await axios.delete(fullUrlSolicitud)
            }
            return id
        } catch (error) {
            console.log(error);
        }
    }
)

export const eliminarFC_01AnexoUnidadEnvasadoBD = createAsyncThunk(
    ELIMINAR_FC_01_ANEXOUNIDADENVASADO_EXITO_BD,
    async(data) => {
        try {
            if (data.idfc01_solicitudregistro !== undefined) {
                const fullUrl = host + `FC_01/eliminarAnexo/${data.idanexo}`
                await axios.delete(fullUrl)
            }
            return data.id
        } catch (error) {
            console.log(error)
        }
    }
)

export const eliminarFC_01AnexoUnidadProduccionBD =  createAsyncThunk(
    ELIMINAR_FC_01_ANEXOUNIDADPRODUCCION_EXITO_BD,
    async(data) => {
        try {
            if (data.idfc01_solicitudregistro !== undefined) {
                const fullUrl = host + `FC_01/eliminarAnexo/${data.idanexo}`
                await axios.delete(fullUrl)
            }
            return data.id
        } catch (error) {
            console.log(error)
        }
    }
)

export const eliminarFC_01AnexoInstalacionBD = createAsyncThunk(
    ELIMINAR_FC_01_INSTALACION_EXITO_BD,
    async(data) => {
        try {
            if (data.idfc01_solicitudregistro !== undefined) {
                const fullUrl = host + `FC_01/eliminarAnexo/${data.idanexo}`
                await axios.delete(fullUrl)
            }
            return data.id
        } catch (error) {
            console.log(error);
        }
    }
)

export const eliminarFC_01AnexoUnidadAlmacenBD = createAsyncThunk(
    ELIMINAR_FC_01_ANEXOUNIDADALMACEN_EXITO_BD,
    async(data) => {
        try {
            if (data.idfc01_solicitudregistro !== undefined) {
                const fullUrl = host + `FC_01/eliminarAnexo/${data.idanexo}`
                await axios.delete(fullUrl)
            }
            return data.id
        } catch (error) {
            console.log(error);
        }
    }
)
export const eliminarFC_01AnexoPredioBD = createAsyncThunk(
    ELIMINAR_FC_01_ANEXOPREDIO_EXITO_BD,
    async(id) => {
        try {
            const fullUrl = host + `FC_01/eliminarAnexoViveroFC_01/${id}`
            await axios.delete(fullUrl)
            return id
        } catch (error) {
            console.log(error)
        }
    }
)
export const eliminarFC_01AnexoProductorBD = createAsyncThunk(
    ELIMINAR_FC_01_ANEXOPRODUCTOR_EXITO_BD,
    async(id) => {
        try {
            const fullUrl = host + `FC_01/eliminarAnexoProductorFC_01/${id}`
            await axios.delete(fullUrl)
            return id
        } catch (error) {
            console.log(error)
        }
    }
)

export const obtenerSeccionesAlmacen = createAsyncThunk(
    OBTENER_FC_01_SECCIONESUNIDADALMACEN_EXITO,
    async(idTipoAnexo) => {
        try {
            const fullUrl = host + `FC_01/obtenerSeccionesDeAnexo/${idTipoAnexo}`
            const res = await axios.get(fullUrl)
            for (const seccion of  res.data.data) {
                for (let i in seccion.seccion.elementosdeseccion) {
                    seccion.seccion.elementosdeseccion[i]['seleccionado'] = false
                }
            }
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerSeccionesEnvasado = createAsyncThunk(
    OBTENER_FC_01_SECCIONESUNIDADENVASADO_EXITO,
    async(idTipoAnexo) => {
        try {
            const fullUrl = host + `FC_01/obtenerSeccionesDeAnexo/${idTipoAnexo}`
            const res = await axios.get(fullUrl)
            for (const seccion of  res.data.data) {
                for (let i in seccion.seccion.elementosdeseccion) {
                    seccion.seccion.elementosdeseccion[i]['seleccionado'] = false
                }
            }
            
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerContador = createAsyncThunk(
    OBTENER_FC_01_BORRADORES_EXITO,
    async(params) => {
        try {
            const fullUrl = host + `FC_01/obtenerFC_01_Contador/idestatusdesolicitudes=${params.idestatusdesolicitudes}&idlogin=${params.idlogin}`
            const res = await axios.get(fullUrl)
            return res.data.data[0].count
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerContadorDeFechaFolio = createAsyncThunk(
    OBTENER_FC_01_CONTADOR_FECHA_FOLIO_EXITO,
    async(year) => {
        try {
            const fullUrl = host + `FC_01/Contadorfc_01DeFechasFolio/year=${year}`
            const res = await axios.get(fullUrl)
            const contador = 
            res.data.data.resultfc_01[0].count + res.data.data.resultfc_05[0].count + res.data.data.resultfc_06[0].count +
            res.data.data.resultfc_08[0].count + res.data.data.resultfc_09[0].count + res.data.data.resultfc_30[0].count +
            res.data.data.resultfc_31[0].count + res.data.data.resultfc_33[0].count + res.data.data.resultfc_34[0].count +
            res.data.data.resultfc_35[0].count + res.data.data.resultfc_36[0].count + res.data.data.resultfc_40[0].count +
            res.data.data.resultfc_41[0].count
            return contador
        } catch (error) {
            console.log(error)
        }
    }
)


export const generarSolicitudEnPDF = createAsyncThunk(
    GENERAR_SOLICITUD_PDF_EXITO,
    async (data) => {
        try {
            const fullUrl = host + 'FC_01/generarSolicitudEnPdf'
            const result = await axios.post(fullUrl, data)
            return {}
        } catch (error) {
            console.log(error);
        }
    }
)

export const obtenerNumeroDeSolicitudesFC_01 = createAsyncThunk(
    OBTENER_NUMERO_SOLICITUDES_FC_01_EXITO,
    async(idlogin) => {
        try {
            const fullUrl = host + `FC_01/obtenerNumeroDeSolicitudesFC_01/${idlogin}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const actualizarFC_01Fecha = createAsyncThunk(
    AGREGAR_FC_01_FECHA_EXITO,
    async (data) => {
        try {
            const actualizarFC_01 = host + `FC_01/actualizarSolicitudFC_01`

            const res = await axios.put(actualizarFC_01, {data:data})
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const actualizarInstalaciones= createAsyncThunk(
    ACTUALIZAR_INSTALACIONES_EXITO,
    async (data) => {
        try {
            let direccion = data.datosdireccion
            console.log("los direccion ", direccion)
            let responsables = data.responsables
            console.log("los responsables ", responsables)
            const urlActualizarInformacionGeneral = host + 'FC_01/actualizarInformacionGeneral'
            const urlActualizarResponsable = host + 'FC_01/actualizarResponsable'
            const res = await axios.put(urlActualizarInformacionGeneral, {data:direccion})
            for(const i in responsables){
                delete responsables[i].id
                delete responsables[i].estado
                const res = await axios.put(urlActualizarResponsable, {data:responsables[i]})
            }
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const fc01SliceBeneficiario = createSlice({
    name: 'fc01SliceBeneficiario',
    initialState: dataInicial,
    reducers: {
        agregarArchivoFC_01(state, { payload }) {
            state.archivos.push(payload)
        },
        editarFC_01AnexoRepresentantesLegales(state, { payload }) {
            const inputRepresentanteLegal = state.representantesLegales.data.filter(field => field.id === payload.id)
            if(inputRepresentanteLegal.length > 0) {
                inputRepresentanteLegal[0][payload.campo] = payload.valor
                if(payload.campo === 'correoelectronicorepresentante'){
                    inputRepresentanteLegal[0]['estado'] = payload.estado
                }
            }
        },
        editarFC_01AnexoMarcasBeneficiario(state,{payload}){
            const inputMarca = state.marcas.data.filter(field => field.id === payload.id)
            if(inputMarca.length>0){
                
                if(payload.campo === "registrosi"){
                    if(payload.valor === false && inputMarca[0]["registrono"]===false){
                    }else{
                        inputMarca[0][payload.campo] = payload.valor
                        inputMarca[0]["registrono"] = false
                        inputMarca[0]["numeroderegistroimpi"] = ''
                }
                }else{
                    if(payload.campo === "registrono"){
                        if(payload.valor === false && inputMarca[0]["registrosi"]===false){
                        }else{
                            inputMarca[0][payload.campo] = payload.valor 
                            inputMarca[0]["registrosi"] = false 
                            inputMarca[0]["numeroderegistroimpi"] = ''
                        }
                    }else{
                        inputMarca[0][payload.campo] = payload.valor
                    }
                }
                
                
            }
        },
        editarFC_01AnexoMarcasProductoConMezcalBeneficiario(state,{payload}){
            const inputMarca = state.marcasProductosConMezcal.data.filter(field => field.id === payload.id)
            if(inputMarca.length>0){
                if(payload.campo === "registrosi"){
                    if(payload.valor === false && inputMarca[0]["registrono"]===false){
                    }else{
                        inputMarca[0][payload.campo] = payload.valor
                        inputMarca[0]["registrono"] = false
                        inputMarca[0]["numeroderegistroimpi"] = ''
                }
                }else{
                    if(payload.campo === "registrono"){
                        if(payload.valor === false && inputMarca[0]["registrosi"]===false){
                        }else{
                            inputMarca[0][payload.campo] = payload.valor 
                            inputMarca[0]["registrosi"] = false 
                            inputMarca[0]["numeroderegistroimpi"] = ''
                        }
                    }else{
                        inputMarca[0][payload.campo] = payload.valor
                    }
                }
                
                
            }
        },

        actualizarEstadoFC_01AnexoMediosDeContactoBeneficiario(state,{payload}){
            const inputMedio = state.mediosDeContacto.data.filter(field => field.id === payload.id)     
                inputMedio[0]['estado'] = payload.estado          
        },

        
        editarFC_01AnexoMediosDeContactoBeneficiario(state,{payload}){
            const inputMedio = state.mediosDeContacto.data.filter(field => field.id === payload.id)
            if(inputMedio.length>0){
                inputMedio[0][payload.campo] = payload.valor
            }
        },
        editarFC_01AnexoPersonasAutBeneficiario(state,{payload}){
            const inputPersona = state.personasAutorizadas.data.filter(field => field.id === payload.id)
            if(inputPersona.length>0){
                inputPersona[0][payload.campo] = payload.valor
                if(payload.campo === 'correoelectronicopersona'){
                    inputPersona[0]['estado'] = payload.estado
                }
            }
        },
        editarFC_01AnexoUnidadEnvasado(state, {payload}){
            let index = state.anexoUnidadEnvasado.findIndex(anexo => anexo.data.id === payload.id);
            let anexos = state.anexoUnidadEnvasado
            anexos[index] = {data: payload}
            state.anexoUnidadEnvasado = anexos
        },
        editarFC_01AnexoPrediosBeneficiario(state,{payload}){
            const inputPredio = state.predios.data.filter(field => field.id === payload.id)
            if(inputPredio.length>0){
                inputPredio[0][payload.campo] = payload.valor
            }
        },
        editarFC_01AnexoProductorBeneficiario(state,{payload}){
            const inputProductor = state.productor.data.filter(field => field.id === payload.id)
            if(inputProductor.length>0){
                inputProductor[0][payload.campo] = payload.valor
            }
        },
        eliminarFC_01AnexoUnidadEnvasado(state, {payload}){
            state.anexoUnidadEnvasado = state.anexoUnidadEnvasado.filter(anexo => anexo.data.id !== payload)
        },
        agregarFC_01AnexoUnidadEnvasado(state, {payload}){
            state.anexoUnidadEnvasado.push({data: payload})
        },
        editarFC_01AnexoUnidadAlmacen(state, {payload}){
            let index = state.anexoUnidadAlmacen.findIndex(anexo => anexo.data.id === payload.id);
            let anexos = state.anexoUnidadAlmacen
            anexos[index] = {data: payload}
            state.anexoUnidadAlmacen = anexos
        },
        eliminarFC_01AnexoInstalacion(state, {payload}){
            state.instalaciones = state.instalaciones.filter(anexo => anexo.data.id !== payload) 
        },
        eliminarFC_01AnexoUnidadAlmacen(state, {payload}){
            state.anexoUnidadAlmacen = state.anexoUnidadAlmacen.filter(anexo => anexo.data.id !== payload) 
        },
        agregarFC_01AnexoUnidadAlmacen(state, {payload}){
            state.anexoUnidadAlmacen.push({data: payload})
        },
        agregarDataSeccionesAlmacen(state, {payload}){
            state.dataSeccionesAlmacen.push({data: payload})
        },
        editarFC_01AnexoInstalacion(state,{payload}){
            let index = state.instalaciones.findIndex(anexo => anexo.data.id === payload.id);
            let anexos = state.instalaciones
            anexos[index] = {data: payload}
            state.instalaciones = anexos
        },
        editarFC_01AnexoUnidadProduccion(state,{payload}){
            let index = state.anexoUnidadProduccion.findIndex(anexo => anexo.data.id === payload.id);
            let anexos = state.anexoUnidadProduccion
            anexos[index] = {data: payload}
            state.anexoUnidadProduccion = anexos
        },
        eliminarFC_01AnexoUnidadProduccion(state,{payload}) {
            state.anexoUnidadProduccion = state.anexoUnidadProduccion.filter(anexo => anexo.data.id !== payload)
        },
        agregarFC_01AnexoInstalacion(state, {payload}){
            state.instalaciones.push({data: payload})
        },
        agregarFC_01AnexoUnidadProduccion(state, {payload}){
            state.anexoUnidadProduccion.push({data: payload})
        },
        agregarFC_01AnexoMarcasBeneficiario(state, {payload}){
            state.marcas = payload
        },
        agregarFC_01AnexoMarcasProductoConMezcalBeneficiario(state, {payload}){
            state.marcasProductosConMezcal = payload
        },
        agregarFC_01AnexoMarcaBeneficiario(state, {payload}){
            state.marcas.data.push(payload)
        },
        agregarFC_01AnexoMarcaProductosConMezcalBeneficiario(state, {payload}){
            state.marcasProductosConMezcal.data.push(payload)
        },
        agregarFC_01AnexoPersonasAutBeneficiario(state, {payload}){
            state.personasAutorizadas = payload
        },
        agregarFC_01AnexoPersonaAutBeneficiario(state,{payload}){
            state.personasAutorizadas.data.push(payload)
        },
        agregarFC_01AnexoPrediosBeneficiario(state, {payload}){
            state.predios = payload
        },
        agregarFC_01AnexoProductoresBeneficiario(state, {payload}){
            state.productor = payload
        },
        agregarFC_01AnexoPredioBeneficiario(state, {payload}){
            state.predios.data.push(payload)
        },
        agregarFC_01AnexoProductorBeneficiario(state, {payload}){
            state.productor.data.push(payload)
        },
        agregarFC_01AnexosFiles(state, { payload }){
            state.files = payload
        },
        agregarFC_01AnexosFilesApoderadosLeg(state, { payload }){
            state.filesApoderadosLeg = payload
        },
        agregarFC_01AnexosFilesPersonasAut(state, { payload }){
            state.filesPersonasAut = payload
        },
        agregarFC_01AnexosFilesPredios(state, { payload }){
            state.filesPredios = payload
        },
        agregarFC_01AnexosFilesViveros(state, { payload }){
            state.filesViveros = payload
        },
        agregarFC_01AnexosFilesMarcas(state, { payload }){
            state.filesMarcas = payload
        },
        agregarFC_01AnexosFilesMarcaProduct(state, { payload }){
            state.filesMarcasProduct = payload
        },
        agregarFC_01AnexosFilesInstalaciones(state, { payload }){
            state.filesInstalaciones = payload
        },
        agregarFC_01OpcionesFilesPredios(state, { payload }){
            state.opcionesFilesPredios = payload
        },
        agregarFC_01OpcionesFilesViveros(state, { payload }){
            state.opcionesFilesViveros = payload
        },
        agregarFC_01OpcionesFilesInstalacion(state, { payload }){
            state.opcionesFilesInstalaciones = payload
        },
        agregarFC_01AnexoMediosDeContactoBeneficiario(state, {payload}){
            state.mediosDeContacto = payload
        },
        agregarFC_01AnexoMedioDeContactoBeneficiario(state, {payload}){
            state.mediosDeContacto.data.push(payload)
        },
        agregarFC_01AnexoRepresentanteLegalBeneficiario(state, {payload}) {
            state.representantesLegales = payload
        },
        agregarFC_01AnexoRepresentanteLegalBenefi(state, {payload}) {
            state.representantesLegales.data.push(payload)
        },
        setCambiosFC_01SolicitudBorrador(state, {payload}){
            state.data = payload
        },
        setCambiosFC_01SolicitudNueva(state, {payload}) {
            state.fc_01 = payload.valores
        },
        setPrueba(state, {payload}){
            state.prueba = payload
        },
        setModoBorrador(state, {payload}){
            state.modoEdicionBorrador = payload
        },
        setModoCorreccion(state, {payload}){
            state.modoCorreccion = payload
        },
        actualizarFC_01PaginaActiva(state,{payload}) {
            state.paginaActiva = payload
        },
        resetDataFC_01(state, {payload}) {
            return dataInicial
        },  
        agregarFC_01Coccion(state, { payload }) {
            state.cocciones.data.push(payload)
        },
        agregarFC_01NuevoCoccion(state, { payload }) {
            state.cocciones = payload
        },
        editarFC_01Coccion(state, { payload }) {
            const inputCoccion = state.cocciones.data.filter(field => field.id === payload.id)
            if (inputCoccion.length > 0) {
                inputCoccion[0][payload.campo] = payload.valor
            }
        },
        editarEquipoAlmacen(state, { payload }) {
            const input = state.anexoUnidadAlmacen.data.dataSeccion.equipoAlmacen.filter(field => field.id === payload.id)
            if (input.length > 0) {
                input[0][payload.campo] = payload.valor
            }
        },
        editarCoccionProduccion(state, { payload }) {
            const input = state.anexoUnidadProduccion.data.dataSeccion.equipoProduccion.filter(field => field.id === payload.id)
            if (input.length > 0) {
                input[0][payload.campo] = payload.valor
            }
        },
        editarMoliendaProduccion(state, { payload }) {
            const input = state.anexoUnidadProduccion.data.dataSeccion.moliendaProduccion.filter(field => field.id === payload.id)
            if (input.length > 0) {
                input[0][payload.campo] = payload.valor
            }
        },
        editarFermentacionProduccion(state, { payload }) {
            const input = state.anexoUnidadProduccion.data.dataSeccion.fermentacionProduccion.filter(field => field.id === payload.id)
            if (input.length > 0) {
                input[0][payload.campo] = payload.valor
            }
        },
        editarDestilacionProduccion(state, { payload }) {
            const input = state.anexoUnidadProduccion.data.dataSeccion.destilacionProduccion.filter(field => field.id === payload.id)
            if (input.length > 0) {
                input[0][payload.campo] = payload.valor
            }
        },
        editarGranelProduccion(state, { payload }) {
            const input = state.anexoUnidadProduccion.data.dataSeccion.granelProduccion.filter(field => field.id === payload.id)
            if (input.length > 0) {
                input[0][payload.campo] = payload.valor
            }
        },
        agregarFC_01ActividadesEmpresa(state, {payload}){
            state.actividadesEmpresa = payload
        },
        agregarFC_01DomicilioFiscal(state, {payload}){
            state.domicilioFiscal = payload
        },
        actualizarFC_01NumeroDeUnidades(state,{payload}) {
            state.numeroDeUnidades = payload
        },
        actualizarCalleFc_01(state,{payload}) {
            state.fc_01.calle = payload
        },
    },
    extraReducers: {
        [obtenerFC_01Map.fulfilled] : (state, {payload}) => {
            state.fc_01Map = payload.fc_01Map
            state.personasAutorizadasMap = payload.anexosMap.anexoPersonasAutMap
            state.representantesLegalesMap = payload.anexosMap.anexoRepresentanteLegal
            state.predioMap = payload.anexosMap.anexoPredioMap
            state.productorMap = payload.anexosMap.anexoProductorMap
            state.anexoMarcaDeMezcalMap = payload.anexosMap.anexoMarcaDeMezcalMap
            state.anexoMarcaConProductoMap = payload.anexosMap.anexoMarcaConProductoMap

            state.documentacionFC_01Map = payload.anexosMap.documentacionFC_01Map
            state.documentacionRepresentanteLegalMap = payload.anexosMap.documentacionRepresentanteLegalMap
            state.documentacionPersonaAutorizadaMap = payload.anexosMap.documentacionPersonaAutorizadaMap
            state.documentacionPredioMap = payload.anexosMap.documentacionPredioMap
            state.documentacionViveroMap = payload.anexosMap.documentacionViveroMap
            state.documentacionMarcaMap = payload.anexosMap.documentacionMarcaMap
            state.documentacionMarcaProductoMap = payload.anexosMap.documentacionMarcaProductoMap
            state.documentacionInstalacionMap = payload.anexosMap.documentacionInstalacionMap
            state.documentacionResponsableMap = payload.anexosMap.documentacionResponsableMap

            state.observacionesApartados = {
                countObsDatosGenerales: payload.anexosMap.countObsDatosGenerales,
                countObsDomicilioFiscal: payload.anexosMap.countObsDomicilioFiscal,
                countObsPrediosViveros: payload.anexosMap.countObsPrediosViveros,
                countObsMarcas: payload.anexosMap.countObsMarcas,
                countObsInstalaciones: payload.anexosMap.countObsInstalaciones,
                countObservacionesDocumentacion: payload.anexosMap.countObservacionesDocumentacion,
                
            }
            state.validacionInstalacion = payload.anexosMap.validacionInstalacion
        },
        [obtenerFC_01AnexoResponsableUnidadMap.fulfilled] : (state, {payload}) => {
            state.anexoResponsableMap = payload
        },
        [agregarFC_01SolicitudBorrador.fulfilled]: (state, {payload}) => {
        },
        [agregarFC_01Solicitud.fulfilled]: (state , {payload}) => {
        },
        [obtenerFC_01SolicitudDetalle.fulfilled] : (state, {payload}) => {
            state.fc_01 = payload.data
            state.data = payload.data
            state.anexoUnidadAlmacen = payload.anexoUnidadAlmacen
            state.anexoUnidadEnvasado = payload.anexoUnidadEnvasado
            state.anexoUnidadProduccion = payload.anexoUnidadProduccion
            state.marcas = payload.anexoMarcas[0]
            state.personasAutorizadas = payload.anexoPersonasAut[0]
            state.representantesLegales = payload.anexoRepresentantesLegales[0]
            state.mediosDeContacto = payload.anexoMediosDeContacto[0]
            state.predios = payload.anexoPredio[0]
            state.productor = payload.anexoProductor[0]
            state.numeroDeUnidades = payload.maxNumeroDeInstlacion
            state.instalaciones = payload.anexoInstalaciones
            state.marcasProductosConMezcal = payload.anexomarcasProductoConMezcal[0]
        },
        [obtenerFC_01SolicitudDetalleConFiles.fulfilled] : (state, {payload}) => {
             state.fc_01 = payload.data
             state.data = payload.data
             state.anexoUnidadAlmacen = payload.anexoUnidadAlmacen
             state.anexoUnidadEnvasado = payload.anexoUnidadEnvasado
             state.anexoUnidadProduccion = payload.anexoUnidadProduccion
             state.marcas = payload.anexoMarcas[0]
             state.personasAutorizadas = payload.anexoPersonasAut[0]
             state.representantesLegales = payload.anexoRepresentantesLegales[0]
             state.mediosDeContacto = payload.anexoMediosDeContacto[0]
             state.predios = payload.anexoPredio[0]
             state.productor = payload.anexoProductor[0]
             state.numeroDeUnidades = payload.maxNumeroDeInstlacion
             state.instalaciones = payload.anexoInstalaciones
             state.marcasProductosConMezcal = payload.anexomarcasProductoConMezcal[0]

             //FILES
             state.files = {data: payload.documentacionFC_01}
             state.filesMarcas = {data: payload.documentacionMarca}
             state.filesApoderadosLeg = {data: payload.documentacionRepresentantesLeg}
             state.filesPersonasAut = {data: payload.documentacionPersonasAut}
             state.filesPredios = {data: payload.documentacionPredios}
             state.filesViveros = {data: payload.documentacionViveros}
             state.filesMarcasProduct = {data: payload.documentacionMarcaProducto}
             state.filesInstalaciones = {data: payload.documentacionInstalaciones}    
             state.filesResponsables = {data: payload.documentacionResponsables}  
             //OPCIONES FILE
             state.opcionesFilesViveros = {data: payload.opcionesFileVivero}
             state.opcionesFilesPredios = {data: payload.opcionesFilePredio}
             state.opcionesFilesInstalaciones = {data: payload.opcionesFileInstalacion}
         },
        [eliminarFC_01Anexos.fulfilled] : (state, {payload}) => {
            state.anexoUnidadAlmacen = payload
            state.anexoUnidadEnvasado = payload
            state.anexoUnidadProduccion = payload
            state.personasAutorizadas = payload
            state.marcas = payload
            state.anexoRepresentantesLegales = payload
            state.mediosDeContacto = payload
            state.predios = payload
        },
        [enviarCorreccionesFC_01.fulfilled]: (state, {payload}) => {
        },
        [guardarCambiosFC_01Borrador.fulfilled] : (state, {payload}) => {
        },
        [actualizarFC_01Estatus.fulfilled] : (state, {payload}) => {
        },
        [eliminarFC_01AnexoMarcasBD.fulfilled] : (state, {payload}) => {
            const filtro = {data: state.marcas.data.filter(anexo => anexo.idfc01_anexomarcas !== payload)}
            state.marcas = filtro        
        },
        [eliminarDataElementoBD.fulfilled] : (state, {payload}) => {
            // const filtro = {data: state.marcas.data.filter(anexo => anexo.idfc01_anexomarcas !== payload)}
            // state.marcas = filtro        
        },
        [eliminarResponsableBD.fulfilled] : (state, {payload}) => {
        },
        [eliminarFC_01AnexoPersonasAutBD.fulfilled]: (state, {payload}) => {
            const filtro = {data: state.personasAutorizadas.data.filter(anexo =>anexo.idfc01_anexopersonaatorizadatramites !== payload)}
            state.personasAutorizadas = filtro  
        },
        [eliminarFC_01AnexoRepresentanteLegal.fulfilled]: (state, { payload }) => {
            const filtro = { data: state.representantesLegales.data.filter(anexo => anexo.idfc01_anexorepresentantelegal !== payload )}
            state.representantesLegales = filtro
        },
        [eliminarFC_01AnexoMedioDeContactoBD.fulfilled]: (state, {payload}) => {
            const filtro = {data: state.mediosDeContacto.data.filter(anexo =>anexo.idfc01_anexomediosdecontacto !== payload)}
            state.mediosDeContacto = filtro  
        },
        [eliminarFC_01SolicitudBD.fulfilled] : (state, {payload}) => {
        },
        [eliminarFC_01AnexoUnidadEnvasadoBD.fulfilled] : (state, {payload}) => {
            state.anexoUnidadEnvasado = state.anexoUnidadEnvasado.filter(anexo => anexo.data.id !== payload)
        },
        [eliminarFC_01AnexoUnidadProduccionBD.fulfilled] : (state, {payload}) => {
            state.anexoUnidadProduccion = state.anexoUnidadProduccion.filter(anexo => anexo.data.id !== payload)
        },
        [eliminarFC_01AnexoUnidadAlmacenBD.fulfilled] : (state, {payload}) => {
            state.anexoUnidadAlmacen = state.anexoUnidadAlmacen.filter(anexo => anexo.data.id !== payload) 
        },
        [eliminarFC_01AnexoInstalacionBD.fulfilled] : (state, {payload}) => {
            state.instalaciones = state.instalaciones.filter(anexo => anexo.data.id !== payload) 
        },
        // [obtenerFC_01AnexoUnidadAlmacenMap.fulfilled]: (state, {payload}) => {
        //     state.anexoUnidadAlmacenMap = payload
        // },
        // [obtenerFC_01AnexoUnidadEnvasadoMap.fulfilled]: (state, {payload}) => {
        //     state.anexoUnidadEnvasadoMap = payload
        // },
        [obtenerFC_01AnexoUnidadMap.fulfilled]: (state, {payload}) => {
            state.anexoUnidadMap = payload
        },
        [eliminarFC_01AnexoPredioBD.fulfilled]: (state, {payload}) => {
            const filtro = {data: state.predios.data.filter(anexo =>anexo.idfc01_anexopredios !== payload)}
            state.predios = filtro 
        },
        [obtenerSeccionesAlmacen.fulfilled]: (state, {payload}) => {
            if(payload){
                state.seccionesAlmacen = payload
            }else{
                state.seccionesAlmacen = []
            }
        },
        [obtenerSeccionesDeProduccion.fulfilled]: (state, {payload}) => {
            if(payload){
                state.seccionesProduccion = payload
            }else{
                state.seccionesProduccion = []
            }
        },
        [obtenerSeccionesEnvasado.fulfilled]: (state, {payload}) => {
            if(payload){
                state.seccionesEnvasado = payload
            }else{
                state.seccionesEnvasado = []
            }
        },
        [eliminarFC_01AnexoProductorBD.fulfilled]: (state, {payload}) => {
            const filtro = {data: state.productor.data.filter(anexo =>anexo.idfc01_anexoproductor !== payload)}
            state.productor = filtro 
        },
        [obtenerContador.fulfilled]: (state, {payload}) => {
            state.borrador = payload
        },
        [obtenerContadorDeFechaFolio.fulfilled]: (state, {payload}) => {
            state.contadorDeFechaFolio = payload
        },
        [generarSolicitudEnPDF.fulfilled]: (state, {payload}) => {
        },
        [obtenerNumeroDeSolicitudesFC_01.fulfilled]: (state, {payload}) => {
        },
        [agregarFileFC_01.fulfilled]: (state, {payload}) => {
        },
        [actualizarFileFC_01.fulfilled]: (state, {payload}) => {
        },
        [eliminarFileFC_01.fulfilled]: (state, {payload}) => {
        },
    },
})


export const {
    agregarFC_01AnexosFiles,
    agregarArchivoFC_01,
    setPrueba, 
    setModoBorrador, 
    setModoCorreccion, 
    actualizarFC_01PaginaActiva,
    setCambiosFC_01SolicitudNueva, 
    setCambiosFC_01SolicitudBorrador, 
    resetDataFC_01,
    agregarFC_01AnexoMarcaBeneficiario,
    agregarFC_01AnexoMarcasBeneficiario,
    editarFC_01AnexoMarcasBeneficiario,
    editarFC_01AnexoPersonasAutBeneficiario,
    agregarFC_01AnexoPersonaAutBeneficiario,
    agregarFC_01AnexoPersonasAutBeneficiario,
    agregarFC_01AnexoUnidadProduccion,
    eliminarFC_01AnexoUnidadProduccion,
    editarFC_01AnexoUnidadProduccion,
    agregarFC_01AnexoUnidadAlmacen,
    eliminarFC_01AnexoUnidadAlmacen,
    editarFC_01AnexoUnidadAlmacen,
    agregarFC_01AnexoUnidadEnvasado,
    editarFC_01AnexoUnidadEnvasado,
    eliminarFC_01AnexoUnidadEnvasado,
    agregarFC_01AnexoMediosDeContactoBeneficiario,
    editarFC_01AnexoMediosDeContactoBeneficiario,
    agregarFC_01AnexoRepresentanteLegalBeneficiario,
    agregarFC_01AnexoRepresentanteLegalBenefi,
    editarFC_01AnexoRepresentantesLegales,
    agregarFC_01AnexoPrediosBeneficiario,
    editarFC_01AnexoPrediosBeneficiario,
    agregarFC_01AnexoMedioDeContactoBeneficiario,
    agregarFC_01AnexoPredioBeneficiario,
    agregarFC_01Coccion,
    agregarFC_01NuevoCoccion,
    editarFC_01Coccion,
    agregarDataSeccionesAlmacen,
    editarEquipoAlmacen,
    editarCoccionProduccion,editarMoliendaProduccion,
    editarFermentacionProduccion,
    editarGranelProduccion,editarDestilacionProduccion,
    agregarFC_01ActividadesEmpresa,
    agregarFC_01AnexoProductorBeneficiario,
    agregarFC_01AnexoProductoresBeneficiario,
    editarFC_01AnexoProductorBeneficiario,
    agregarFC_01DomicilioFiscal,
    actualizarFC_01NumeroDeUnidades,
    actualizarEstadoFC_01AnexoMediosDeContactoBeneficiario,
    eliminarFC_01AnexoInstalacion,
    agregarFC_01AnexoInstalacion,
    editarFC_01AnexoInstalacion,
    agregarFC_01AnexoMarcaProductosConMezcalBeneficiario,
    agregarFC_01AnexoMarcasProductoConMezcalBeneficiario,
    editarFC_01AnexoMarcasProductoConMezcalBeneficiario,
    agregarFC_01AnexosFilesApoderadosLeg,
    agregarFC_01AnexosFilesPersonasAut,
    agregarFC_01AnexosFilesPredios,
    agregarFC_01AnexosFilesViveros,
    agregarFC_01AnexosFilesMarcas,
    agregarFC_01AnexosFilesMarcaProduct,
    agregarFC_01AnexosFilesInstalaciones,
    agregarFC_01OpcionesFilesPredios,
    agregarFC_01OpcionesFilesViveros,
    agregarFC_01OpcionesFilesInstalacion,
    actualizarCalleFc_01
    } = fc01SliceBeneficiario.actions
export const FC01ReducerBeneficiario = fc01SliceBeneficiario.reducer

//reducer
// export default function FC_01Reducer(state = dataInicial, action) {
//     switch (action.type) {
//         /******Obtener */
//         case OBTENERTODAS_FC_01_EXITO:
//             return { ...state, data: action.payload }
//         case OBTENER_FC_01_DETALLE_EXITO: {
//             return { ...state, data: action.payload }
//         }
//         case OBTENER_FC_01_MAP_EXITO:
//             Object.assign(state.fc_01Map, action.payload);
//             return {...state, fc_01Map: action.payload}
//         //******Agregar***** */
//         case AGREGAR_FC_01_ANEXOMARCAS_EXITO:
//             {
//                 Object.assign(state.marcas, action.payload);
//                 return { ...state, marcas: action.payload }
//             }
//         case AGREGAR_FC_01_ANEXOPERSONASAUT_EXITO:
//             {
//                 Object.assign(state.personasAutorizadas, action.payload);
//                 return { ...state, personasAutorizadas: action.payload }
//             }
//         case AGREGAR_FC_01_EXITO:
//             return dataInicial
//         case AGREGAR_FC_01_BORRADOR_EXITO:
//             return { ...state }
//         case AGREGAR_FC_01_ANEXOUNIDADALMACEN_EXITO:
//             return { ...state, anexoUnidadAlmacen: [...state.anexoUnidadAlmacen, action.payload] }
//         case AGREGAR_FC_01_ANEXOUNIDADENVASADO_EXITO:
//             return { ...state, anexoUnidadEnvasado: [...state.anexoUnidadEnvasado, action.payload] }
//         case AGREGAR_FC_01_ANEXOUNIDADPRODUCCION_EXITO:
//             return { ...state, anexoUnidadProduccion: [...state.anexoUnidadProduccion, action.payload] }
//         //****Eliminar***** */
//         // case ELIMINAR_FC_01_ANEXOMARCAS_EXITO_BD: {
//         //     const filtro = {data: state.marcas.data.filter(anexo => 
//         //         anexo.idfc01_anexomarcas !== action.payload)}
//         //     state.marcas = filtro
//         //     const newAnexo = Object.assign(state.marcas, 
//         //         filtro);
//         //     return {
//         //         ...state,
//         //         marcas: newAnexo
//         //     }
//         // }
//         // case ELIMINAR_FC_01_ANEXOPERSONASAUT_EXITO_BD: {
//         //     const filtro = {data: state.personasAutorizadas.data.filter(anexo => 
//         //         anexo.idfc01_anexopersonaatorizadatramites !== action.payload)}
//         //     state.personasAutorizadas = filtro
//         //     const newAnexo = Object.assign(state.personasAutorizadas, 
//         //         filtro);
//         //     return {
//         //         ...state,
//         //         personasAutorizadas: newAnexo
//         //     }
//         // }

//         case ELIMINAR_FC_01_ANEXOS: {
//             return {
//                 ...state,
//                 anexoUnidadAlmacen: action.payload,
//                 anexoUnidadEnvasado: action.payload,
//                 anexoUnidadProduccion: action.payload,
//                 personasAutorizadas: action.payload,
//                 marcas: action.payload
//             }
//         }
//         case ELIMINAR_FC_01_SOLICITUD_EXITO_BD:
//             return { ...state }
//         case ELIMINAR_FC_01_ANEXOUNIDADALMACEN_EXITO:
//             return { ...state, anexoUnidadAlmacen: state.anexoUnidadAlmacen.filter(anexo => anexo.data.id !== action.payload) }
//         case ELIMINAR_FC_01_ANEXOUNIDADALMACEN_EXITO_BD:
//             return { ...state, anexoUnidadAlmacen: state.anexoUnidadAlmacen.filter(anexo => anexo.data.id !== action.payload) }

//         case ELIMINAR_FC_01_ANEXOUNIDADENVASADO_EXITO:
//             return { ...state, anexoUnidadEnvasado: state.anexoUnidadEnvasado.filter(anexo => anexo.data.id !== action.payload) }
//         case ELIMINAR_FC_01_ANEXOUNIDADENVASADO_EXITO_BD:
//             return { ...state, anexoUnidadEnvasado: state.anexoUnidadEnvasado.filter(anexo => anexo.data.id !== action.payload) }

//         case ELIMINAR_FC_01_ANEXOUNIDADPRODUCCION_EXITO:
//             return { ...state, anexoUnidadProduccion: state.anexoUnidadProduccion.filter(anexo => anexo.data.id !== action.payload) }
//         case ELIMINAR_FC_01_ANEXOUNIDADPRODUCCION_EXITO_BD:
//             return { ...state, anexoUnidadProduccion: state.anexoUnidadProduccion.filter(anexo => anexo.data.id !== action.payload) }
        
//             case ELIMINAR_FC_01_ANEXO_PRODUCCION_MAP:
//             return { ...state, anexoUnidadProduccionMap: state.anexoUnidadProduccionMap.filter(anexo => anexo.data.id !== action.payload) }
//         case ELIMINAR_FC_01_ANEXO_ENVASADO_MAP:
//             return { ...state, anexoUnidadEnvasadoMap: state.anexoUnidadEnvasadoMap.filter(anexo => anexo.data.id !== action.payload) }
//         case ELIMINAR_FC_01_ANEXO_ALMACEN_MAP:
//             return { ...state, anexoUnidadAlmacenMap: state.anexoUnidadAlmacenMap.filter(anexo => anexo.data.id !== action.payload) }

//         /****Editar */
//         case GUARDAR_CAMBIOS_FC_01_EXITO:
//             {
//                 Object.assign(state.fc_01, action.payload);
//                 return { ...state, fc_01: action.payload }
//             }
//         case GUARDAR_CAMBIOS_FC_01_BORRADOR_EXITO:
//             {
//                 Object.assign(state.data, action.payload);
//                 return { ...state, data: action.payload }
//             }
//         case ACTUALIZAR_MODO_EDICION_FC_01_EXITO:
//             {
//                 Object.assign(state.modoEdicionBorrador, action.payload);
//                 Object.assign(state.modoEdicionBorrador, { modoEdicionBorrador: action.payload })

//                 return { ...state, modoEdicionBorrador: action.payload }
//             }
//         case ACTUALIZAR_FC_01_MODOCORRECCION_EXITO: {
//             Object.assign(state.modoCorreccion, action.payload);
//             return {...state, modoCorreccion : action.payload}
//         }
//         case ACTUALIZAR_FC_01_PAGINA:
//             return { ...state, paginaActiva: action.payload }
//         case GUARDAR_CAMBIOS_FC_01MAP_EXITO:
//             {
//                 Object.assign(state.fc_01Map, action.payload);
//                 return { ...state, fc_01Map: action.payload }
//             }
//         case EDITAR_FC_01_ANEXOUNIDADALMACEN_EXITO: {
//             let index = state.anexoUnidadAlmacen.findIndex(anexo => anexo.data.id === action.payload.data.id);
//             let anexos = [...state.anexoUnidadAlmacen];
//             anexos[index] = action.payload
//             return { ...state, anexoUnidadAlmacen: anexos }
//         }
//         case EDITAR_FC_01_ANEXOUNIDADPRODUCCION_EXITO: {
//             let index = state.anexoUnidadProduccion.findIndex(anexo => anexo.data.id === action.payload.data.id);
//             let anexos = [...state.anexoUnidadProduccion];
//             anexos[index] = action.payload
//             return { ...state, anexoUnidadProduccion: anexos }
//         }

//         case EDITAR_FC_01_ANEXOUNIDADENVASADO_EXITO: {
//             let index = state.anexoUnidadEnvasado.findIndex(anexo => anexo.data.id === action.payload.data.id);
//             let anexos = [...state.anexoUnidadEnvasado];
//             anexos[index] = action.payload
//             return { ...state, anexoUnidadEnvasado: anexos }
//         }
//         case RESET_DATA_EXITO:
//             {
//                 let newDataObject = Object.assign(dataInicial, {
//                     data: {},
//                     fc_01: {},
//                     anexoUnidadAlmacen: [],
//                     anexoUnidadProduccion: [],
//                     anexoUnidadEnvasado: [],
//                     anexoUnidadAlmacenMap: [],
//                     anexoUnidadProduccionMap: [],
//                     anexoUnidadEnvasadoMap: [],
//                     marcas: [],
//                     personasAutorizadas: [],
//                     paginaActiva: 1,
//                     modoEdicionBorrador: false,
//                     loading: false,
//                     modoCorreccion: false,
//                     fc_01Map: {}
//                 })
//                 return newDataObject
//             }
//         default:
//             return state
//     }
// }


//acciones
